// tslint:disable
/**
 * iLOQ Public API
 * Public API for iLOQ 5 Series and S50 Locking system.      # Introduction  This is OpenApi documentation for iLOQ Public API.     Service is REST (Representational state transfer).   Protocol used to transport the data is HTTP and JSON is used for data transfer.    # Public API  ## API Documentation  This OpenApi 3.0 documentation is for Public API version 2 for 5 Series locking systems. Other locking systems should use version 1.    For other versions use this endpoint documentation: https://s10.iloq.com/iloqwsapi/help      OpenApi Json document can be used to generate client library in multiple programming languages (C#, java, javascript, etc.). For more information about swagger, visit https://swagger.io/    ## Usage    To use the API, you first need to make sure your locking system is API enabled. If it isn\'t enabled, an error will occur during login. For further assistance, please contact iLOQ. Contact information can be found at https://www.iloq.com/en/sales/iloq-sales-support/    Before starting, it is recommended to get familiar with the general idea and principles behind iLOQ\'s locking system. You can contact iLOQ to book a training course about the locking system and iLOQ Manager software. This training takes from half a day to a day. Here is also some reading about the locking system:    * S10: https://www.iloq.com/manual/en/s10/  * 5 Series: https://www.iloq.com/manual/en/5-series/    The API is a RESTful service. Endpoints can be called with simple HTTP calls and HTTP protocols are mapped to CRUD operations:    * GET will retrieve data  * PUT updates data  * POST inserts new data (sometimes also used to just retrieve data if complex parameter is required)  * DELETE deletes data    # Getting started  ### General process  Using iLOQ Public API is a six step process.    | Steps                  |                                                |  | ---------------------- |------------------------------------------------|  | 1. Resolve url         | Resolves which server url to use               |  | 2. Create session      | Creates session                                |  | 3. Get locking systems | Returns locking systems user has rights to use |  | 4. Set locking system  | Logging to locking system                      |  | 5. Call endpoints      | Use endpoints to manage locking system         |  | 6. Kill session        | Terminates session after it\'s no longer needed |    ### 1. Resolve url  First step is to get the correct url to use for the rest of the API calls.    Use your iLOQ Manager server url to call **[POST api/v2/Url/GetUrl](#operation/Url_GetUrl)** endpoint with customer code.  This endpoint returns you rest of url.    Calling this endpoint and resolving the url makes sure your application always uses the correct url to access the API.    Usually your iLOQ Manager server url is:   * https://s10.iloq.com/iloqws   * https://s10.iloq.de/iloqws    ### 2. Create session    Second step is to create session.   This has to done before any other calls to the API. )  This is done by calling **[POST api/v2/CreateSession](#operation/Authentication_CreateSession)** endpoint with credentials.    | Credentials   | Description                        |  | ------------- |----------------------------------- |  | UserName      | User name                          |  | Password      | Password                           |  | CustomerCode  | Customer code                      |  | ApiKey        | Leave empty for now                |  | ApiSecret     | Leave empty for now                |    Call returns response token with SessionId and result which tells if the session creation was successful. This token has to be used in all API calls in Http header called \"SessionId\".  ### 3. Get locking systems  After retrieving session id successfully, you need to set the locking group user uses. Persons, keys, locks and other resources are always linked to a locking system. Before they can be accessed, user must be authenticated to a locking system.   First you need to get all the locking systems user has rights to.  Call **[GET api/v2/LockGroups](#operation/LockGroups_GetAllLockGroups)** endpoint to get all locking systems that user has rights.  Resultset contains one or more locking systems. If only one locking system is returned, that can be used directly. to log to locking system. Otherwise show locking systems to end user and let user to choose locking system.  ### 4. Set locking system  To Authenticate to selected locking system   Call **[POST api/v2/SetLockgroup](#operation/Authentication_SetLockgroup)** with the chosen locking system.   SetLockgroup returns user\'s permission rights. You can use this bit mask value to enable/disable certain actions in your software. For example, if your application is used to book times using a calendar and user doesn\'t have permission to edit calendars (CanEditCalendars (2251799813685248)), you can disable calendar edit controls.    Now user can call rest of the endpoints.  ### 5. Call endpoints  Call endpoints to manage locking system.  ### 6. Kill session  Lastly when you have finished using Public API endpoints, terminate session with **[GET api/v2/KillSession](#operation/Authentication_KillSession)**.  # Samples  ## Common use cases  These samples describe what endpoints and in which order to call them.  These use cases do not provide parameters or responses.   * <a href=\"iLOQPublicApiDoc/use_cases/iLOQ_BlacklistingKeys.html\" target=\"_blank\">Blocklisting keys</a>  * <a href=\"iLOQPublicApiDoc/use_cases/iLOQ_CalendarSecurityAccessGroup.html\" target=\"_blank\">Code access groups to calendar controls</a>  * <a href=\"iLOQPublicApiDoc/use_cases/iLOQ_SessionAndLogging.html\" target=\"_blank\">Creating session and logging to locking system</a>  * <a href=\"iLOQPublicApiDoc/use_cases/iLOQ_Calendars.html\" target=\"_blank\">Managing calendars and time controls</a>  * <a href=\"iLOQPublicApiDoc/use_cases/iLOQ_ManagingCalendarControlledDoors.html\" target=\"_blank\">Manage calendar controlled doors</a>  * <a href=\"iLOQPublicApiDoc/use_cases/iLOQ_ManagingCalendarControlledDoorsSecurityCode.html\" target=\"_blank\">Manage calendar controlled doors with code access groups</a>  * <a href=\"iLOQPublicApiDoc/use_cases/iLOQ_ManagingCodeAccesGroups.html\" target=\"_blank\">Manage code access groups</a>  * <a href=\"iLOQPublicApiDoc/use_cases/iLOQ_ManangingKeys.html\" target=\"_blank\">Managing keys</a>  * <a href=\"iLOQPublicApiDoc/use_cases/iLOQ_ManageKeysSecurityAccessesRemotely.html\" target=\"_blank\">Manage key\'s security accesses remotely</a>  * <a href=\"iLOQPublicApiDoc/use_cases/iLOQ_ManageLocksSecurityAccessesRemotely.html\" target=\"_blank\">Manage lock\'s security accesses remotely</a>  * <a href=\"iLOQPublicApiDoc/use_cases/iLOQ_ManagingPersons.html\" target=\"_blank\">Manage persons</a>  * <a href=\"iLOQPublicApiDoc/use_cases/iLOQ_OrderingPhoneKeys.html\" target=\"_blank\">Managing phone keys</a>  * <a href=\"iLOQPublicApiDoc/use_cases/iLOQ_ManagingSecurityAccesses.html\" target=\"_blank\">Manage security accesses</a>  * <a href=\"iLOQPublicApiDoc/use_cases/iLOQ_ManagingTimeLimits.html\" target=\"_blank\">Manage time profiles</a>  ## UWP application  Sample project Is an UWP application written In C#.   Project can be downloaded from <a href=\"iLOQPublicApiDoc/use_cases/PublicApiUseCases.zip\">here</a>.  It shows you how to login to a locking system and it also covers these common use cases:    * Transferring person data from your system to iLOQ.  * Making calendar reservations for common area, like laundry room or sauna.  * Adding and configuring S5 keys for tenants.  * Managing iLOQ S50 phone keys.  * Listening to log events in real time using SignalR.    # Contact  For API support, contact api.support@iloq.com.    For non-API-related issues (like contract issues), contact other supports which can be found at https://www.iloq.com/en/sales/iloq-sales-support/  # Calendar reservations  Below is a chart that illustrates relations between calendars and network module components.   ![Calendar chart](iLOQPublicApiDoc/images/iLOQ_API_Chart.png)      # SignalR  <h3>Usage</h3>  SignalR service is developed using .NET Core. For more information and samples about .NET Core SignalR in general, please refer to Microsoft’s documentation: https://docs.microsoft.com/en-us/aspnet/core/signalr/introduction    Using this service, you can receive locks’ and keys’ logging data in real time from devices which support it. This kind of devices are, for example, S50 Phone keys and S10/S5 locks which are connected to a network module.    To start listening to logging events, you must call Register endpoint and provide authorization information as well as the locks/keys you are interested in. Parameter for register endpoint requires an access token, which can be obtained using the iLOQ Public API’s [api/v2/LockGroups/GenerateAccessToken](#operation/LockGroups_GenerateAccessToken) endpoint. After obtaining the access token, you must call Register within one minute or the access token expires and a new one must be generated.    <details>  <summary>Click here to expand</summary>    <h3>Endpoints</h3>  Here is a list of API endpoints client can call:  <div style=\"background:#ffffff; overflow:auto;width:auto;border:solid #0A485F;border-width:.1em .1em .1em .4em;padding:.2em .6em;\">  <pre style=\"background-color: #ffffff;border:0; margin:0; line-height: 125%; color:#000000\">  <span style=\"color:#008000;border:0\">/// &lt;summary&gt;</span>  <span style=\"color:#008000;border:0\">/// Ping, answered by Pong.</span>  <span style=\"color:#008000\">/// &lt;/summary&gt;</span>  <span style=\"color:#008000\">/// &lt;param name=&quot;text&quot;&gt;Text to send and receive in pong.&lt;/param&gt;</span>  <span style=\"color:#008000\">/// &lt;returns&gt;&lt;/returns&gt;</span>  Ping(<span style=\"color: #2b91af\">string</span> text);  <p>  <span style=\"color:#008000\">/// &lt;summary&gt;</span>  <span style=\"color:#008000\">/// Ping, answered by Pong.</span>  <span style=\"color:#008000\">/// &lt;/summary&gt;</span>  <span style=\"color:#008000\">/// &lt;param name=&quot;param&quot;&gt;Parameter containing registration information&lt;/param&gt;</span>  <span style=\"color:#008000\">/// &lt;returns&gt;&lt;/returns&gt;</span>  Register(RegisterParam param);  </pre>  </div>  After registration is completed successfully, client starts receiving KeyLogReceived/LockLogReceived callbacks if client has registered itself to listen for these changes.    <h3>Callbacks</h3>  Here is a list of callbacks client can receive:  <div style=\"background: #ffffff; overflow:auto;width:auto;border:solid #0A485F;border-width:.1em .1em .1em .4em;padding:.2em .6em;\">  <pre style=\"background-color: #ffffff;border:0; margin:0; line-height: 125%; color:#000000\">  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Called when key log is received</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #008000\">/// &lt;param name=&quot;deviceLog&quot;&gt;Log data containing information about the passage&lt;/param&gt;</span>  <span style=\"color: #008000\">/// &lt;returns&gt;&lt;/returns&gt;</span>  KeyLogReceived(DeviceLogData deviceLog);  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Called when lock log is received</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #008000\">/// &lt;param name=&quot;deviceLog&quot;&gt;Log data containing information about the passage&lt;/param&gt;</span>  <span style=\"color: #008000\">/// &lt;returns&gt;&lt;/returns&gt;</span>  LockLogReceived(DeviceLogData deviceLog);  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Response for Ping</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #008000\">/// &lt;param name=&quot;msg&quot;&gt;Message&lt;/param&gt;</span>  <span style=\"color: #008000\">/// &lt;returns&gt;&lt;/returns&gt;</span>  Pong(<span style=\"color: #2b91af\">string</span> msg);  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Callback for Register method.</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #008000\">/// &lt;param name=&quot;isSuccess&quot;&gt;True/False indicating success of register call.&lt;/param&gt;</span>  <span style=\"color: #008000\">/// &lt;param name=&quot;msg&quot;&gt;Error message or &#39;Registration successful&#39; depending on isSuccess value.&lt;/param&gt;</span>  <span style=\"color: #008000\">/// &lt;returns&gt;&lt;/returns&gt;</span>  Registered(<span style=\"color: #2b91af\">bool</span> isSuccess, <span style=\"color: #2b91af\">string</span> msg);  </pre>  </div>    <h3>Object schemes</h3>  <h4>RegisterParam</h4>  C# code  <div style=\"background: #ffffff; overflow:auto;width:auto;border:solid #0A485F;border-width:.1em .1em .1em .4em;padding:.2em .6em;\">  <pre style=\"background-color: #ffffff;border:0; margin:0; line-height: 125%; color:#000000\">  <span style=\"color: #0000ff\">public</span> <span style=\"color: #0000ff\">class</span> <span style=\"color: #2b91af\">RegisterParam</span>  {  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Access token</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  [Required]  <span style=\"color: #0000ff\">public</span> Guid AccessToken { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// ServiceCode</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  [Required(AllowEmptyStrings = false)]  <span style=\"color: #0000ff\">public</span> <span style=\"color: #2b91af\">string</span> CustomerCode { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Registration information when listening to key logs.</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #0000ff\">public</span> KeyLogEventRegisterInfo KeyLogEventRegisterInfo { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// LockGroup ID</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  [Required]  <span style=\"color: #0000ff\">public</span> Guid LockGroupID { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Registration information when listening to lock logs.</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #0000ff\">public</span> LockLogEventRegisterInfo LockLogEventRegisterInfo { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  }  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Registration information when listening to key logs.</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #0000ff\">public</span> <span style=\"color: #0000ff\">class</span> <span style=\"color: #2b91af\">KeyLogEventRegisterInfo</span>  {  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// FNKeyIds to listen for.</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #0000ff\">public</span> List&lt;Guid&gt; FNKeyIds { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Is client interested in listening to key log events</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #0000ff\">public</span> <span style=\"color: #2b91af\">bool</span> IsInterested { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }   }  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Registration information when listening to lock logs.</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #0000ff\">public</span> <span style=\"color: #0000ff\">class</span> <span style=\"color: #2b91af\">LockLogEventRegisterInfo</span>  {  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// FLockIds to listen for.</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #0000ff\">public</span> List&lt;Guid&gt; FLockIds { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Is client interested in listening to lock log events</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #0000ff\">public</span> <span style=\"color: #2b91af\">bool</span> IsInterested { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }   }  </pre>  </div>    Json schema  <div id=\"RegisterParamJson\" class=\"collapse\" style=\"background: #ffffff; overflow:auto;width:auto;border:solid #0A485F;border-width:.1em .1em .1em .4em;padding:.2em .6em;\">  <pre style=\"background-color: #ffffff;border:0; margin:0; line-height: 125%; color:#000000\">  {      <span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;object&quot;</span>,      <span style=\"font-weight: bold\">&quot;properties&quot;</span>:       {          <span style=\"font-weight: bold\">&quot;AccessToken&quot;</span>: {<span style=\"font-weight: bold\">&quot;required&quot;</span>: <span style=\"font-weight: bold\">true</span>, <span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;string&quot;</span>},          <span style=\"font-weight: bold\">&quot;CustomerCode&quot;</span>: {<span style=\"font-weight: bold\">&quot;required&quot;</span>: <span style=\"font-weight: bold\">true</span>, <span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;string&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>]},          <span style=\"font-weight: bold\">&quot;KeyLogEventRegisterInfo&quot;</span>: {          <span style=\"font-weight: bold\">&quot;required&quot;</span>: <span style=\"font-weight: bold\">true</span>,          <span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;object&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>],          <span style=\"font-weight: bold\">&quot;properties&quot;</span>: {              <span style=\"font-weight: bold\">&quot;FNKeyIds&quot;</span>: {              <span style=\"font-weight: bold\">&quot;required&quot;</span>: <span style=\"font-weight: bold\">true</span>,              <span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;array&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>],              <span style=\"font-weight: bold\">&quot;items&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;string&quot;</span>}              },              <span style=\"font-weight: bold\">&quot;IsInterested&quot;</span>: {<span style=\"font-weight: bold\">&quot;required&quot;</span>: <span style=\"font-weight: bold\">true</span>, <span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;boolean&quot;</span>}          }          },          <span style=\"font-weight: bold\">&quot;LockGroupID&quot;</span>: {<span style=\"font-weight: bold\">&quot;required&quot;</span>: <span style=\"font-weight: bold\">true</span>, <span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;string&quot;</span>},          <span style=\"font-weight: bold\">&quot;LockLogEventRegisterInfo&quot;</span>: {          <span style=\"font-weight: bold\">&quot;required&quot;</span>: <span style=\"font-weight: bold\">true</span>,          <span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;object&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>],          <span style=\"font-weight: bold\">&quot;properties&quot;</span>: {              <span style=\"font-weight: bold\">&quot;FLockIds&quot;</span>: {              <span style=\"font-weight: bold\">&quot;required&quot;</span>: <span style=\"font-weight: bold\">true</span>,              <span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;array&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>],              <span style=\"font-weight: bold\">&quot;items&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;string&quot;</span>}              },              <span style=\"font-weight: bold\">&quot;IsInterested&quot;</span>: {<span style=\"font-weight: bold\">&quot;required&quot;</span>: <span style=\"font-weight: bold\">true</span>, <span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;boolean&quot;</span>}          }          }      }  }      </pre>  </div>    <h4>DeviceLogData</h4>  C# code  <div style=\"background: #ffffff; overflow:auto;width:auto;border:solid #0A485F;border-width:.1em .1em .1em .4em;padding:.2em .6em;\">  <pre style=\"background-color: #ffffff;border:0; margin:0; line-height: 125%; color:#000000\">  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// log event</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #0000ff\">public</span> <span style=\"color: #0000ff\">class</span> <span style=\"color: #2b91af\">DeviceLogData</span>  {      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Id</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> Guid DeviceLog_ID { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Error code from device</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> <span style=\"color: #2b91af\">int</span> ErrCode { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Lock information if log row is linked to a lock</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> DeviceLogFlock FLock { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Key information if log row is linked to a key</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> DeviceLogFNKey FNKey { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Date and time of log access</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> DateTime? GoingDateUtc { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Additional programming information if any.</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> <span style=\"color: #2b91af\">int?</span> ProgrammingInfo { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Type mask of access</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> DeviceLogTypeMask TypeMask { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  }  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Lock log types as bit mask values. For example 1028 would be successful S10 key access. 12 would be successful phone access etc.</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  [Flags]  <span style=\"color: #0000ff\">public</span> <span style=\"color: #0000ff\">enum</span> DeviceLogTypeMask  {      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">///</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      None = 0,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Failed access</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      OpenFailed = 1,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Lock was programmed</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      LockProgrammingTask = 2,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Successful access</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      OpenSucceeded = 4,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Phone accessed the lock</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      S40PhoneKey = 8,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Fob accessed the lock</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      S40FobKey = 16,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Key accessed the lock</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      S10Key = 1024,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// S20 key accessed the lock</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      S20Key = 2048,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Unknown key (Key is empty or in factory state)</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      UnknownKey = 4096,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Snap open access</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      SnapOpenKey = 8192,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Log is a key passage from a lock which doesn&#39;t collect logs.</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      KeyPassageFromLockNotCollectingLog = 16384  }  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Key linked to log row</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #0000ff\">public</span> <span style=\"color: #0000ff\">class</span> <span style=\"color: #2b91af\">DeviceLogFNKey</span>  {      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Key description</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> <span style=\"color: #2b91af\">string</span> Description { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Id</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> Guid FNKeyId { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Key going counter</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> <span style=\"color: #2b91af\">int</span> GoingCounter { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Numeric Key id</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> <span style=\"color: #2b91af\">int</span> KeyId { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Key type</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> KeyTypeMask KeyTypeMask { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Person&#39;s name during the time of access.</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> <span style=\"color: #2b91af\">string</span> PersonName { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Stamp</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> <span style=\"color: #2b91af\">string</span> Stamp { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  }  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Key type mask.</span>  <span style=\"color: #008000\">/// For example 6 would be S40 Phone (2 + 4)</span>  <span style=\"color: #008000\">/// MainType: S10/S40/S20</span>  <span style=\"color: #008000\">/// Physical form: Phone, iLoqKey, External</span>  <span style=\"color: #008000\">/// RFid: MifareClassic, MifareDesfire</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  [Flags()]  <span style=\"color: #0000ff\">public</span> <span style=\"color: #0000ff\">enum</span> KeyTypeMask : <span style=\"color: #2b91af\">int</span>  {      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Unknown</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      Unknown = 0,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// S10 system key</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      S10 = 1,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// S40 system key</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      S40 = 2,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Phone key</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      PhoneKey = 4,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// iLoq key</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      iLoqKey = 8,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Classic Mifare rfid</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      MifareClassic = 16,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Key has Desfire capabilities</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      MifareDesfire = 32,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Key has Nortec capabilities</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      Nortec_NotInUse = 64,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Other than iLoq key</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      ExternalKey = 128,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// S20 system key</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      S20 = 256,  }  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Lock linked to log row</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #0000ff\">public</span> <span style=\"color: #0000ff\">class</span> <span style=\"color: #2b91af\">DeviceLogFlock</span>  {      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Id</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> Guid FlockId { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Lock going counter</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> <span style=\"color: #2b91af\">int</span> GoingCounter { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Key chamber</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> <span style=\"color: #2b91af\">string</span> KeyChamber { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Location code</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> <span style=\"color: #2b91af\">string</span> LocationCode { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Locking object</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> <span style=\"color: #2b91af\">string</span> LockingObject { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Lock type</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      <span style=\"color: #0000ff\">public</span> LockType? LockType { <span style=\"color: #0000ff\">get</span>; <span style=\"color: #0000ff\">set</span>; }  }  <p>  <span style=\"color: #008000\">/// &lt;summary&gt;</span>  <span style=\"color: #008000\">/// Lock types.</span>  <span style=\"color: #008000\">/// &lt;/summary&gt;</span>  <span style=\"color: #0000ff\">public</span> <span style=\"color: #0000ff\">enum</span> LockType : <span style=\"color: #2b91af\">short</span>  {      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// Normal S10 lock</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      S10Normal = 0,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// S10 network module lock</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      S10Online = 1,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// S50 lock</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      S50Normal = 2,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// C5 lock</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      C5Normal = 3,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// S5Online lock for S5 network module</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      S5Online = 4,  <p>      <span style=\"color: #008000\">/// &lt;summary&gt;</span>      <span style=\"color: #008000\">/// D5 locks</span>      <span style=\"color: #008000\">/// &lt;/summary&gt;</span>      D5Normal = 5  }      </pre>  </div id=\"DeviceLogDataJson\" class=\"collapse\">    Json schema  <div style=\"background: #ffffff; overflow:auto;width:auto;border:solid #0A485F;border-width:.1em .1em .1em .4em;padding:.2em .6em;\">  <pre style=\"background-color: #ffffff;border:0; margin:0; line-height: 125%; color:#000000\">  {      <span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;object&quot;</span>,      <span style=\"font-weight: bold\">&quot;properties&quot;</span>:       {          <span style=\"font-weight: bold\">&quot;DeviceLog_ID&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;string&quot;</span>},          <span style=\"font-weight: bold\">&quot;ErrCode&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;integer&quot;</span>},          <span style=\"font-weight: bold\">&quot;FLock&quot;</span>: {          <span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;object&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>],          <span style=\"font-weight: bold\">&quot;properties&quot;</span>: {              <span style=\"font-weight: bold\">&quot;FlockId&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;string&quot;</span>},              <span style=\"font-weight: bold\">&quot;GoingCounter&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;integer&quot;</span>},              <span style=\"font-weight: bold\">&quot;KeyChamber&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;string&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>]},              <span style=\"font-weight: bold\">&quot;LocationCode&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;string&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>]},              <span style=\"font-weight: bold\">&quot;LockingObject&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;string&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>]},              <span style=\"font-weight: bold\">&quot;LockType&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;integer&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>]}          }          },          <span style=\"font-weight: bold\">&quot;FNKey&quot;</span>: {          <span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;object&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>],          <span style=\"font-weight: bold\">&quot;properties&quot;</span>: {              <span style=\"font-weight: bold\">&quot;Description&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;string&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>]},              <span style=\"font-weight: bold\">&quot;FNKeyId&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;string&quot;</span>},              <span style=\"font-weight: bold\">&quot;GoingCounter&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;integer&quot;</span>},              <span style=\"font-weight: bold\">&quot;KeyId&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;integer&quot;</span>},              <span style=\"font-weight: bold\">&quot;KeyTypeMask&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;integer&quot;</span>},              <span style=\"font-weight: bold\">&quot;PersonName&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;string&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>]},              <span style=\"font-weight: bold\">&quot;Stamp&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;string&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>]}          }          },          <span style=\"font-weight: bold\">&quot;GoingDateUtc&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;string&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>]},          <span style=\"font-weight: bold\">&quot;ProgrammingInfo&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: [<span style=\"font-style: italic\">&quot;integer&quot;</span>,<span style=\"font-style: italic\">&quot;null&quot;</span>]},          <span style=\"font-weight: bold\">&quot;TypeMask&quot;</span>: {<span style=\"font-weight: bold\">&quot;type&quot;</span>: <span style=\"font-style: italic\">&quot;integer&quot;</span>}      }  }      </pre>  </div>    </details>      
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Access token type mask    0 = None    1 = Single time use key which is valid for 1 minute    
 * @export
 * @enum {string}
 */
export enum AccessTokenTypeMask {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

/**
 * Options for the message delivery system for network module    0 = Messaging system is not in use    1 = Messages are delivered using sockets.    2 = Messages are delivered using SignalR service    
 * @export
 * @enum {string}
 */
export enum AllowedSocketRequestTypeMask {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

/**
 * 
 * @export
 * @interface BlackList
 */
export interface BlackList {
    /**
     * Id
     * @type {string}
     * @memberof BlackList
     */
    FNKeyBlacklistPacketLink_ID?: string;
    /**
     * Blocklist\'s version
     * @type {string}
     * @memberof BlackList
     */
    BlacklistVersion?: string | null;
    /**
     * Name
     * @type {string}
     * @memberof BlackList
     */
    Name?: string | null;
    /**
     * Key\'s id which is in blocklist
     * @type {string}
     * @memberof BlackList
     */
    FNKey_ID?: string;
    /**
     * Person\'s name
     * @type {string}
     * @memberof BlackList
     */
    PersonName?: string | null;
    /**
     * Date and time when item was added to blocklist
     * @type {string}
     * @memberof BlackList
     */
    BlackListDateUtc?: string;
    /**
     * Key\'s stamp
     * @type {string}
     * @memberof BlackList
     */
    KeyStamp?: string | null;
    /**
     * base key type
     * @type {KeyTypeMask}
     * @memberof BlackList
     */
    KeyTypeMask?: KeyTypeMask;
    /**
     * change to previous ordered blocklist
     * @type {BlacklistChangeType}
     * @memberof BlackList
     */
    ChangeType?: BlacklistChangeType;
}
/**
 * Blocklist change    0 = No change    1 = Item was added to blocklist    2 = Item was removed from blocklist    
 * @export
 * @enum {string}
 */
export enum BlacklistChangeType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

/**
 * 
 * @export
 * @interface BlacklistPacket
 */
export interface BlacklistPacket {
    /**
     * 
     * @type {string}
     * @memberof BlacklistPacket
     */
    BlacklistPacket_ID?: string;
    /**
     * 
     * @type {number}
     * @memberof BlacklistPacket
     */
    HardDataVersion?: number;
    /**
     * 
     * @type {number}
     * @memberof BlacklistPacket
     */
    SoftDataVersion?: number;
    /**
     * 
     * @type {BlacklistPacketState}
     * @memberof BlacklistPacket
     */
    State?: BlacklistPacketState;
}
/**
 * Blocklist packet state    0 = Blocklist packet is not found    1 = Blocklist packet is in planning state    2 = Blocklist packet is ordered    
 * @export
 * @enum {string}
 */
export enum BlacklistPacketState {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

/**
 * 
 * @export
 * @interface CalendarDataEntry
 */
export interface CalendarDataEntry {
    /**
     * Calendar data id
     * @type {string}
     * @memberof CalendarDataEntry
     */
    CalendarData_ID?: string;
    /**
     * Calendar data title id for which this entry belongs to.
     * @type {string}
     * @memberof CalendarDataEntry
     */
    CalendarDataTitle_ID?: string;
    /**
     * Start time
     * @type {string}
     * @memberof CalendarDataEntry
     */
    StartDateTime?: string;
    /**
     * End time
     * @type {string}
     * @memberof CalendarDataEntry
     */
    EndDateTime?: string;
    /**
     * Subject text
     * @type {string}
     * @memberof CalendarDataEntry
     */
    Subject?: string | null;
    /**
     * Type
     * @type {CalendarDataType}
     * @memberof CalendarDataEntry
     */
    Type?: CalendarDataType;
}
/**
 * 
 * @export
 * @interface CalendarDataGetByCalendarDataIdResult
 */
export interface CalendarDataGetByCalendarDataIdResult {
    /**
     * Calendar data information
     * @type {CalendarDataEntry}
     * @memberof CalendarDataGetByCalendarDataIdResult
     */
    Entry?: CalendarDataEntry | null;
    /**
     * Recurring entry information
     * @type {CalendarDataRecurringEntry}
     * @memberof CalendarDataGetByCalendarDataIdResult
     */
    RecurringEntry?: CalendarDataRecurringEntry | null;
    /**
     * Recurring entry exception information
     * @type {CalendarDataRecurringEntryException}
     * @memberof CalendarDataGetByCalendarDataIdResult
     */
    RecurringEntryException?: CalendarDataRecurringEntryException | null;
}
/**
 * 
 * @export
 * @interface CalendarDataGetByCalendarIdResult
 */
export interface CalendarDataGetByCalendarIdResult {
    /**
     * Calendar datas which belong to calendar
     * @type {Array<CalendarDataEntry>}
     * @memberof CalendarDataGetByCalendarIdResult
     */
    Entries?: Array<CalendarDataEntry> | null;
    /**
     * Recurring entries which belong to calendar
     * @type {Array<CalendarDataRecurringEntry>}
     * @memberof CalendarDataGetByCalendarIdResult
     */
    RecurringEntries?: Array<CalendarDataRecurringEntry> | null;
    /**
     * Recurring entry exceptions which belong to calendar
     * @type {Array<CalendarDataRecurringEntryException>}
     * @memberof CalendarDataGetByCalendarIdResult
     */
    RecurringEntryExceptions?: Array<CalendarDataRecurringEntryException> | null;
}
/**
 * 
 * @export
 * @interface CalendarDataInsertParam
 */
export interface CalendarDataInsertParam {
    /**
     * Calendar datas to insert
     * @type {Array<CalendarDataEntry>}
     * @memberof CalendarDataInsertParam
     */
    Entries?: Array<CalendarDataEntry> | null;
    /**
     * Recurring entries to insert
     * @type {Array<CalendarDataRecurringEntry>}
     * @memberof CalendarDataInsertParam
     */
    RecurringEntries?: Array<CalendarDataRecurringEntry> | null;
    /**
     * Recurring entry exceptions to insert
     * @type {Array<CalendarDataRecurringEntryException>}
     * @memberof CalendarDataInsertParam
     */
    RecurringEntryExceptions?: Array<CalendarDataRecurringEntryException> | null;
}
/**
 * 
 * @export
 * @interface CalendarDataRecurringEntry
 */
export interface CalendarDataRecurringEntry {
    /**
     * Calendar data id
     * @type {string}
     * @memberof CalendarDataRecurringEntry
     */
    CalendarData_ID?: string;
    /**
     * Calendar data title id for which this entry belongs to.
     * @type {string}
     * @memberof CalendarDataRecurringEntry
     */
    CalendarDataTitle_ID?: string;
    /**
     * Start time
     * @type {string}
     * @memberof CalendarDataRecurringEntry
     */
    StartDateTime?: string;
    /**
     * End time
     * @type {string}
     * @memberof CalendarDataRecurringEntry
     */
    EndDateTime?: string;
    /**
     * Subject text
     * @type {string}
     * @memberof CalendarDataRecurringEntry
     */
    Subject?: string | null;
    /**
     * Type
     * @type {CalendarDataType}
     * @memberof CalendarDataRecurringEntry
     */
    Type?: CalendarDataType;
    /**
     * ID so that exceptions can be linked to correct recurring entry.
     * @type {string}
     * @memberof CalendarDataRecurringEntry
     */
    Re_ID?: string;
    /**
     * Recurring entry\'s duration in ticks.
     * @type {number}
     * @memberof CalendarDataRecurringEntry
     */
    Re_OccurrenceDurationTicks?: number;
    /**
     * Days of week mask which tells on which days the recurring entry happens. None = 0 Sunday = 1 Monday = 2 Tuesday = 4 Wednesday = 8 Thursday = 16 Friday = 32 Saturday = 64
     * @type {number}
     * @memberof CalendarDataRecurringEntry
     */
    Re_PatternDaysOfWeek?: number;
    /**
     * How often entry recurs: Daily = 0 Weekly = 1 Monthly = 2 Yearly = 3
     * @type {number}
     * @memberof CalendarDataRecurringEntry
     */
    Re_PatternFrequency?: number;
    /**
     * Occurence start time. This and Re_OccurrenceDurationTicks are used to calculate the time span of the occurence.
     * @type {string}
     * @memberof CalendarDataRecurringEntry
     */
    Re_OccurrenceStartTime?: string;
    /**
     * Last date of recurring entry.
     * @type {string}
     * @memberof CalendarDataRecurringEntry
     */
    Re_RangeEndDate?: string;
    /**
     * First date of recurring entry.
     * @type {string}
     * @memberof CalendarDataRecurringEntry
     */
    Re_RangeStartDate?: string;
    /**
     * 0 = No limit to the number of occurrences in the recurrence. 1 = The recurrence is limited to a specific number of occurrences. 2 = The recurrence is restricted by an ending date.
     * @type {number}
     * @memberof CalendarDataRecurringEntry
     */
    Re_RangeLimit?: number;
}
/**
 * 
 * @export
 * @interface CalendarDataRecurringEntryAllOf
 */
export interface CalendarDataRecurringEntryAllOf {
    /**
     * ID so that exceptions can be linked to correct recurring entry.
     * @type {string}
     * @memberof CalendarDataRecurringEntryAllOf
     */
    Re_ID?: string;
    /**
     * Recurring entry\'s duration in ticks.
     * @type {number}
     * @memberof CalendarDataRecurringEntryAllOf
     */
    Re_OccurrenceDurationTicks?: number;
    /**
     * Days of week mask which tells on which days the recurring entry happens. None = 0 Sunday = 1 Monday = 2 Tuesday = 4 Wednesday = 8 Thursday = 16 Friday = 32 Saturday = 64
     * @type {number}
     * @memberof CalendarDataRecurringEntryAllOf
     */
    Re_PatternDaysOfWeek?: number;
    /**
     * How often entry recurs: Daily = 0 Weekly = 1 Monthly = 2 Yearly = 3
     * @type {number}
     * @memberof CalendarDataRecurringEntryAllOf
     */
    Re_PatternFrequency?: number;
    /**
     * Occurence start time. This and Re_OccurrenceDurationTicks are used to calculate the time span of the occurence.
     * @type {string}
     * @memberof CalendarDataRecurringEntryAllOf
     */
    Re_OccurrenceStartTime?: string;
    /**
     * Last date of recurring entry.
     * @type {string}
     * @memberof CalendarDataRecurringEntryAllOf
     */
    Re_RangeEndDate?: string;
    /**
     * First date of recurring entry.
     * @type {string}
     * @memberof CalendarDataRecurringEntryAllOf
     */
    Re_RangeStartDate?: string;
    /**
     * 0 = No limit to the number of occurrences in the recurrence. 1 = The recurrence is limited to a specific number of occurrences. 2 = The recurrence is restricted by an ending date.
     * @type {number}
     * @memberof CalendarDataRecurringEntryAllOf
     */
    Re_RangeLimit?: number;
}
/**
 * 
 * @export
 * @interface CalendarDataRecurringEntryException
 */
export interface CalendarDataRecurringEntryException {
    /**
     * Calendar data id
     * @type {string}
     * @memberof CalendarDataRecurringEntryException
     */
    CalendarData_ID?: string;
    /**
     * Calendar data title id for which this entry belongs to.
     * @type {string}
     * @memberof CalendarDataRecurringEntryException
     */
    CalendarDataTitle_ID?: string;
    /**
     * Start time
     * @type {string}
     * @memberof CalendarDataRecurringEntryException
     */
    StartDateTime?: string;
    /**
     * End time
     * @type {string}
     * @memberof CalendarDataRecurringEntryException
     */
    EndDateTime?: string;
    /**
     * Subject text
     * @type {string}
     * @memberof CalendarDataRecurringEntryException
     */
    Subject?: string | null;
    /**
     * Type
     * @type {CalendarDataType}
     * @memberof CalendarDataRecurringEntryException
     */
    Type?: CalendarDataType;
    /**
     * Contains entry\'s original start date, when this entry should have happened normally.
     * @type {string}
     * @memberof CalendarDataRecurringEntryException
     */
    OriginalStartDateTime?: string;
    /**
     * Re_ID of the recurring entry.
     * @type {string}
     * @memberof CalendarDataRecurringEntryException
     */
    RecurrenceId?: string;
    /**
     * True if this entry is removed from recurring calendar entry
     * @type {boolean}
     * @memberof CalendarDataRecurringEntryException
     */
    A_IsRemoved?: boolean;
}
/**
 * 
 * @export
 * @interface CalendarDataRecurringEntryExceptionAllOf
 */
export interface CalendarDataRecurringEntryExceptionAllOf {
    /**
     * Contains entry\'s original start date, when this entry should have happened normally.
     * @type {string}
     * @memberof CalendarDataRecurringEntryExceptionAllOf
     */
    OriginalStartDateTime?: string;
    /**
     * Re_ID of the recurring entry.
     * @type {string}
     * @memberof CalendarDataRecurringEntryExceptionAllOf
     */
    RecurrenceId?: string;
    /**
     * True if this entry is removed from recurring calendar entry
     * @type {boolean}
     * @memberof CalendarDataRecurringEntryExceptionAllOf
     */
    A_IsRemoved?: boolean;
}
/**
 * 
 * @export
 * @interface CalendarDataSecurityRoleLink
 */
export interface CalendarDataSecurityRoleLink {
    /**
     * Calendar data ID
     * @type {string}
     * @memberof CalendarDataSecurityRoleLink
     */
    CalendarData_ID?: string;
    /**
     * Security role ID
     * @type {string}
     * @memberof CalendarDataSecurityRoleLink
     */
    SecurityRole_ID?: string | null;
}
/**
 * 
 * @export
 * @interface CalendarDataSecurityRoleLinksDeleteLinksParam
 */
export interface CalendarDataSecurityRoleLinksDeleteLinksParam {
    /**
     * Security role Ids which are deleted from calendar data
     * @type {Array<string>}
     * @memberof CalendarDataSecurityRoleLinksDeleteLinksParam
     */
    SecurityRoleIds?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CalendarDataSecurityRoleLinksInsertLinksParam
 */
export interface CalendarDataSecurityRoleLinksInsertLinksParam {
    /**
     * Security role Ids which are added to calendar data
     * @type {Array<string>}
     * @memberof CalendarDataSecurityRoleLinksInsertLinksParam
     */
    SecurityRoleIds?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CalendarDataSecurityRoleLinksSetLinksParam
 */
export interface CalendarDataSecurityRoleLinksSetLinksParam {
    /**
     * Security role Ids to link for calendar data The whole result set must be given when setting links because this method handles both adding/removing of links. If no links are given, clears all calendar data\'s links.
     * @type {Array<string>}
     * @memberof CalendarDataSecurityRoleLinksSetLinksParam
     */
    SecurityRoleIds?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CalendarDataTitle
 */
export interface CalendarDataTitle {
    /**
     * Calendar ID
     * @type {string}
     * @memberof CalendarDataTitle
     */
    CalendarDataTitle_ID?: string;
    /**
     * Description
     * @type {string}
     * @memberof CalendarDataTitle
     */
    Description?: string | null;
    /**
     * Name
     * @type {string}
     * @memberof CalendarDataTitle
     */
    Name?: string | null;
    /**
     * Real estate id
     * @type {string}
     * @memberof CalendarDataTitle
     */
    RealEstate_ID?: string;
    /**
     * Type
     * @type {CalendarDataTitleType}
     * @memberof CalendarDataTitle
     */
    Type?: CalendarDataTitleType;
    /**
     * Zone id
     * @type {string}
     * @memberof CalendarDataTitle
     */
    Zone_ID?: string;
}
/**
 * Calendar data title type    0 = Time control calendar    1 = Key pin code calendar    -1 = Not specified. Do not use.    
 * @export
 * @enum {string}
 */
export enum CalendarDataTitleType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_MINUS_1 = -1
}

/**
 * Calendar data type    0 = Relay is on when calendar entry occurs    1 = Relay is on if security role\'s pin code input is correct    2 = Lock is controlled by key pin code    
 * @export
 * @enum {string}
 */
export enum CalendarDataType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

/**
 * 
 * @export
 * @interface CalendarDataUpdateParam
 */
export interface CalendarDataUpdateParam {
    /**
     * Calendar datas to update
     * @type {Array<CalendarDataEntry>}
     * @memberof CalendarDataUpdateParam
     */
    Entries?: Array<CalendarDataEntry> | null;
    /**
     * Recurring entries to update
     * @type {Array<CalendarDataRecurringEntry>}
     * @memberof CalendarDataUpdateParam
     */
    RecurringEntries?: Array<CalendarDataRecurringEntry> | null;
    /**
     * Recurring entry exceptions to update
     * @type {Array<CalendarDataRecurringEntryException>}
     * @memberof CalendarDataUpdateParam
     */
    RecurringEntryExceptions?: Array<CalendarDataRecurringEntryException> | null;
}
/**
 * 
 * @export
 * @interface CalendarNetworkModuleDeviceRelayLinksSetLinksParam
 */
export interface CalendarNetworkModuleDeviceRelayLinksSetLinksParam {
    /**
     * Links. The whole result set must be given when setting links because this method handles both adding/removing of links. If no links are given, clears all calendar\'s links.
     * @type {Array<string>}
     * @memberof CalendarNetworkModuleDeviceRelayLinksSetLinksParam
     */
    NetworkModuleDeviceRelayIds?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CalendarNetworkModuleRelayLink
 */
export interface CalendarNetworkModuleRelayLink {
    /**
     * Calendar data title ID
     * @type {string}
     * @memberof CalendarNetworkModuleRelayLink
     */
    CalendarDataTitle_ID?: string;
    /**
     * Network module device relay ID
     * @type {string}
     * @memberof CalendarNetworkModuleRelayLink
     */
    NetworkModuleDeviceRelay_ID?: string | null;
}
/**
 * Result for TimeLimitTitles/CanDelete    0 = Time limit title can be deleted.    1 = Time limit title has active keys linked to it and can\'t be deleted.    2 = time limit title is locked and cannot be deleted    3 = time limit title has active locks linked to it and can\'t be deleted    
 * @export
 * @enum {string}
 */
export enum CanDeleteTimeLimitTitleResult {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}

/**
 * Result when asked if key can be ordered.    0 = Ok, can order key    1 = Key has changes which require iLOQ Manager + token to order.    2 = Key isn\'t a phone or 5 Series key and can\'t be ordered using public api    3 = Key can\'t be ordered because the license limit has been exceeded. Return keys or contact iLOQ to acquire more licenses.    4 = Key is in wrong state. Only keys in planning state can be ordered.    5 = Key\'s id is too large.    6 = Key has security accesses which are outside his zones. This can only occur if key is a new key.    7 = Key has time limits which are outside his zones. This can only occur if key is a new key.    8 = Key is in block list.    9 = Phone key doesn\'t have phone number set on FNKeyPhone    10 = Phone key doesn\'t have email address set on FNKeyPhone and FNKeyPhone.OptionMask states that messages are sent via email.    11 = key has too many timelimits defined    12 = Key main zone is not set and is required.    -1 = Error occurred during checking    
 * @export
 * @enum {string}
 */
export enum CanOrderKeyResultType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6,
    NUMBER_7 = 7,
    NUMBER_8 = 8,
    NUMBER_9 = 9,
    NUMBER_10 = 10,
    NUMBER_11 = 11,
    NUMBER_12 = 12,
    NUMBER_MINUS_1 = -1
}

/**
 * Result for checking if lock can be ordered    0 = Ok, Lock can be ordered    1 = Lock has changes which required iLOQ Manager + token to order.    
 * @export
 * @enum {string}
 */
export enum CanOrderLockResultType {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

/**
 * Result for Blacklists/CanOrderS40Blacklist web api method    0 = Blocklist can be ordered through public web api    1 = Blocklist has changes which require iLOQ Manager + token to order    2 = Blocklist doesn\'t have any changes since last time it was ordered or it is completely empty.    3 = Too many items in blocklist    
 * @export
 * @enum {string}
 */
export enum CanOrderS40BlacklistResult {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}

/**
 * Result when asked if key can be returned using public API    0 = Ok, can return key    1 = Returning key requires iLOQ Manager + token    2 = Key isn\'t a phone and can\'t be returned using public api    3 = Key has never been programmed. It can\'t be returned before it\'s programmed. Call Delete endpoint instead.    
 * @export
 * @enum {string}
 */
export enum CanReturnKeyResultType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}

/**
 * Results for check if key\'s main zone can be updated.    0 = Key\'s main zone can be changed    1 = The selected locking system does not support main zone functionality    2 = Main zone cannot be changed after the key has been ordered for the first time.    
 * @export
 * @enum {string}
 */
export enum CanUpdateKeyMainZoneResult {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

/**
 * Parameter for creating session
 * @export
 * @interface CreateSessionParam
 */
export interface CreateSessionParam {
    /**
     * User name
     * @type {string}
     * @memberof CreateSessionParam
     */
    UserName?: string | null;
    /**
     * Password
     * @type {string}
     * @memberof CreateSessionParam
     */
    Password?: string | null;
    /**
     * Customer code
     * @type {string}
     * @memberof CreateSessionParam
     */
    CustomerCode?: string | null;
    /**
     * Not in use at the moment. Leave empty.
     * @type {string}
     * @memberof CreateSessionParam
     */
    ApiKey?: string | null;
    /**
     * Not in use at the moment. Leave empty.
     * @type {string}
     * @memberof CreateSessionParam
     */
    ApiSecret?: string | null;
}
/**
 * Return value for CreateSession method
 * @export
 * @interface CreateSessionResult
 */
export interface CreateSessionResult {
    /**
     * Created session ID.
     * @type {string}
     * @memberof CreateSessionResult
     */
    SessionID?: string | null;
    /**
     * Result
     * @type {CreateSessionResultType}
     * @memberof CreateSessionResult
     */
    Result?: CreateSessionResultType;
}
/**
 * Result type for creating session    0 = No result.    1 = Successful login    2 = Invalid WebService interface version.    3 = Secured Https connection is required    4 = Database update is in progress on server so login is temporarily disabled until the database is updated.    5 = Invalid credentials or invalid customer code.    6 = Database version is too low and cannot be connected using this server version. Check that you have the correct server address.    
 * @export
 * @enum {string}
 */
export enum CreateSessionResultType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6
}

/**
 * 
 * @export
 * @interface DeviceLogData
 */
export interface DeviceLogData {
    /**
     * Id
     * @type {string}
     * @memberof DeviceLogData
     */
    DeviceLog_ID?: string;
    /**
     * Error code from device
     * @type {number}
     * @memberof DeviceLogData
     */
    ErrCode?: number;
    /**
     * Lock information if log row is linked to a lock
     * @type {DeviceLogFlock}
     * @memberof DeviceLogData
     */
    FLock?: DeviceLogFlock | null;
    /**
     * Key information if log row is linked to a key
     * @type {DeviceLogFNKey}
     * @memberof DeviceLogData
     */
    FNKey?: DeviceLogFNKey | null;
    /**
     * Date and time of log access
     * @type {string}
     * @memberof DeviceLogData
     */
    GoingDateUtc?: string | null;
    /**
     * Additional programming information if any.
     * @type {number}
     * @memberof DeviceLogData
     */
    ProgrammingInfo?: number | null;
    /**
     * Type mask of access
     * @type {DeviceLogTypeMask}
     * @memberof DeviceLogData
     */
    TypeMask?: DeviceLogTypeMask;
}
/**
 * 
 * @export
 * @interface DeviceLogFNKey
 */
export interface DeviceLogFNKey {
    /**
     * Key description
     * @type {string}
     * @memberof DeviceLogFNKey
     */
    Description?: string | null;
    /**
     * Id
     * @type {string}
     * @memberof DeviceLogFNKey
     */
    FNKeyId?: string;
    /**
     * Key going counter
     * @type {number}
     * @memberof DeviceLogFNKey
     */
    GoingCounter?: number;
    /**
     * Numeric Key id
     * @type {number}
     * @memberof DeviceLogFNKey
     */
    KeyId?: number;
    /**
     * Key type
     * @type {KeyTypeMask}
     * @memberof DeviceLogFNKey
     */
    KeyTypeMask?: KeyTypeMask;
    /**
     * Person\'s name during the time of access.
     * @type {string}
     * @memberof DeviceLogFNKey
     */
    PersonName?: string | null;
    /**
     * Stamp
     * @type {string}
     * @memberof DeviceLogFNKey
     */
    Stamp?: string | null;
}
/**
 * 
 * @export
 * @interface DeviceLogFlock
 */
export interface DeviceLogFlock {
    /**
     * Id
     * @type {string}
     * @memberof DeviceLogFlock
     */
    FlockId?: string;
    /**
     * Lock going counter
     * @type {number}
     * @memberof DeviceLogFlock
     */
    GoingCounter?: number;
    /**
     * Key chamber
     * @type {string}
     * @memberof DeviceLogFlock
     */
    KeyChamber?: string | null;
    /**
     * Location code
     * @type {string}
     * @memberof DeviceLogFlock
     */
    LocationCode?: string | null;
    /**
     * Locking object
     * @type {string}
     * @memberof DeviceLogFlock
     */
    LockingObject?: string | null;
    /**
     * Lock type
     * @type {EnuLockType}
     * @memberof DeviceLogFlock
     */
    LockType?: EnuLockType | null;
}
/**
 * Lock log types as bit mask values. For example 1028 would be successful S10 key access. 12 would be successful phone access etc.    0 = Unknown type    1 = Failed access    2 = Lock was programmed    4 = Successful access    8 = Phone accessed the lock    16 = Fob accessed the lock    1024 = Key accessed the lock    2048 = 5 Series key accessed the lock    4096 = Unknown key (Key is empty or in factory state)    8192 = Snap open access    16384 = Log is a key passage from a lock which doesn\'t collect logs.    
 * @export
 * @enum {string}
 */
export enum DeviceLogTypeMask {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_4 = 4,
    NUMBER_8 = 8,
    NUMBER_16 = 16,
    NUMBER_1024 = 1024,
    NUMBER_2048 = 2048,
    NUMBER_4096 = 4096,
    NUMBER_8192 = 8192,
    NUMBER_16384 = 16384
}

/**
 * Network module\'s calendar state    0 = In planning    1 = Ordered    2 = Network module has retrieved calendars    3 = Network module has confirmed retrieving latest calendars.    
 * @export
 * @enum {string}
 */
export enum EnuCalendarDataState {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}

/**
 * Lock types.    0 = Normal S10 lock    1 = S10 network module lock    2 = S50 lock    3 = C5 lock    4 = S5Online lock for 5 Series network module    5 = D5 locks    
 * @export
 * @enum {string}
 */
export enum EnuLockType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5
}

/**
 * Security access mode    0 = show as default    1 = hide as default    
 * @export
 * @enum {string}
 */
export enum EnuSecurityAccessMode {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

/**
 * KeyPhone options mask    0 = No options    1 = Phone is waiting for registration    2 = Phone is registered    4 = Is mepin link replace required.    8 = Are registration messages sent via email instead of SMS    
 * @export
 * @enum {string}
 */
export enum FNKeyPhoneOptionMask {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_4 = 4,
    NUMBER_8 = 8
}

/**
 * Requests for the phone    0 = no requests    1 = Phone\'s lock list has changed    
 * @export
 * @enum {string}
 */
export enum FNKeyPhoneRequestTypeMask {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

/**
 * State mask for tokens and network modules    0 = Not set    1 = Active    2 = Programming is started    4 = Programmed    
 * @export
 * @enum {string}
 */
export enum FprogKeyStateMask {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_4 = 4
}

/**
 * 
 * @export
 * @interface GenerateAccessTokenParam
 */
export interface GenerateAccessTokenParam {
    /**
     * Access token\'s type.
     * @type {AccessTokenTypeMask}
     * @memberof GenerateAccessTokenParam
     */
    TypeMask?: AccessTokenTypeMask;
}
/**
 * 
 * @export
 * @interface GenerateAccessTokenResult
 */
export interface GenerateAccessTokenResult {
    /**
     * Access token which was generated.
     * @type {string}
     * @memberof GenerateAccessTokenResult
     */
    AccessToken?: string;
}
/**
 * 
 * @export
 * @interface GetConnectionSettingsResult
 */
export interface GetConnectionSettingsResult {
    /**
     * Address for old message service.
     * @type {string}
     * @memberof GetConnectionSettingsResult
     */
    SignalMessageServiceAddress?: string | null;
    /**
     * Address for new signalr service
     * @type {string}
     * @memberof GetConnectionSettingsResult
     */
    SignalRServiceAddress?: string | null;
}
/**
 * Result for gettings key\'s security accesses
 * @export
 * @interface GetKeySecurityAccessesResult
 */
export interface GetKeySecurityAccessesResult {
    /**
     * Security accesses linked to keys which are visible to user
     * @type {Array<SecurityAccess>}
     * @memberof GetKeySecurityAccessesResult
     */
    SecurityAccesses?: Array<SecurityAccess> | null;
    /**
     * How many of additional security accesses are linked to the key which are invisible to user because they are outside his zones
     * @type {number}
     * @memberof GetKeySecurityAccessesResult
     */
    OutsideUserZonesCount?: number;
}
/**
 * Result for getting keys for person
 * @export
 * @interface GetKeysByPersonResult
 */
export interface GetKeysByPersonResult {
    /**
     * List of person\'s keys
     * @type {Array<Key>}
     * @memberof GetKeysByPersonResult
     */
    Keys?: Array<Key> | null;
}
/**
 * Result for getting keys for person
 * @export
 * @interface GetKeysByPersonResult1
 */
export interface GetKeysByPersonResult1 {
    /**
     * List of person\'s keys
     * @type {Array<Key1>}
     * @memberof GetKeysByPersonResult1
     */
    Keys?: Array<Key1> | null;
}
/**
 * Parameter for getting lock logs
 * @export
 * @interface GetLockLogDataParam
 */
export interface GetLockLogDataParam {
    /**
     * End date and time the logs are returned for (exclusive)
     * @type {string}
     * @memberof GetLockLogDataParam
     */
    EndDateUtc?: string | null;
    /**
     * Start date and time the logs are returned for (inclusive)
     * @type {string}
     * @memberof GetLockLogDataParam
     */
    StartDateUtc?: string | null;
}
/**
 * Result for getting lock logs
 * @export
 * @interface GetLockLogDataResult
 */
export interface GetLockLogDataResult {
    /**
     * End date and time the logs are returned for.
     * @type {string}
     * @memberof GetLockLogDataResult
     */
    EndDateUtc?: string | null;
    /**
     * Lock logs which are between startdate and enddate (or all if neither is given).
     * @type {Array<LockLogData>}
     * @memberof GetLockLogDataResult
     */
    LockLogs?: Array<LockLogData> | null;
    /**
     * Start date and time the logs are returned for.
     * @type {string}
     * @memberof GetLockLogDataResult
     */
    StartDateUtc?: string | null;
}
/**
 * Parameter for getting lock logs.
 * @export
 * @interface GetLockLogsParam
 */
export interface GetLockLogsParam {
    /**
     * Lock Ids. Either Key ids or Lock ids must be given, or both.
     * @type {Array<string>}
     * @memberof GetLockLogsParam
     */
    FLockIds?: Array<string> | null;
    /**
     * Key Ids. Either Key ids or Lock ids must be given, or both.
     * @type {Array<string>}
     * @memberof GetLockLogsParam
     */
    FNKeyIds?: Array<string> | null;
    /**
     * Return logs where going date is before this end date. If null, then doesn\'t take it into account.
     * @type {string}
     * @memberof GetLockLogsParam
     */
    GoingEndDateUtc?: string | null;
    /**
     * Returns logs where going date is after this start date. If null, then doesn\'t take it into account.
     * @type {string}
     * @memberof GetLockLogsParam
     */
    GoingStartDateUtc?: string | null;
    /**
     * Lock log types which are retrieved. For example 1028 would be successful S10 key access. 12 would be successful phone access etc.
     * @type {DeviceLogTypeMask}
     * @memberof GetLockLogsParam
     */
    TypeMask?: DeviceLogTypeMask;
}
/**
 * 
 * @export
 * @interface GetLockLogsResult
 */
export interface GetLockLogsResult {
    /**
     * Device logs. Currently maximum of 2000 is returned at once.
     * @type {Array<DeviceLogData>}
     * @memberof GetLockLogsResult
     */
    LockLogs?: Array<DeviceLogData> | null;
    /**
     * Total number of device logs on server with given parameters. Calling application can compare LockLogs.Count to this number and if they don\'t match, change parameters to narrow it down.
     * @type {number}
     * @memberof GetLockLogsResult
     */
    TotalCount?: number;
}
/**
 * 
 * @export
 * @interface GetLockSecurityAccessesResult
 */
export interface GetLockSecurityAccessesResult {
    /**
     * Security accesses linked to lock which are visible to user
     * @type {Array<SecurityAccess2>}
     * @memberof GetLockSecurityAccessesResult
     */
    SecurityAccesses?: Array<SecurityAccess2> | null;
    /**
     * How many of additional security accesses are linked to the lock which are invisible to user because they are outside his zones
     * @type {number}
     * @memberof GetLockSecurityAccessesResult
     */
    OutsideUserZonesCount?: number;
}
/**
 * Result for gettings lock\'s security accesses
 * @export
 * @interface GetLockTimeLimitsResult
 */
export interface GetLockTimeLimitsResult {
    /**
     * Time limit titles linked to lock which are visible to user
     * @type {Array<TimeLimitTitle>}
     * @memberof GetLockTimeLimitsResult
     */
    TimeLimitTitles?: Array<TimeLimitTitle> | null;
    /**
     * How many of additional time limit titles are linked to the lock which are invisible to user because they are outside his zones
     * @type {number}
     * @memberof GetLockTimeLimitsResult
     */
    OutsideUserZonesCount?: number;
}
/**
 * 
 * @export
 * @interface GetS40BlacklistResult
 */
export interface GetS40BlacklistResult {
    /**
     * list of keys in blocklist
     * @type {Array<BlackList>}
     * @memberof GetS40BlacklistResult
     */
    BlacklistItems?: Array<BlackList> | null;
    /**
     * keys outside user zones
     * @type {number}
     * @memberof GetS40BlacklistResult
     */
    OutsideUserZoneKeyCount?: number;
    /**
     * current blocklist
     * @type {BlacklistPacket}
     * @memberof GetS40BlacklistResult
     */
    BlacklistPacket?: BlacklistPacket | null;
}
/**
 * View modes for filtering security access output    0 = None. Do not use, use values 1 or 2 instead.    1 = Gets security accesses for planned state. Default.    2 = Gets security accesses for last programmed state    
 * @export
 * @enum {string}
 */
export enum GetSecurityAccessesView {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

/**
 * Result for retrieving Key\'s time limit information
 * @export
 * @interface GetTimeLimitsResult
 */
export interface GetTimeLimitsResult {
    /**
     * Key renew information
     * @type {KeyScheduler}
     * @memberof GetTimeLimitsResult
     */
    KeyScheduler?: KeyScheduler | null;
    /**
     * Time limit slots
     * @type {Array<KeyTimeLimitSlot>}
     * @memberof GetTimeLimitsResult
     */
    KeyTimeLimitSlots?: Array<KeyTimeLimitSlot> | null;
    /**
     * Slots which are filled by information not available for current user.
     * @type {Array<number>}
     * @memberof GetTimeLimitsResult
     */
    OutsideUserZoneTimeLimitTitleSlots?: Array<number> | null;
    /**
     * S50 Time key works offline in seconds. Zero = unlimited offline access.
     * @type {number}
     * @memberof GetTimeLimitsResult
     */
    OfflineExpirationSeconds?: number;
}
/**
 * View modes for filtering time limit output    0 = None    1 = Gets time limits for planned state    2 = Gets time limits for last programmed state    
 * @export
 * @enum {string}
 */
export enum GetTimeLimitsView {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

/**
 * Parameter for inserting a new key
 * @export
 * @interface InsertKeyParam
 */
export interface InsertKeyParam {
    /**
     * Key information
     * @type {KeyInsert}
     * @memberof InsertKeyParam
     */
    Key?: KeyInsert | null;
    /**
     * Security accesses which should be linked to the new key
     * @type {Array<string>}
     * @memberof InsertKeyParam
     */
    SecurityAccessIds?: Array<string> | null;
    /**
     * Key renew information
     * @type {KeyScheduler}
     * @memberof InsertKeyParam
     */
    KeyScheduler?: KeyScheduler | null;
    /**
     * Time limit slots
     * @type {Array<KeyTimeLimitSlot>}
     * @memberof InsertKeyParam
     */
    TimeLimitSlots?: Array<KeyTimeLimitSlot> | null;
    /**
     * Zones the new key belongs to
     * @type {Array<string>}
     * @memberof InsertKeyParam
     */
    ZoneIds?: Array<string> | null;
    /**
     * S50 Time key works offline in seconds. Zero = unlimited offline access.
     * @type {number}
     * @memberof InsertKeyParam
     */
    OfflineExpirationSeconds?: number;
}
/**
 * Parameter for inserting a new key
 * @export
 * @interface InsertKeyParam1
 */
export interface InsertKeyParam1 {
    /**
     * Key information
     * @type {KeyInsert1}
     * @memberof InsertKeyParam1
     */
    Key?: KeyInsert1 | null;
    /**
     * Security accesses which should be linked to the new key
     * @type {Array<string>}
     * @memberof InsertKeyParam1
     */
    SecurityAccessIds?: Array<string> | null;
    /**
     * Time limit information for the new key
     * @type {Array<KeyTimeLimit>}
     * @memberof InsertKeyParam1
     */
    TimeLimits?: Array<KeyTimeLimit> | null;
    /**
     * Zones the new key belongs to
     * @type {Array<string>}
     * @memberof InsertKeyParam1
     */
    ZoneIds?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface InsertLockParam
 */
export interface InsertLockParam {
    /**
     * Lock information
     * @type {LockInsert}
     * @memberof InsertLockParam
     */
    Lock?: LockInsert | null;
    /**
     * Lock options
     * @type {LLockOptionMaskParam}
     * @memberof InsertLockParam
     */
    LockOptions?: LLockOptionMaskParam | null;
    /**
     * Lock relay information
     * @type {LockRelay}
     * @memberof InsertLockParam
     */
    LockRelay?: LockRelay | null;
    /**
     * If true, then lock respects all timelimits and TimeLimitTitleIds doesn\'t need to be given. If false, then lock respects given TimeLimitTitleIds. If no timelimittitle ids are given, then lock isn\'t timelimited. Default is false.
     * @type {boolean}
     * @memberof InsertLockParam
     */
    LockRespectsAllTimeLimits?: boolean;
    /**
     * Security accesses which are set for the new lock
     * @type {Array<LockSecurityAccessInsert>}
     * @memberof InsertLockParam
     */
    SecurityAccesses?: Array<LockSecurityAccessInsert> | null;
    /**
     * Time limit titles for the new lock
     * @type {Array<string>}
     * @memberof InsertLockParam
     */
    TimeLimitTitleIds?: Array<string> | null;
}
/**
 * Parameter for inserting a new lock
 * @export
 * @interface InsertLockParam1
 */
export interface InsertLockParam1 {
    /**
     * Lock information
     * @type {LockInsert}
     * @memberof InsertLockParam1
     */
    Lock?: LockInsert | null;
    /**
     * Security accesses which are set for the new lock
     * @type {Array<LockSecurityAccessInsert>}
     * @memberof InsertLockParam1
     */
    SecurityAccesses?: Array<LockSecurityAccessInsert> | null;
    /**
     * Time limit information for the new lock
     * @type {LockTimeLimit}
     * @memberof InsertLockParam1
     */
    TimeLimit?: LockTimeLimit | null;
    /**
     * Lock relay information
     * @type {LockRelay}
     * @memberof InsertLockParam1
     */
    LockRelay?: LockRelay | null;
}
/**
 * 
 * @export
 * @interface InsertPersonParam
 */
export interface InsertPersonParam {
    /**
     * Person which is added
     * @type {PersonInsert}
     * @memberof InsertPersonParam
     */
    Person?: PersonInsert | null;
    /**
     * Zones which user is linked to
     * @type {Array<string>}
     * @memberof InsertPersonParam
     */
    ZoneIds?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface InsertResult
 */
export interface InsertResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof InsertResult
     */
    PersonIds?: Array<string> | null;
}
/**
 * Parameter for inserting a new security access
 * @export
 * @interface InsertSecurityAccessParam
 */
export interface InsertSecurityAccessParam {
    /**
     * Security access to insert
     * @type {SecurityAccessInsert}
     * @memberof InsertSecurityAccessParam
     */
    SecurityAccess?: SecurityAccessInsert | null;
}
/**
 * Result for succesful insert
 * @export
 * @interface InsertSecurityAccessResult
 */
export interface InsertSecurityAccessResult {
    /**
     * Inserted security access
     * @type {SecurityAccess}
     * @memberof InsertSecurityAccessResult
     */
    SecurityAccess?: SecurityAccess | null;
}
/**
 * 
 * @export
 * @interface InsertTimeLimitTitlesParam
 */
export interface InsertTimeLimitTitlesParam {
    /**
     * Time limit title which is added
     * @type {TimeLimitTitle}
     * @memberof InsertTimeLimitTitlesParam
     */
    TimeLimitTitle?: TimeLimitTitle | null;
    /**
     * Datas which are added for the added time limit title Maximum count is 10
     * @type {Array<TimeLimitData>}
     * @memberof InsertTimeLimitTitlesParam
     */
    TimeLimitData?: Array<TimeLimitData> | null;
}
/**
 * 
 * @export
 * @interface Key
 */
export interface Key {
    /**
     * Description text
     * @type {string}
     * @memberof Key
     */
    Description?: string | null;
    /**
     * Expiration date. Null if the key doesn\'t expire.
     * @type {string}
     * @memberof Key
     */
    ExpireDate?: string | null;
    /**
     * Key Id
     * @type {string}
     * @memberof Key
     */
    FNKey_ID?: string;
    /**
     * Additional info text
     * @type {string}
     * @memberof Key
     */
    InfoText?: string | null;
    /**
     * Key\'s types in bitmask    0 = Unknown    1 = S10 locking system key    2 = S50 locking system key    4 = Phone key    8 = iLoq key    16 = Classic Mifare rfid    32 = Key has Desfire capabilities    64 = Key has Nortec capabilities    128 = Other than iLoq key    256 = 5 Series locking system key    
     * @type {KeyTypeMask}
     * @memberof Key
     */
    KeyTypeMask?: KeyTypeMask;
    /**
     * Person to whom the key is linked to. Null if the key isn\'t linked to anyone.
     * @type {string}
     * @memberof Key
     */
    Person_ID?: string | null;
    /**
     * ID of the real estate where this key belongs to.
     * @type {string}
     * @memberof Key
     */
    RealEstate_ID?: string;
    /**
     * ROM ID
     * @type {string}
     * @memberof Key
     */
    ROM_ID?: string | null;
    /**
     * Stamp. Number consisting of 4 digits written to the physical key.
     * @type {string}
     * @memberof Key
     */
    Stamp: string;
    /**
     * The source of the key labeling (Stamp). Read only.    0 = User-entered    1 = Read from the key. Key labeling (Stamp) can not be edited.    2 = Retrieved from the database    
     * @type {number}
     * @memberof Key
     */
    StampSource?: number;
    /**
     * Current state    0 = Key is in planning state.    1 = Key is handed over to a person    2 = Key is hidden and shouldn\'t be displayed by default    3 = Key is deleted but remains in the system for logging purposes    4 = Key is returned    
     * @type {number}
     * @memberof Key
     */
    State?: number;
    /**
     * RFID Tag. Empty string if not given.
     * @type {string}
     * @memberof Key
     */
    TagKey?: string | null;
    /**
     * The source of the key\'s tagkey enumeration. Read only.      0 = User-entered    1 = Read from the key. Key\'s tagkey can not be edited.    
     * @type {number}
     * @memberof Key
     */
    TagKeySource?: number;
    /**
     * Version information
     * @type {string}
     * @memberof Key
     */
    VersionCode?: string | null;
}
/**
 * 
 * @export
 * @interface Key1
 */
export interface Key1 {
    /**
     * Key Id
     * @type {string}
     * @memberof Key1
     */
    FNKey_ID?: string;
    /**
     * ROM ID
     * @type {string}
     * @memberof Key1
     */
    ROM_ID?: string | null;
    /**
     * Description text
     * @type {string}
     * @memberof Key1
     */
    Description?: string | null;
    /**
     * Expiration date. Null if the key doesn\'t expire.
     * @type {string}
     * @memberof Key1
     */
    ExpireDate?: string | null;
    /**
     * Additional info text
     * @type {string}
     * @memberof Key1
     */
    InfoText?: string | null;
    /**
     * Person to whom the key is linked to. Null if the key isn\'t linked to anyone.
     * @type {string}
     * @memberof Key1
     */
    Person_ID?: string | null;
    /**
     * ID of the real estate where this key belongs to.
     * @type {string}
     * @memberof Key1
     */
    RealEstate_ID?: string;
    /**
     * Stamp. Number consisting of 4 digits written to the physical key.
     * @type {string}
     * @memberof Key1
     */
    Stamp: string;
    /**
     * Current state    0 = Key is in planning state.    1 = Key is handed over to a person    2 = Key is hidden and shouldn\'t be displayed by default    3 = Key is deleted but remains in the system for logging purposes    4 = Key is returned    
     * @type {number}
     * @memberof Key1
     */
    State?: number;
    /**
     * RFID Tag. Empty string if not given.
     * @type {string}
     * @memberof Key1
     */
    TagKey?: string | null;
    /**
     * The source of the key labeling (Stamp). Read only.    0 = User-entered    1 = Read from the key. Key labeling (Stamp) can not be edited.    2 = Retrieved from the database    
     * @type {number}
     * @memberof Key1
     */
    StampSource?: number;
    /**
     * The source of the key\'s tagkey enumeration. Read only.      0 = User-entered    1 = Read from the key. Key\'s tagkey can not be edited.    
     * @type {number}
     * @memberof Key1
     */
    TagKeySource?: number;
    /**
     * Version information.
     * @type {string}
     * @memberof Key1
     */
    VersionCode?: string | null;
}
/**
 * 
 * @export
 * @interface KeyInsert
 */
export interface KeyInsert {
    /**
     * Key ID
     * @type {string}
     * @memberof KeyInsert
     */
    FNKey_ID?: string | null;
    /**
     * Description text
     * @type {string}
     * @memberof KeyInsert
     */
    Description?: string | null;
    /**
     * Expiration date. Null if the key doesn\'t expire.
     * @type {string}
     * @memberof KeyInsert
     */
    ExpireDate?: string | null;
    /**
     * Additional info text
     * @type {string}
     * @memberof KeyInsert
     */
    InfoText?: string | null;
    /**
     * Manufacturing info
     * @type {string}
     * @memberof KeyInsert
     */
    ManufacturingInfo?: string | null;
    /**
     * PIN code consisting of 5 digits. Network modules may contain calendar controls which require this code for access.
     * @type {string}
     * @memberof KeyInsert
     */
    OnlineAccessCode?: string | null;
    /**
     * Person to whom the key is linked to. Null if the key isn\'t linked to anyone.
     * @type {string}
     * @memberof KeyInsert
     */
    Person_ID?: string | null;
    /**
     * ID of the real estate where this key belongs to.
     * @type {string}
     * @memberof KeyInsert
     */
    RealEstate_ID?: string;
    /**
     * ROM ID. Not used in inserting new key.
     * @type {string}
     * @memberof KeyInsert
     */
    ROM_ID?: string | null;
    /**
     * Stamp. Number consisting of 4 digits written to the physical key.
     * @type {string}
     * @memberof KeyInsert
     */
    Stamp?: string | null;
    /**
     * RFID Tag. Empty string if not given.
     * @type {string}
     * @memberof KeyInsert
     */
    TagKey?: string | null;
    /**
     * Version information
     * @type {string}
     * @memberof KeyInsert
     */
    VersionCode?: string | null;
    /**
     * Key type mask. Accepts the following combinations: S10 + iLoqKey (S10 key), S40 + PhoneKey (S50 phone key), S40 + iLoqKey (S50 fob key), S20 + iLoqKey (S5 key)
     * @type {KeyTypeMask}
     * @memberof KeyInsert
     */
    KeyTypeMask?: KeyTypeMask;
}
/**
 * 
 * @export
 * @interface KeyInsert1
 */
export interface KeyInsert1 {
    /**
     * Key ID
     * @type {string}
     * @memberof KeyInsert1
     */
    FNKey_ID?: string | null;
    /**
     * Description text
     * @type {string}
     * @memberof KeyInsert1
     */
    Description?: string | null;
    /**
     * Expiration date. Null if the key doesn\'t expire.
     * @type {string}
     * @memberof KeyInsert1
     */
    ExpireDate?: string | null;
    /**
     * Additional info text
     * @type {string}
     * @memberof KeyInsert1
     */
    InfoText?: string | null;
    /**
     * Manufacturing info
     * @type {string}
     * @memberof KeyInsert1
     */
    ManufacturingInfo?: string | null;
    /**
     * PIN code consisting of 5 digits. Network modules may contain calendar controls which require this code for access.
     * @type {string}
     * @memberof KeyInsert1
     */
    OnlineAccessCode?: string | null;
    /**
     * Person to whom the key is linked to. Null if the key isn\'t linked to anyone.
     * @type {string}
     * @memberof KeyInsert1
     */
    Person_ID?: string | null;
    /**
     * ID of the real estate where this key belongs to.
     * @type {string}
     * @memberof KeyInsert1
     */
    RealEstate_ID?: string;
    /**
     * ROM ID
     * @type {string}
     * @memberof KeyInsert1
     */
    ROM_ID?: string | null;
    /**
     * Stamp. Number consisting of 4 digits written to the physical key.
     * @type {string}
     * @memberof KeyInsert1
     */
    Stamp?: string | null;
    /**
     * RFID Tag. Empty string if not given.
     * @type {string}
     * @memberof KeyInsert1
     */
    TagKey?: string | null;
    /**
     * Version information
     * @type {string}
     * @memberof KeyInsert1
     */
    VersionCode?: string | null;
}
/**
 * 
 * @export
 * @interface KeyPhone
 */
export interface KeyPhone {
    /**
     * Key Id
     * @type {string}
     * @memberof KeyPhone
     */
    FNKey_ID?: string;
    /**
     * Phone number
     * @type {string}
     * @memberof KeyPhone
     */
    PhoneNo?: string | null;
    /**
     * Phone options/state
     * @type {FNKeyPhoneOptionMask}
     * @memberof KeyPhone
     */
    OptionMask?: FNKeyPhoneOptionMask;
    /**
     * Tasks for phone
     * @type {FNKeyPhoneRequestTypeMask}
     * @memberof KeyPhone
     */
    RequestTypeMask?: FNKeyPhoneRequestTypeMask;
    /**
     * Email address which is used instead of sms if OptionMask contains \'UseEmail\'
     * @type {string}
     * @memberof KeyPhone
     */
    Email?: string | null;
}
/**
 * 
 * @export
 * @interface KeyScheduler
 */
export interface KeyScheduler {
    /**
     * Renew type
     * @type {RenewGapType}
     * @memberof KeyScheduler
     */
    RenewGapType?: RenewGapType;
    /**
     * Gap in days/weeks before key is renewed. (depending on RenewGapType) 
     * @type {number}
     * @memberof KeyScheduler
     */
    RenewGapCount?: number;
    /**
     * When renewing ends
     * @type {string}
     * @memberof KeyScheduler
     */
    RenewEndDate?: string;
    /**
     * How long before key\'s expiration it is renewed. Time is in minutes. For example if value is 120, new programming packet is made about 2 hours before expiration. Minimum is 70 minutes.
     * @type {number}
     * @memberof KeyScheduler
     */
    RenewMinute?: number;
}
/**
 * 
 * @export
 * @interface KeyTimeLimit
 */
export interface KeyTimeLimit {
    /**
     * 
     * @type {number}
     * @memberof KeyTimeLimit
     */
    DaylightSaving?: number;
    /**
     * 
     * @type {string}
     * @memberof KeyTimeLimit
     */
    EndDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof KeyTimeLimit
     */
    LimitType?: number;
    /**
     * 
     * @type {string}
     * @memberof KeyTimeLimit
     */
    LNKey_ID?: string;
    /**
     * 
     * @type {string}
     * @memberof KeyTimeLimit
     */
    LNKeyTimeLimit_ID?: string;
    /**
     * 
     * @type {number}
     * @memberof KeyTimeLimit
     */
    OrderNo?: number;
    /**
     * 
     * @type {string}
     * @memberof KeyTimeLimit
     */
    RenewEndDate?: string;
    /**
     * 
     * @type {number}
     * @memberof KeyTimeLimit
     */
    RenewGapCount?: number;
    /**
     * 
     * @type {number}
     * @memberof KeyTimeLimit
     */
    RenewGapType?: number;
    /**
     * 
     * @type {number}
     * @memberof KeyTimeLimit
     */
    RenewMinute?: number;
    /**
     * 
     * @type {string}
     * @memberof KeyTimeLimit
     */
    StartDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof KeyTimeLimit
     */
    WeekDay?: number;
}
/**
 * 
 * @export
 * @interface KeyTimeLimitData
 */
export interface KeyTimeLimitData {
    /**
     * Week days mask to inform when this timelimit is in use    0 = None    1 = Monday    2 = Tuesday    4 = Wednesday    8 = Thursday    16 = Friday    32 = Saturday    64 = Sunday    
     * @type {number}
     * @memberof KeyTimeLimitData
     */
    WeekDayMask?: number;
    /**
     * Start time in milliseconds when this timelimit begins on given weekdays. For example 28 800 000 would be 8:00 in the morning. Must be divisable by 15 minutes.
     * @type {number}
     * @memberof KeyTimeLimitData
     */
    StartTimeMS?: number;
    /**
     * Start time in milliseconds when this timelimit ends on given weekdays For example 57 600 000 would be 16:00 in the afternoon. Must be divisable by 15 minutes.
     * @type {number}
     * @memberof KeyTimeLimitData
     */
    EndTimeMS?: number;
}
/**
 * 
 * @export
 * @interface KeyTimeLimitSlot
 */
export interface KeyTimeLimitSlot {
    /**
     * If slot = 0, this is start date in locking system\'s time zone If slot = 1, this is end date in locking system\'s time zone If slot = 2
     * @type {string}
     * @memberof KeyTimeLimitSlot
     */
    LimitDateLg?: string | null;
    /**
     * Slot in which this time limit is.
     * @type {LNKeyTimelimitSlotNo}
     * @memberof KeyTimeLimitSlot
     */
    SlotNo?: LNKeyTimelimitSlotNo;
    /**
     * TimeLimit data in this slot.
     * @type {Array<KeyTimeLimitData>}
     * @memberof KeyTimeLimitSlot
     */
    TimeLimitData?: Array<KeyTimeLimitData> | null;
    /**
     * TimeLimitTitle ID if any.
     * @type {string}
     * @memberof KeyTimeLimitSlot
     */
    TimeLimitTitle_ID?: string | null;
    /**
     * TimeLimitTitlen loppupäivä lukoston ajassa, tai null jos ei ole määritetty
     * @type {string}
     * @memberof KeyTimeLimitSlot
     */
    TimeLimitTitleEndDateLg?: string | null;
    /**
     * TimeLimitTitlen alkupäivä lukoston ajassa, tai null jos ei ole määritetty
     * @type {string}
     * @memberof KeyTimeLimitSlot
     */
    TimeLimitTitleStartDateLg?: string | null;
}
/**
 * Key type mask. For example 6 would be S50 Phone (2 + 4) MainType: S10/S50/5 Series Physical form: Phone, iLoqKey, External RFid: MifareClassic, MifareDesfire    0 = Unknown    1 = S10 locking system key    2 = S50 locking system key    4 = Phone key    8 = iLoq key    16 = Classic Mifare rfid    32 = Key has Desfire capabilities    64 = Key has Nortec capabilities    128 = Other than iLoq key    256 = 5 Series locking system key    
 * @export
 * @enum {string}
 */
export enum KeyTypeMask {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_4 = 4,
    NUMBER_8 = 8,
    NUMBER_16 = 16,
    NUMBER_32 = 32,
    NUMBER_64 = 64,
    NUMBER_128 = 128,
    NUMBER_256 = 256
}

/**
 * 
 * @export
 * @interface LLockOptionMaskParam
 */
export interface LLockOptionMaskParam {
    /**
     * sets S10CollectAuditTrail option on/off/leaves old value if null
     * @type {boolean}
     * @memberof LLockOptionMaskParam
     */
    S10CollectAuditTrail?: boolean | null;
    /**
     * sets S40AcceptSoftGroup option on/off/leaves old value if null
     * @type {boolean}
     * @memberof LLockOptionMaskParam
     */
    S40AcceptSoftGroup?: boolean | null;
    /**
     * sets S40FlipFlop option on/off/leaves old value if null
     * @type {boolean}
     * @memberof LLockOptionMaskParam
     */
    S40FlipFlop?: boolean | null;
    /**
     * sets S40LoggingOn option on/off/leaves old value if null
     * @type {boolean}
     * @memberof LLockOptionMaskParam
     */
    S40LoggingOn?: boolean | null;
    /**
     * sets S40OnlineRequiredHard option on/off/leaves old value if null
     * @type {boolean}
     * @memberof LLockOptionMaskParam
     */
    S40OnlineRequiredHard?: boolean | null;
    /**
     * sets S40OnlineRequiredSoft option on/off/leaves old value if null
     * @type {boolean}
     * @memberof LLockOptionMaskParam
     */
    S40OnlineRequiredSoft?: boolean | null;
    /**
     * sets SaveOnlineLockAuditTrail option on/off/leaves old value if null
     * @type {boolean}
     * @memberof LLockOptionMaskParam
     */
    SaveOnlineLockAuditTrail?: boolean | null;
}
/**
 * Key time limit slot no    0 = S10/S50 start date or S10 timelimit    1 = S10/S50 end date or S10 timelimit    2 = S50 timelimittitle link    
 * @export
 * @enum {string}
 */
export enum LNKeyTimelimitSlotNo {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

/**
 * 
 * @export
 * @interface Lock
 */
export interface Lock {
    /**
     * Is clock installed on physical lock
     * @type {boolean}
     * @memberof Lock
     */
    ClockInstalled?: boolean;
    /**
     * UTC date when the clock was installed if ClockInstalled = true. Null if information isn\'t available
     * @type {string}
     * @memberof Lock
     */
    ClockInstalledDateUtc?: string | null;
    /**
     * Lock\'s description
     * @type {string}
     * @memberof Lock
     */
    Description?: string | null;
    /**
     * Door\'s opening direction
     * @type {string}
     * @memberof Lock
     */
    Direction?: string | null;
    /**
     * Door\'s thickness
     * @type {string}
     * @memberof Lock
     */
    DoorThickness?: string | null;
    /**
     * Door\'s type
     * @type {string}
     * @memberof Lock
     */
    DoorType?: string | null;
    /**
     * Ext
     * @type {number}
     * @memberof Lock
     */
    Ext?: number;
    /**
     * Description of Ext
     * @type {string}
     * @memberof Lock
     */
    ExtDescription?: string | null;
    /**
     * Extension piece
     * @type {string}
     * @memberof Lock
     */
    ExtentionPiece?: string | null;
    /**
     * Door\'s handiness
     * @type {string}
     * @memberof Lock
     */
    Handed?: string | null;
    /**
     * Lock\'s key chamber type
     * @type {string}
     * @memberof Lock
     */
    KeyChamber?: string | null;
    /**
     * Location code
     * @type {string}
     * @memberof Lock
     */
    LocationCode?: string | null;
    /**
     * Lock framework
     * @type {string}
     * @memberof Lock
     */
    LockFramework?: string | null;
    /**
     * Lock framework depth
     * @type {string}
     * @memberof Lock
     */
    LockFrameworkDepth?: string | null;
    /**
     * Lock\'s unique identifier
     * @type {string}
     * @memberof Lock
     */
    FLock_ID?: string;
    /**
     * Locking object
     * @type {string}
     * @memberof Lock
     */
    LockingObject?: string | null;
    /**
     * Lock type
     * @type {number}
     * @memberof Lock
     */
    LockType?: number;
    /**
     * Mounting
     * @type {string}
     * @memberof Lock
     */
    Mounting?: string | null;
    /**
     * Unique identifier for network module device if lock is connected to one.
     * @type {string}
     * @memberof Lock
     */
    NetworkModuleDevice_ID?: string | null;
    /**
     * Other equipment
     * @type {string}
     * @memberof Lock
     */
    OtherEquipment?: string | null;
    /**
     * Lock\'s physical state
     * @type {number}
     * @memberof Lock
     */
    PhysicalState?: number;
    /**
     * RealEstate Id
     * @type {string}
     * @memberof Lock
     */
    RealEstate_Id?: string;
    /**
     * Stamp
     * @type {string}
     * @memberof Lock
     */
    Stamp?: string | null;
    /**
     * Zone Id
     * @type {string}
     * @memberof Lock
     */
    Zone_ID?: string | null;
    /**
     * Data version
     * @type {number}
     * @memberof Lock
     */
    DataVersion?: number;
    /**
     * Default program station id if available.
     * @type {string}
     * @memberof Lock
     */
    DefaultProgramStationFProgKey_ID?: string | null;
    /**
     * Hardware version
     * @type {number}
     * @memberof Lock
     */
    HwVersion?: number;
    /**
     * Floor plan ID if lock is used in floor plan
     * @type {string}
     * @memberof Lock
     */
    FloorPlan_ID?: string | null;
    /**
     * X coordinate on floor plan.
     * @type {number}
     * @memberof Lock
     */
    FloorPlanPointX?: number;
    /**
     * Y coordinate on floor plan
     * @type {number}
     * @memberof Lock
     */
    FloorPlanPointY?: number;
    /**
     * Lock code
     * @type {string}
     * @memberof Lock
     */
    LockCode?: string | null;
    /**
     * Lock settings
     * @type {string}
     * @memberof Lock
     */
    LockSettings?: string | null;
    /**
     * Lock state
     * @type {number}
     * @memberof Lock
     */
    LockState?: number;
    /**
     * MAC address
     * @type {string}
     * @memberof Lock
     */
    MAC?: string | null;
    /**
     * Manufacturing info
     * @type {string}
     * @memberof Lock
     */
    ManufacturingInfo?: string | null;
    /**
     * Mech version
     * @type {number}
     * @memberof Lock
     */
    MechVersion?: number;
    /**
     * Lock serial number
     * @type {number}
     * @memberof Lock
     */
    SerialNumber?: number;
    /**
     * Lock software version
     * @type {number}
     * @memberof Lock
     */
    SwVersion?: number;
}
/**
 * 
 * @export
 * @interface LockGroup
 */
export interface LockGroup {
    /**
     * Adapter version which user has set in the locking system settings.    0 = Adapter doesn\'t exist or it isn\'t recognized    1 = Adapter which doesn\'t have flash memory.    2 = Adapter which supports flash memory (if installed)    4 = Adapter which supports the making of laundry room keys (programming packet may contain key\'s name)    
     * @type {number}
     * @memberof LockGroup
     */
    AdapterVersion?: number;
    /**
     * Street address/city where the locking system is in use
     * @type {string}
     * @memberof LockGroup
     */
    Address?: string | null;
    /**
     * Classification
     * @type {string}
     * @memberof LockGroup
     */
    Classification?: string | null;
    /**
     * Contact person\'s name
     * @type {string}
     * @memberof LockGroup
     */
    ContactPerson?: string | null;
    /**
     * Locking system\'s country code. For example \"FIN\" for Finnish.
     * @type {string}
     * @memberof LockGroup
     */
    CountryCode?: string | null;
    /**
     * Customer ID who owns the lockgroup
     * @type {string}
     * @memberof LockGroup
     */
    Customer_ID?: string;
    /**
     * Description
     * @type {string}
     * @memberof LockGroup
     */
    Description?: string | null;
    /**
     * Date when locking system expires. Null if doesn\'t expire.
     * @type {string}
     * @memberof LockGroup
     */
    ExpireDateUTC?: string | null;
    /**
     * User set image which is displayed on the start page of iLOQ Manager. Null if not set.
     * @type {string}
     * @memberof LockGroup
     */
    FrontImage?: string | null;
    /**
     * General user written info text.
     * @type {string}
     * @memberof LockGroup
     */
    InfoText?: string | null;
    /**
     * ID
     * @type {string}
     * @memberof LockGroup
     */
    LockGroup_ID?: string;
    /**
     * Name of the locking system
     * @type {string}
     * @memberof LockGroup
     */
    Name?: string | null;
    /**
     * Option mask of the settings in use in the locking system.    0 = None    1 = Key\'s, which has been handed over, person can be changed without returning the key.    2 = Zones are in use.    4 = Real estates are in use    8 = Is Tag field visible for key    16 = Can keys\' tags be edited    32 = Code groups are in use    64 = Lock\'s time limits are split into key\'s time limits    128 = Key\'s PIN code in use    256 = Is locking system in 24 bit mode    512 = Addition for CanUseSpace value. Are zones in use on keys and persons    1024 = Can set key\'s packet valid from date    2048 = Is Public API in use    4096 = Is S50 locking system in use    8192 = Is S10 locking system in use    16384 = Can locking system use API access rights    32768 = Are external RFID tags in use    65536 = Is 5 Series locking system in use    131072 = Is zone specific black list in use    
     * @type {number}
     * @memberof LockGroup
     */
    OptionMask?: number;
    /**
     * Name of the person who is responsible for programming tasks
     * @type {string}
     * @memberof LockGroup
     */
    ProgrammingAdmin?: string | null;
    /**
     * Is locking system in use or not    0 = Locking system is active (in use)    1 = Locking system is not active (not in use)    
     * @type {number}
     * @memberof LockGroup
     */
    State?: number;
    /**
     * Name of the time zone the locking system uses. For example \'FLE Standard Time\'
     * @type {string}
     * @memberof LockGroup
     */
    TimeZoneStandardName?: string | null;
}
/**
 * 
 * @export
 * @interface LockInsert
 */
export interface LockInsert {
    /**
     * ID
     * @type {string}
     * @memberof LockInsert
     */
    FLock_ID?: string | null;
    /**
     * Is clock installed on physical lock
     * @type {boolean}
     * @memberof LockInsert
     */
    ClockInstalled?: boolean;
    /**
     * UTC date when the clock was installed if ClockInstalled = true. Null if information isn\'t available
     * @type {string}
     * @memberof LockInsert
     */
    ClockInstalledDateUtc?: string | null;
    /**
     * Lock\'s description
     * @type {string}
     * @memberof LockInsert
     */
    Description?: string | null;
    /**
     * Door\'s opening direction
     * @type {string}
     * @memberof LockInsert
     */
    Direction?: string | null;
    /**
     * Door\'s thickness
     * @type {string}
     * @memberof LockInsert
     */
    DoorThickness?: string | null;
    /**
     * Door\'s type
     * @type {string}
     * @memberof LockInsert
     */
    DoorType?: string | null;
    /**
     * Ext
     * @type {number}
     * @memberof LockInsert
     */
    Ext?: number;
    /**
     * Description of Ext
     * @type {string}
     * @memberof LockInsert
     */
    ExtDescription?: string | null;
    /**
     * Extension piece
     * @type {string}
     * @memberof LockInsert
     */
    ExtentionPiece?: string | null;
    /**
     * Door\'s handiness
     * @type {string}
     * @memberof LockInsert
     */
    Handed?: string | null;
    /**
     * Lock\'s key chamber type
     * @type {string}
     * @memberof LockInsert
     */
    KeyChamber?: string | null;
    /**
     * Location code
     * @type {string}
     * @memberof LockInsert
     */
    LocationCode?: string | null;
    /**
     * Lock framework
     * @type {string}
     * @memberof LockInsert
     */
    LockFramework?: string | null;
    /**
     * Lock framework depth
     * @type {string}
     * @memberof LockInsert
     */
    LockFrameworkDepth?: string | null;
    /**
     * Locking object
     * @type {string}
     * @memberof LockInsert
     */
    LockingObject?: string | null;
    /**
     * Lock type
     * @type {number}
     * @memberof LockInsert
     */
    LockType?: number;
    /**
     * Mounting
     * @type {string}
     * @memberof LockInsert
     */
    Mounting?: string | null;
    /**
     * Other equipment
     * @type {string}
     * @memberof LockInsert
     */
    OtherEquipment?: string | null;
    /**
     * RealEstate Id
     * @type {string}
     * @memberof LockInsert
     */
    RealEstate_ID?: string;
    /**
     * Stamp
     * @type {string}
     * @memberof LockInsert
     */
    Stamp?: string | null;
    /**
     * Zone Id
     * @type {string}
     * @memberof LockInsert
     */
    Zone_ID?: string | null;
    /**
     * Data version
     * @type {number}
     * @memberof LockInsert
     */
    DataVersion?: number;
    /**
     * Default program station id if available.
     * @type {string}
     * @memberof LockInsert
     */
    DefaultProgramStationFProgKey_ID?: string | null;
    /**
     * Hardware version
     * @type {number}
     * @memberof LockInsert
     */
    HwVersion?: number;
    /**
     * Location picture id if lock is used in location picture
     * @type {string}
     * @memberof LockInsert
     */
    FloorPlan_ID?: string | null;
    /**
     * X coordinate on location picture.
     * @type {number}
     * @memberof LockInsert
     */
    FloorPlanPointX?: number;
    /**
     * Y coordinate on location picture
     * @type {number}
     * @memberof LockInsert
     */
    FloorPlanPointY?: number;
    /**
     * Lock code
     * @type {string}
     * @memberof LockInsert
     */
    LockCode?: string | null;
    /**
     * Lock settings
     * @type {string}
     * @memberof LockInsert
     */
    LockSettings?: string | null;
    /**
     * Manufacturing info
     * @type {string}
     * @memberof LockInsert
     */
    ManufacturingInfo?: string | null;
    /**
     * Mech version
     * @type {number}
     * @memberof LockInsert
     */
    MechVersion?: number;
    /**
     * Lock secret
     * @type {string}
     * @memberof LockInsert
     */
    Secret?: string | null;
    /**
     * Lock serial number
     * @type {number}
     * @memberof LockInsert
     */
    SerialNumber?: number;
    /**
     * Lock software version
     * @type {number}
     * @memberof LockInsert
     */
    SwVersion?: number;
}
/**
 * 
 * @export
 * @interface LockLogData
 */
export interface LockLogData {
    /**
     * Lock Id 
     * @type {string}
     * @memberof LockLogData
     */
    FLock_ID?: string;
    /**
     * Lock\'s location code
     * @type {string}
     * @memberof LockLogData
     */
    LocationCode?: string | null;
    /**
     * Lock\'s Locking object info
     * @type {string}
     * @memberof LockLogData
     */
    LockingObject?: string | null;
    /**
     * Date And time when log was read
     * @type {string}
     * @memberof LockLogData
     */
    ReadingDate?: string | null;
    /**
     * Counter of how many times lock has been used
     * @type {number}
     * @memberof LockLogData
     */
    GoingCounter?: number;
    /**
     * Key\'s ID which accessed lock
     * @type {string}
     * @memberof LockLogData
     */
    FNKey_ID?: string | null;
    /**
     * Date And time when Key accessed lock (UTC time)
     * @type {string}
     * @memberof LockLogData
     */
    GoingDate?: string | null;
    /**
     * Type of the access. Bit mask of possible values. For example 12 would be a successful S50 phone access
     * @type {DeviceLogTypeMask}
     * @memberof LockLogData
     */
    AccessTypeMask?: DeviceLogTypeMask;
    /**
     * Error code. 0 means no error
     * @type {number}
     * @memberof LockLogData
     */
    ErrorCode?: number;
    /**
     * Key\'s KeyId info
     * @type {number}
     * @memberof LockLogData
     */
    KeyId?: number;
    /**
     * Log ID. Deprecated field, use DeviceLog_ID instead.
     * @type {string}
     * @memberof LockLogData
     */
    FLockLogFNKey_ID?: string;
    /**
     * Log ID
     * @type {string}
     * @memberof LockLogData
     */
    DeviceLog_ID?: string;
    /**
     * Time when log arrived to the server and was added to the database
     * @type {string}
     * @memberof LockLogData
     */
    TimestampUtc?: string;
    /**
     * Locking system ID
     * @type {string}
     * @memberof LockLogData
     */
    LockGroup_ID?: string;
}
/**
 * 
 * @export
 * @interface LockRelay
 */
export interface LockRelay {
    /**
     * Lock K1 relay work delay in milliseconds  
     * @type {number}
     * @memberof LockRelay
     */
    RelayK1Delay?: number;
    /**
     * K2 relay work delay in milliseconds
     * @type {number}
     * @memberof LockRelay
     */
    RelayK2Delay?: number;
    /**
     * Mask of which relays are in use
     * @type {number}
     * @memberof LockRelay
     */
    RelayMask?: number;
    /**
     * Relay mode
     * @type {RelayMode}
     * @memberof LockRelay
     */
    RelayMode?: RelayMode;
    /**
     * Name data
     * @type {string}
     * @memberof LockRelay
     */
    RelayNameData?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LockRelay
     */
    RelayPacket?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LockRelay
     */
    RelayQuasarDelay?: number;
    /**
     * Quasar mode
     * @type {QuasarModeMask}
     * @memberof LockRelay
     */
    RelayQuasarMode?: QuasarModeMask;
}
/**
 * 
 * @export
 * @interface LockSecurityAccessInsert
 */
export interface LockSecurityAccessInsert {
    /**
     * 
     * @type {number}
     * @memberof LockSecurityAccessInsert
     */
    RelayMask?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LockSecurityAccessInsert
     */
    SecurityAccess_ID?: string;
}
/**
 * Message requests for locks connected to network module    0 = No message requests    1 = Log reading has been requested    2 = Connection test has been requested    4 = There is a lock programming task waiting for the lock    8 = There are calendar changes for the lock    16 = Network module lock has programmed a key. Network modules which are capable of programming keys will be sent a message that they should update their list of keys which have programming tasks.    32 = Key has been ordered. Network modules which are capable of programming keys will be sent a message that they should update their list of keys which have programming tasks.    64 = Key have been returned. Network modules which are capable of programming keys will be sent a message that they should update their list of keys which have programming tasks.    128 = Reboot of network module is requested    256 = Firmware update is requested    512 = Setup is requested    1024 = Retrieval of relay\'s logs    2048 = Retrieval of network module\'s system logs    4096 = Retrieval of Lock\'s diagnostics logs    -1 = Messages can\'t be sent    
 * @export
 * @enum {string}
 */
export enum LockSocketRequestTypeMask {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_4 = 4,
    NUMBER_8 = 8,
    NUMBER_16 = 16,
    NUMBER_32 = 32,
    NUMBER_64 = 64,
    NUMBER_128 = 128,
    NUMBER_256 = 256,
    NUMBER_512 = 512,
    NUMBER_1024 = 1024,
    NUMBER_2048 = 2048,
    NUMBER_4096 = 4096,
    NUMBER_MINUS_1 = -1
}

/**
 * 
 * @export
 * @interface LockTimeLimit
 */
export interface LockTimeLimit {
    /**
     * 
     * @type {boolean}
     * @memberof LockTimeLimit
     */
    HighSecurity?: boolean;
    /**
     *     0 = Lock doesn\'t care about key\'s time limits. Default.    1 = Lock handles both time limits              Obsolete. Use values 2 and 4 instead    2 = Lock handles key\'s time limit 1    4 = Lock handles key\'s time limit 2    
     * @type {number}
     * @memberof LockTimeLimit
     */
    TimeLimitMask?: number;
}
/**
 * 
 * @export
 * @interface LockUpdate
 */
export interface LockUpdate {
    /**
     * Lock\'s description
     * @type {string}
     * @memberof LockUpdate
     */
    Description?: string | null;
    /**
     * Door\'s opening direction
     * @type {string}
     * @memberof LockUpdate
     */
    Direction?: string | null;
    /**
     * Door\'s thickness
     * @type {string}
     * @memberof LockUpdate
     */
    DoorThickness?: string | null;
    /**
     * Door\'s type
     * @type {string}
     * @memberof LockUpdate
     */
    DoorType?: string | null;
    /**
     * Ext
     * @type {number}
     * @memberof LockUpdate
     */
    Ext?: number;
    /**
     * Description of Ext
     * @type {string}
     * @memberof LockUpdate
     */
    ExtDescription?: string | null;
    /**
     * Extension piece
     * @type {string}
     * @memberof LockUpdate
     */
    ExtentionPiece?: string | null;
    /**
     * Door\'s handiness
     * @type {string}
     * @memberof LockUpdate
     */
    Handed?: string | null;
    /**
     * Lock\'s key chamber type
     * @type {string}
     * @memberof LockUpdate
     */
    KeyChamber?: string | null;
    /**
     * Location code
     * @type {string}
     * @memberof LockUpdate
     */
    LocationCode?: string | null;
    /**
     * Lock framework
     * @type {string}
     * @memberof LockUpdate
     */
    LockFramework?: string | null;
    /**
     * Lock framework depth
     * @type {string}
     * @memberof LockUpdate
     */
    LockFrameworkDepth?: string | null;
    /**
     * Lock\'s unique identifier
     * @type {string}
     * @memberof LockUpdate
     */
    FLock_ID?: string;
    /**
     * Locking object
     * @type {string}
     * @memberof LockUpdate
     */
    LockingObject?: string | null;
    /**
     * Lock type
     * @type {number}
     * @memberof LockUpdate
     */
    LockType?: number;
    /**
     * Mounting
     * @type {string}
     * @memberof LockUpdate
     */
    Mounting?: string | null;
    /**
     * Other equipment
     * @type {string}
     * @memberof LockUpdate
     */
    OtherEquipment?: string | null;
    /**
     * Lock\'s state
     * @type {number}
     * @memberof LockUpdate
     */
    State?: number;
    /**
     * Stamp
     * @type {string}
     * @memberof LockUpdate
     */
    Stamp?: string | null;
    /**
     * Zone Id
     * @type {string}
     * @memberof LockUpdate
     */
    Zone_ID?: string | null;
    /**
     * Default program station id if available.
     * @type {string}
     * @memberof LockUpdate
     */
    DefaultProgramStationFProgKey_ID?: string | null;
}
/**
 * 
 * @export
 * @interface NetworkModule
 */
export interface NetworkModule {
    /**
     * Adapter number
     * @type {string}
     * @memberof NetworkModule
     */
    AdapterNr?: string | null;
    /**
     * Adapter version
     * @type {string}
     * @memberof NetworkModule
     */
    AdapterVersion?: string | null;
    /**
     * Allowed IP
     * @type {string}
     * @memberof NetworkModule
     */
    AllowedIP?: string | null;
    /**
     * Allowed socket request mask
     * @type {AllowedSocketRequestTypeMask}
     * @memberof NetworkModule
     */
    AllowedSocketRequest?: AllowedSocketRequestTypeMask;
    /**
     * Board hot spot
     * @type {number}
     * @memberof NetworkModule
     */
    BoardHotSpot?: number;
    /**
     * Board settings
     * @type {string}
     * @memberof NetworkModule
     */
    BoardSettings?: string | null;
    /**
     * Date when calendar data was modified
     * @type {string}
     * @memberof NetworkModule
     */
    CalendarDataModifiedDate?: string | null;
    /**
     * Date when calendar data was received
     * @type {string}
     * @memberof NetworkModule
     */
    CalendarDataReceivedDate?: string | null;
    /**
     * Calendar data state
     * @type {EnuCalendarDataState}
     * @memberof NetworkModule
     */
    CalendarDataState?: EnuCalendarDataState;
    /**
     * Description
     * @type {string}
     * @memberof NetworkModule
     */
    Description?: string | null;
    /**
     * Device limit count
     * @type {number}
     * @memberof NetworkModule
     */
    DeviceLimitCount?: number;
    /**
     * Network module ID
     * @type {string}
     * @memberof NetworkModule
     */
    FProgKey_ID?: string;
    /**
     * Network module\'s ip address
     * @type {string}
     * @memberof NetworkModule
     */
    IPAddress?: string | null;
    /**
     * Network module\'s ip address if user has defined it.
     * @type {string}
     * @memberof NetworkModule
     */
    IPAddressUserDefined?: string | null;
    /**
     * Key id
     * @type {string}
     * @memberof NetworkModule
     */
    KeyId?: string | null;
    /**
     * Programming packet list received date
     * @type {string}
     * @memberof NetworkModule
     */
    KeyProgPacketListReceivedDate?: string | null;
    /**
     * License mode
     * @type {number}
     * @memberof NetworkModule
     */
    LicenseMode?: number;
    /**
     * Location picture ID
     * @type {string}
     * @memberof NetworkModule
     */
    LocationPicture_ID?: string | null;
    /**
     * Additional attributes if linked to location picture
     * @type {string}
     * @memberof NetworkModule
     */
    LocationPointAttributes?: string | null;
    /**
     * Location point X coordinate if linked to location picture
     * @type {number}
     * @memberof NetworkModule
     */
    LocationPointX?: number;
    /**
     * Location point Y coordinate if linked to location picture
     * @type {number}
     * @memberof NetworkModule
     */
    LocationPointY?: number;
    /**
     * Connection date
     * @type {string}
     * @memberof NetworkModule
     */
    OnlineConnectionDate?: string | null;
    /**
     * Key
     * @type {string}
     * @memberof NetworkModule
     */
    OnlineKey?: string | null;
    /**
     * Mac address
     * @type {string}
     * @memberof NetworkModule
     */
    OnlineMacAddress?: string | null;
    /**
     * Software version
     * @type {string}
     * @memberof NetworkModule
     */
    OnlineSoftwareVersion?: string | null;
    /**
     * Network module\'s port
     * @type {number}
     * @memberof NetworkModule
     */
    Port?: number;
    /**
     * Network module\'s port if user has defined it.
     * @type {number}
     * @memberof NetworkModule
     */
    PortUserDefined?: number | null;
    /**
     * Real estate id
     * @type {string}
     * @memberof NetworkModule
     */
    RealEstate_ID?: string | null;
    /**
     * Request type
     * @type {LockSocketRequestTypeMask}
     * @memberof NetworkModule
     */
    RequestType?: LockSocketRequestTypeMask;
    /**
     * Information related to request type, for example reboot time if reboot is requested
     * @type {string}
     * @memberof NetworkModule
     */
    RequestTypeInfo?: string | null;
    /**
     * State
     * @type {PniProgrammingKeyState}
     * @memberof NetworkModule
     */
    State?: PniProgrammingKeyState;
    /**
     * state information
     * @type {FprogKeyStateMask}
     * @memberof NetworkModule
     */
    StateMask?: FprogKeyStateMask;
    /**
     * Type
     * @type {PniProgrammingKeyType}
     * @memberof NetworkModule
     */
    Type?: PniProgrammingKeyType;
    /**
     * Zone id
     * @type {string}
     * @memberof NetworkModule
     */
    Zone_ID?: string | null;
}
/**
 * 
 * @export
 * @interface NetworkModuleDevice
 */
export interface NetworkModuleDevice {
    /**
     * Network module ID
     * @type {string}
     * @memberof NetworkModuleDevice
     */
    FProgKey_ID?: string;
    /**
     * Device name
     * @type {string}
     * @memberof NetworkModuleDevice
     */
    Name?: string | null;
    /**
     * ID
     * @type {string}
     * @memberof NetworkModuleDevice
     */
    NetworkModuleDevice_ID?: string;
    /**
     * Serial number
     * @type {string}
     * @memberof NetworkModuleDevice
     */
    SerialNo?: string | null;
    /**
     * Software version
     * @type {string}
     * @memberof NetworkModuleDevice
     */
    SoftwareVersion?: string | null;
    /**
     * Type
     * @type {NetworkModuleDeviceType}
     * @memberof NetworkModuleDevice
     */
    Type?: NetworkModuleDeviceType;
}
/**
 * 
 * @export
 * @interface NetworkModuleDeviceRelay
 */
export interface NetworkModuleDeviceRelay {
    /**
     * Is relay in use
     * @type {number}
     * @memberof NetworkModuleDeviceRelay
     */
    InUse?: number;
    /**
     * Name
     * @type {string}
     * @memberof NetworkModuleDeviceRelay
     */
    Name?: string | null;
    /**
     * Network module device ID
     * @type {string}
     * @memberof NetworkModuleDeviceRelay
     */
    NetworkModuleDevice_ID?: string;
    /**
     * Relay ID
     * @type {string}
     * @memberof NetworkModuleDeviceRelay
     */
    NetworkModuleDeviceRelay_ID?: string;
    /**
     * Relay number
     * @type {number}
     * @memberof NetworkModuleDeviceRelay
     */
    RelayNo?: number;
}
/**
 * Type for the device connected to network module    0 = Unknown device    1 = Old network module for S10    2 = Bridge module for S10 locking system    3 = N102 door module for S10 locking system    4 = Hot spot module for S10 locking system    5 = Lock    6 = Relay    7 = Idesco keyboard    8 = Switch (inputdevice)    9 = N501 door module for 5 Series locking system.    10 = N504 hotspot for 5 Series locking system.    11 = N502 door module for 5 Series locking system.    12 = Unknown lock. This reprents a lock which isn\'t found in this locking system. So it can be an empty lock or a lock which is wrongly connected and belongs to another locking system.    13 = N505 hotspot for 5 Series locking system.    
 * @export
 * @enum {string}
 */
export enum NetworkModuleDeviceType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6,
    NUMBER_7 = 7,
    NUMBER_8 = 8,
    NUMBER_9 = 9,
    NUMBER_10 = 10,
    NUMBER_11 = 11,
    NUMBER_12 = 12,
    NUMBER_13 = 13
}

/**
 * 
 * @export
 * @interface Person
 */
export interface Person {
    /**
     * Person ID
     * @type {string}
     * @memberof Person
     */
    Person_ID?: string;
    /**
     * Code identifying user. For example social security number.
     * @type {string}
     * @memberof Person
     */
    PersonCode?: string | null;
    /**
     * Street address 
     * @type {string}
     * @memberof Person
     */
    Address?: string | null;
    /**
     * Company where person works
     * @type {string}
     * @memberof Person
     */
    CompanyName?: string | null;
    /**
     * General contact info field
     * @type {string}
     * @memberof Person
     */
    ContactInfo?: string | null;
    /**
     * Country where person lives
     * @type {string}
     * @memberof Person
     */
    Country?: string | null;
    /**
     * Description
     * @type {string}
     * @memberof Person
     */
    Description?: string | null;
    /**
     * Email address
     * @type {string}
     * @memberof Person
     */
    eMail?: string | null;
    /**
     * Optional date when user\'s work contract ends.
     * @type {string}
     * @memberof Person
     */
    EmploymentEndDate?: string | null;
    /**
     * Is person editable
     * @type {boolean}
     * @memberof Person
     */
    ExternalCanEdit?: boolean;
    /**
     * Person\'s identifier if person is imported to iLOQ from external system.
     * @type {string}
     * @memberof Person
     */
    ExternalPersonId?: string | null;
    /**
     * First names
     * @type {string}
     * @memberof Person
     */
    FirstName?: string | null;
    /**
     * Last name
     * @type {string}
     * @memberof Person
     */
    LastName?: string | null;
    /**
     * Phone number 1
     * @type {string}
     * @memberof Person
     */
    Phone1?: string | null;
    /**
     * Phone number 2
     * @type {string}
     * @memberof Person
     */
    Phone2?: string | null;
    /**
     * Phone number 3
     * @type {string}
     * @memberof Person
     */
    Phone3?: string | null;
    /**
     * City or post office info
     * @type {string}
     * @memberof Person
     */
    PostOffice?: string | null;
    /**
     * State. Is person in use or not in use.
     * @type {PniPersonState}
     * @memberof Person
     */
    State?: PniPersonState;
    /**
     * Work title in the company.
     * @type {string}
     * @memberof Person
     */
    WorkTitle?: string | null;
    /**
     * Zip code
     * @type {string}
     * @memberof Person
     */
    ZipCode?: string | null;
}
/**
 * 
 * @export
 * @interface PersonInsert
 */
export interface PersonInsert {
    /**
     * ID
     * @type {string}
     * @memberof PersonInsert
     */
    Person_ID?: string | null;
    /**
     * Code identifying user. For example social security number.
     * @type {string}
     * @memberof PersonInsert
     */
    PersonCode: string;
    /**
     * Street address 
     * @type {string}
     * @memberof PersonInsert
     */
    Address?: string | null;
    /**
     * Company where person works
     * @type {string}
     * @memberof PersonInsert
     */
    CompanyName?: string | null;
    /**
     * General contact info field
     * @type {string}
     * @memberof PersonInsert
     */
    ContactInfo?: string | null;
    /**
     * Country where person lives
     * @type {string}
     * @memberof PersonInsert
     */
    Country?: string | null;
    /**
     * Description
     * @type {string}
     * @memberof PersonInsert
     */
    Description?: string | null;
    /**
     * Email address
     * @type {string}
     * @memberof PersonInsert
     */
    eMail?: string | null;
    /**
     * Optional date when user\'s work contract ends.
     * @type {string}
     * @memberof PersonInsert
     */
    EmploymentEndDate?: string | null;
    /**
     * Is person editable
     * @type {boolean}
     * @memberof PersonInsert
     */
    ExternalCanEdit?: boolean;
    /**
     * Person\'s identifier if person is imported to iLOQ from external system.
     * @type {string}
     * @memberof PersonInsert
     */
    ExternalPersonId?: string | null;
    /**
     * First names
     * @type {string}
     * @memberof PersonInsert
     */
    FirstName?: string | null;
    /**
     * Last name
     * @type {string}
     * @memberof PersonInsert
     */
    LastName?: string | null;
    /**
     * Phone number 1
     * @type {string}
     * @memberof PersonInsert
     */
    Phone1?: string | null;
    /**
     * Phone number 2
     * @type {string}
     * @memberof PersonInsert
     */
    Phone2?: string | null;
    /**
     * Phone number 3
     * @type {string}
     * @memberof PersonInsert
     */
    Phone3?: string | null;
    /**
     * City or post office info
     * @type {string}
     * @memberof PersonInsert
     */
    PostOffice?: string | null;
    /**
     * State. Is person in use or not in use.
     * @type {PniPersonState}
     * @memberof PersonInsert
     */
    State?: PniPersonState;
    /**
     * Work title in the company.
     * @type {string}
     * @memberof PersonInsert
     */
    WorkTitle?: string | null;
    /**
     * Zip code
     * @type {string}
     * @memberof PersonInsert
     */
    ZipCode?: string | null;
}
/**
 * 
 * @export
 * @interface PersonRole
 */
export interface PersonRole {
    /**
     * ID
     * @type {string}
     * @memberof PersonRole
     */
    PersonRole_ID?: string;
    /**
     * Name
     * @type {string}
     * @memberof PersonRole
     */
    Name?: string | null;
    /**
     * Description
     * @type {string}
     * @memberof PersonRole
     */
    Description?: string | null;
}
/**
 * 
 * @export
 * @interface PersonUpdate
 */
export interface PersonUpdate {
    /**
     * Person ID
     * @type {string}
     * @memberof PersonUpdate
     */
    Person_ID?: string;
    /**
     * Code identifying user. For example social security number.
     * @type {string}
     * @memberof PersonUpdate
     */
    PersonCode?: string | null;
    /**
     * Street address 
     * @type {string}
     * @memberof PersonUpdate
     */
    Address?: string | null;
    /**
     * Company where person works
     * @type {string}
     * @memberof PersonUpdate
     */
    CompanyName?: string | null;
    /**
     * General contact info field
     * @type {string}
     * @memberof PersonUpdate
     */
    ContactInfo?: string | null;
    /**
     * Country where person lives
     * @type {string}
     * @memberof PersonUpdate
     */
    Country?: string | null;
    /**
     * Description
     * @type {string}
     * @memberof PersonUpdate
     */
    Description?: string | null;
    /**
     * Email address
     * @type {string}
     * @memberof PersonUpdate
     */
    eMail?: string | null;
    /**
     * Optional date when user\'s work contract ends.
     * @type {string}
     * @memberof PersonUpdate
     */
    EmploymentEndDate?: string | null;
    /**
     * Is person editable
     * @type {boolean}
     * @memberof PersonUpdate
     */
    ExternalCanEdit?: boolean;
    /**
     * Person\'s identifier if person is imported to iLOQ from external system.
     * @type {string}
     * @memberof PersonUpdate
     */
    ExternalPersonId?: string | null;
    /**
     * First names
     * @type {string}
     * @memberof PersonUpdate
     */
    FirstName?: string | null;
    /**
     * Last name
     * @type {string}
     * @memberof PersonUpdate
     */
    LastName?: string | null;
    /**
     * Phone number 1
     * @type {string}
     * @memberof PersonUpdate
     */
    Phone1?: string | null;
    /**
     * Phone number 2
     * @type {string}
     * @memberof PersonUpdate
     */
    Phone2?: string | null;
    /**
     * Phone number 3
     * @type {string}
     * @memberof PersonUpdate
     */
    Phone3?: string | null;
    /**
     * City or post office info
     * @type {string}
     * @memberof PersonUpdate
     */
    PostOffice?: string | null;
    /**
     * State. Is person in use or not in use. Read only. Can\'t be modified.
     * @type {PniPersonState}
     * @memberof PersonUpdate
     */
    State?: PniPersonState;
    /**
     * Work title in the company.
     * @type {string}
     * @memberof PersonUpdate
     */
    WorkTitle?: string | null;
    /**
     * Zip code
     * @type {string}
     * @memberof PersonUpdate
     */
    ZipCode?: string | null;
}
/**
 * CanDeletePerson results    0 = Person can be deleted    1 = Person has active keys which means keys must be returned before deleting person    2 = Person has active user account in the locking system. Can\'t be deleted through API.    3 = Person has linked programming keys or network module. Remove this links before deleting person.    4 = Person has active user account in another locking system.    5 = Person is the same user currently logged in.    6 = Person is S50 service user. This user can\'t be deleted.    -1 = Error occurred    
 * @export
 * @enum {string}
 */
export enum PniPersonCanDeleteErrorType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6,
    NUMBER_MINUS_1 = -1
}

/**
 * Person\'s states    0 = Active person    1 = Person is not in use    
 * @export
 * @enum {string}
 */
export enum PniPersonState {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

/**
 * Programming token\'s states.    0 = Not active    1 = Active    
 * @export
 * @enum {string}
 */
export enum PniProgrammingKeyState {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

/**
 * Programming token type    0 = S10 Locking system\'s programming token    1 = S10 Locking system\'s master token    2 = S10 Locking system\'s master token with initialize task    3 = S10 Locking system\'s netbox    4 = S10 Locking system\'s Remote station    5 = S10 Locking system\'s Key scheduler    6 = S10 Locking system\'s Bridge    7 = S50 and 5 Series\' token    8 = 5 Series locking system\'s N501 network module, which also uses one USB modem license    9 = 5 Series locking system\'s N500 network module, which doesn\'t use USB modem license    -1 = No type    
 * @export
 * @enum {string}
 */
export enum PniProgrammingKeyType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6,
    NUMBER_7 = 7,
    NUMBER_8 = 8,
    NUMBER_9 = 9,
    NUMBER_MINUS_1 = -1
}

/**
 * Mode for security access to determine if it is set as a default for locks.    0 = Security access is not set for locks as default    1 = Security access is set for locks as default    
 * @export
 * @enum {string}
 */
export enum PniSecurityAccessDefaultAccess {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

/**
 * Security access\' time control options    0 = Time control is not in use    1 = Time control is in use    
 * @export
 * @enum {string}
 */
export enum PniSecurityAccessExt {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

/**
 * Security access status    0 = Active    1 = Security access is no longer in use.    2 = Security access is blocklisted    3 = Security access is lead to blocklist through a key (only possible on lock security accesses)    4 = Blocked    
 * @export
 * @enum {string}
 */
export enum PniSecurityAccessStatus {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4
}

/**
 * Security access type.    0 = Key security access. This is only for keys which are in blocklist and is created automatically when Key is blocklisted.    1 = Standard access    2 = Mask. Not in use.    3 = API Access    
 * @export
 * @enum {string}
 */
export enum PniSecurityAccessType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}

/**
 * 
 * @export
 * @interface PublicApiGetUrlParam
 */
export interface PublicApiGetUrlParam {
    /**
     * Customer code.
     * @type {string}
     * @memberof PublicApiGetUrlParam
     */
    CustomerCode: string;
}
/**
 * Relay lock quasar modes    0 = External relays aren\'t connected    1 = 1x8 relays connected    2 = 2x8 relays connected    4 = 1x16    8 = Internal relays K1 and K2 are controlled like additional relays    
 * @export
 * @enum {string}
 */
export enum QuasarModeMask {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_4 = 4,
    NUMBER_8 = 8
}

/**
 * 
 * @export
 * @interface RealEstate
 */
export interface RealEstate {
    /**
     * Real estate name
     * @type {string}
     * @memberof RealEstate
     */
    Name?: string | null;
    /**
     * Parent\'s ID if real estate is nested and linked to a parent. Null if it isn\'t nested.
     * @type {string}
     * @memberof RealEstate
     */
    ParentRealEstate_ID?: string | null;
    /**
     * ID
     * @type {string}
     * @memberof RealEstate
     */
    RealEstate_ID?: string;
}
/**
 * Relay lock\'s modes    0 = Latch    1 = Pulse    3 = Key hold    7 = Roller door    255 = Dipp    
 * @export
 * @enum {string}
 */
export enum RelayMode {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_3 = 3,
    NUMBER_7 = 7,
    NUMBER_255 = 255
}

/**
 * KeyScheduler renew type    0 = Not in use    1 = Daily renew    2 = Weekly renew    
 * @export
 * @enum {string}
 */
export enum RenewGapType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

/**
 * 
 * @export
 * @interface SecurityAccess
 */
export interface SecurityAccess {
    /**
     * Access mode    0 = show as default    1 = hide as default    
     * @type {EnuSecurityAccessMode}
     * @memberof SecurityAccess
     */
    AccessMode?: EnuSecurityAccessMode;
    /**
     * Is security access set for locks as default    0 = Security access is not set for locks as default    1 = Security access is set for locks as default    
     * @type {PniSecurityAccessDefaultAccess}
     * @memberof SecurityAccess
     */
    DefaultAccess?: PniSecurityAccessDefaultAccess;
    /**
     * Description text
     * @type {string}
     * @memberof SecurityAccess
     */
    Description?: string | null;
    /**
     * Option if time control/additional conditions are on.    0 = Time control is not in use    1 = Time control is in use    
     * @type {PniSecurityAccessExt}
     * @memberof SecurityAccess
     */
    Ext?: PniSecurityAccessExt;
    /**
     * Description for what the Ext value means (for example, time control is on).
     * @type {string}
     * @memberof SecurityAccess
     */
    ExtDescription?: string | null;
    /**
     * Name
     * @type {string}
     * @memberof SecurityAccess
     */
    Name?: string | null;
    /**
     * Parent security access ID if this security access is nested and linked to parent. Null if not nested. Reserved for future use.
     * @type {string}
     * @memberof SecurityAccess
     */
    ParentSecurityAccess_ID?: string | null;
    /**
     * Real estate ID
     * @type {string}
     * @memberof SecurityAccess
     */
    RealEstate_ID?: string;
    /**
     * ID
     * @type {string}
     * @memberof SecurityAccess
     */
    SecurityAccess_ID?: string;
    /**
     * Zone id if linked to a zone.
     * @type {string}
     * @memberof SecurityAccess
     */
    Zone_ID?: string | null;
    /**
     * Status    0 = Active    1 = Security access is no longer in use.    2 = Security access is blocklisted    3 = Security access is lead to blocklist through a key (only possible on lock security accesses)    4 = Blocked    
     * @type {PniSecurityAccessStatus}
     * @memberof SecurityAccess
     */
    Status?: PniSecurityAccessStatus;
    /**
     * Type     0 = Key security access. This is only for keys which are in blocklist and is created automatically when Key is blocklisted.    1 = Standard access    2 = Mask. Not in use.    3 = API Access    
     * @type {PniSecurityAccessType}
     * @memberof SecurityAccess
     */
    Type?: PniSecurityAccessType;
    /**
     * Version number if versioned security access. Null otherwise.
     * @type {number}
     * @memberof SecurityAccess
     */
    VersionNr?: number | null;
}
/**
 * 
 * @export
 * @interface SecurityAccess2
 */
export interface SecurityAccess2 {
    /**
     * ID
     * @type {string}
     * @memberof SecurityAccess2
     */
    SecurityAccess_ID?: string;
    /**
     * Parent security access ID if this security access is nested and linked to parent. Null if not nested.
     * @type {string}
     * @memberof SecurityAccess2
     */
    ParentSecurityAccess_ID?: string | null;
    /**
     * name
     * @type {string}
     * @memberof SecurityAccess2
     */
    Name?: string | null;
    /**
     * description
     * @type {string}
     * @memberof SecurityAccess2
     */
    Description?: string | null;
    /**
     * Type (Group, mask, key)
     * @type {PniSecurityAccessType}
     * @memberof SecurityAccess2
     */
    Type?: PniSecurityAccessType;
    /**
     * status
     * @type {PniSecurityAccessStatus}
     * @memberof SecurityAccess2
     */
    Status?: PniSecurityAccessStatus;
    /**
     * Option if time control/additional conditions are on.
     * @type {PniSecurityAccessExt}
     * @memberof SecurityAccess2
     */
    Ext?: PniSecurityAccessExt;
    /**
     * Description for what the Ext value means (for example, time control is on).
     * @type {string}
     * @memberof SecurityAccess2
     */
    ExtDescription?: string | null;
    /**
     * Zone id if linked to a zone.
     * @type {string}
     * @memberof SecurityAccess2
     */
    Zone_ID?: string | null;
    /**
     * Is security access set for locks as default
     * @type {PniSecurityAccessDefaultAccess}
     * @memberof SecurityAccess2
     */
    DefaultAccess?: PniSecurityAccessDefaultAccess;
    /**
     * Version number if versioned security access. Null otherwise.
     * @type {number}
     * @memberof SecurityAccess2
     */
    VersionNr?: number | null;
    /**
     * Real estate ID
     * @type {string}
     * @memberof SecurityAccess2
     */
    RealEstate_ID?: string;
    /**
     * Access mode
     * @type {EnuSecurityAccessMode}
     * @memberof SecurityAccess2
     */
    AccessMode?: EnuSecurityAccessMode;
}
/**
 * 
 * @export
 * @interface SecurityAccessInsert
 */
export interface SecurityAccessInsert {
    /**
     * ID. 
     * @type {string}
     * @memberof SecurityAccessInsert
     */
    SecurityAccess_ID?: string | null;
    /**
     * Access mode    0 = show as default    1 = hide as default    
     * @type {number}
     * @memberof SecurityAccessInsert
     */
    AccessMode?: number;
    /**
     * Is security access set for locks as default    0 = Security access is not set for locks as default    1 = Security access is set for locks as default    
     * @type {number}
     * @memberof SecurityAccessInsert
     */
    DefaultAccess?: number;
    /**
     * Description text
     * @type {string}
     * @memberof SecurityAccessInsert
     */
    Description?: string | null;
    /**
     * Option if time control/additional conditions are on.    0 = Time control is not in use    1 = Time control is in use    
     * @type {number}
     * @memberof SecurityAccessInsert
     */
    Ext?: number;
    /**
     * Description for what the Ext value means (for example, time control is on).
     * @type {string}
     * @memberof SecurityAccessInsert
     */
    ExtDescription?: string | null;
    /**
     * Name
     * @type {string}
     * @memberof SecurityAccessInsert
     */
    Name?: string | null;
    /**
     * Parent security access ID if this security access is nested and linked to parent. Null if not nested.
     * @type {string}
     * @memberof SecurityAccessInsert
     */
    ParentSecurityAccess_ID?: string | null;
    /**
     * Real estate ID
     * @type {string}
     * @memberof SecurityAccessInsert
     */
    RealEstate_ID?: string;
    /**
     * Zone id if linked to a zone.
     * @type {string}
     * @memberof SecurityAccessInsert
     */
    Zone_ID?: string | null;
    /**
     * Status. Only Active access rights can be created.    0 = Active    1 = Security access is no longer in use.    2 = Security access is blocklisted    3 = Security access is lead to blocklist through a key (only possible on lock security accesses)    4 = Blocked    
     * @type {number}
     * @memberof SecurityAccessInsert
     */
    Status?: number;
    /**
     * Type. Only standard access and API access can be added. Key types are created when keys are blocklisted.    0 = Key security access. This is only for keys which are in blocklist and is created automatically when Key is blocklisted.    1 = Standard access    2 = Mask. Not in use.    3 = API Access    
     * @type {number}
     * @memberof SecurityAccessInsert
     */
    Type?: number;
    /**
     * Version number if versioned security access. Null otherwise.
     * @type {number}
     * @memberof SecurityAccessInsert
     */
    VersionNr?: number | null;
}
/**
 * 
 * @export
 * @interface SecurityAccessRelay
 */
export interface SecurityAccessRelay {
    /**
     * Relay mask
     * @type {number}
     * @memberof SecurityAccessRelay
     */
    RelayMask?: number;
    /**
     * Security access id
     * @type {string}
     * @memberof SecurityAccessRelay
     */
    SecurityAccess_ID?: string;
}
/**
 * 
 * @export
 * @interface SecurityAccessUpdate
 */
export interface SecurityAccessUpdate {
    /**
     * Access mode    0 = show as default    1 = hide as default    
     * @type {number}
     * @memberof SecurityAccessUpdate
     */
    AccessMode?: number;
    /**
     * Is security access set for locks as default    0 = Security access is not set for locks as default    1 = Security access is set for locks as default    
     * @type {number}
     * @memberof SecurityAccessUpdate
     */
    DefaultAccess?: number;
    /**
     * Description text
     * @type {string}
     * @memberof SecurityAccessUpdate
     */
    Description?: string | null;
    /**
     * Option if time control/additional conditions are on.    0 = Time control is not in use    1 = Time control is in use    
     * @type {number}
     * @memberof SecurityAccessUpdate
     */
    Ext?: number;
    /**
     * Description for what the Ext value means (for example, time control is on).
     * @type {string}
     * @memberof SecurityAccessUpdate
     */
    ExtDescription?: string | null;
    /**
     * Name
     * @type {string}
     * @memberof SecurityAccessUpdate
     */
    Name?: string | null;
    /**
     * ID
     * @type {string}
     * @memberof SecurityAccessUpdate
     */
    SecurityAccess_ID?: string;
    /**
     * Type. Read only, can\'t be changed.    0 = Key security access. This is only for keys which are in blocklist and is created automatically when Key is blocklisted.    1 = Standard access    2 = Mask. Not in use.    3 = API Access    
     * @type {number}
     * @memberof SecurityAccessUpdate
     */
    Type?: number;
    /**
     * True if security access is versioned. False if not.
     * @type {boolean}
     * @memberof SecurityAccessUpdate
     */
    VersionInUse?: boolean;
    /**
     * Real estate ID
     * @type {string}
     * @memberof SecurityAccessUpdate
     */
    RealEstate_ID?: string;
    /**
     * Zone id if linked to a zone.
     * @type {string}
     * @memberof SecurityAccessUpdate
     */
    Zone_ID?: string | null;
}
/**
 * 
 * @export
 * @interface SecurityRole
 */
export interface SecurityRole {
    /**
     * Description
     * @type {string}
     * @memberof SecurityRole
     */
    Description?: string | null;
    /**
     * Name
     * @type {string}
     * @memberof SecurityRole
     */
    Name?: string | null;
    /**
     * Online access code. Empty when retrieving security roles and must be retrieved with a different method. If given as empty string during update, uses previous code.
     * @type {string}
     * @memberof SecurityRole
     */
    OnlineAccessCode?: string | null;
    /**
     * How long the relay is on after access is granted. In milliseconds.
     * @type {number}
     * @memberof SecurityRole
     */
    OnlineRelayOperatingTimeMs?: number;
    /**
     * Real estate id
     * @type {string}
     * @memberof SecurityRole
     */
    RealEstate_ID?: string;
    /**
     * ID
     * @type {string}
     * @memberof SecurityRole
     */
    SecurityRole_ID?: string;
    /**
     * Type
     * @type {SecurityRoleTypeMask}
     * @memberof SecurityRole
     */
    TypeMask?: SecurityRoleTypeMask;
    /**
     * Zone id
     * @type {string}
     * @memberof SecurityRole
     */
    Zone_ID?: string | null;
}
/**
 * Security role type mask.    0 = Not set    1 = Default security role    2 = Network module security access group    
 * @export
 * @enum {string}
 */
export enum SecurityRoleTypeMask {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

/**
 * Parameter for settings session\'s locking system information
 * @export
 * @interface SetLockgroupParam
 */
export interface SetLockgroupParam {
    /**
     * Locking system\'s ID user is logging in to.
     * @type {string}
     * @memberof SetLockgroupParam
     */
    LockGroup_ID?: string;
}
/**
 * Result after setting locking system successfully
 * @export
 * @interface SetLockgroupResult
 */
export interface SetLockgroupResult {
    /**
     * User\'s rights as a bit mask.    0 = No permission    1 = Right to log in to iLOQ Manager    2 = Right to view person list    4 = Not in use. Use CanBrowseLocks instead.    8 = Right to view person tools    16 = Right to view lock tools    32 = Right to view key tools    64 = Right to view report tools    128 = Right to view black list tools    256 = Right to view group tools    512 = Right to view key list    1024 = Right to view zone tools    2048 = Right to view zone list    4096 = Right to edit users    8192 = Right to view user list    16384 = Right to edit person roles    32768 = Right to view person role list    65536 = Right to edit persons    131072 = Right to edit black list    262144 = Right to edit locks    524288 = Right to edit keys    1048576 = Right to edit zones    2097152 = Right to view security access list    4194304 = Right to edit security accesses    8388608 = Right to view black list    16777216 = Right to view and print reports    33554432 = Right to edit key access    67108864 = Right to hand over keys    134217728 = Right to handle key returns    268435456 = Right to order locks    536870912 = Right to edit lock access    1073741824 = Right to browse lock list    2147483648 = Right to administrate locking system    4294967296 = Right to view user tools    8589934592 = Not in use    17179869184 = Right to view programming key tools    34359738368 = Right to order keys    68719476736 = Right to program keys    137438953472 = Not in use    274877906944 = Right to edit locking system basic information    549755813888 = Right to browse lock log entries    1099511627776 = Right to program locks    2199023255552 = Right to change user passwords    4398046511104 = Right to use PDA    8796093022208 = Right to browser event log entries    17592186044416 = Right to edit floor plans    35184372088832 = Right to edit lock\'s default access    70368744177664 = Online lock user rights.    140737488355328 = Right to edit real estates    281474976710656 = Right to make Transfers.    562949953421312 = Can make replacing keys    1125899906842624 = Right to edit code groups    2251799813685248 = Right to edit doors\' calendar controls    4503599627370496 = Right to use phone interface    9007199254740992 = Rights to add new S50 or 5 Series token or S10 programming token    18014398509481984 = Rights to listen to all flock log events using SignalR server    
     * @type {number}
     * @memberof SetLockgroupResult
     */
    RightsMask?: number;
}
/**
 * 
 * @export
 * @interface TimeLimitData
 */
export interface TimeLimitData {
    /**
     * Id
     * @type {string}
     * @memberof TimeLimitData
     */
    TimeLimitData_ID?: string;
    /**
     * Time limit title ID
     * @type {string}
     * @memberof TimeLimitData
     */
    TimeLimitTitle_ID?: string;
    /**
     * Week days for this time limit data. For example 31 (monday to friday)    0 = None    1 = Monday    2 = Tuesday    4 = Wednesday    8 = Thursday    16 = Friday    32 = Saturday    64 = Sunday    
     * @type {number}
     * @memberof TimeLimitData
     */
    WeekDayMask?: number;
    /**
     * Start time. For example 8:00
     * @type {string}
     * @memberof TimeLimitData
     */
    StartTime?: string;
    /**
     * End time. For example 16:30
     * @type {string}
     * @memberof TimeLimitData
     */
    EndTime?: string;
}
/**
 * 
 * @export
 * @interface TimeLimitTitle
 */
export interface TimeLimitTitle {
    /**
     * Description
     * @type {string}
     * @memberof TimeLimitTitle
     */
    Description?: string | null;
    /**
     * Time limit\'s end date in locking system\'s time. Can be null.
     * @type {string}
     * @memberof TimeLimitTitle
     */
    EndDateLg?: string | null;
    /**
     * Time limit title\'s name
     * @type {string}
     * @memberof TimeLimitTitle
     */
    Name?: string | null;
    /**
     * Options    0 = Not in use    1 = S10 compatible    2 = S50 and 5 Series compatible    4 = Time limit title is deleted. Can be marked as deleted if all keys under time limit title are returned    8 = dynamic time limit. Changing dynamic time limit doesn\'t change key directly so keys are still following their own schedule (LNKeyTimeLimitData)    16 = S10 \"Time Limit 1\" profile    32 = S10 \"Time Limit 2\" profile    
     * @type {TimeLimitTitleOptionMaskEnum}
     * @memberof TimeLimitTitle
     */
    OptionMask?: TimeLimitTitleOptionMaskEnum;
    /**
     * Real Estate ID
     * @type {string}
     * @memberof TimeLimitTitle
     */
    RealEstate_ID?: string;
    /**
     * Time limit\'s start date in locking system\'s time. Can be null.
     * @type {string}
     * @memberof TimeLimitTitle
     */
    StartDateLg?: string | null;
    /**
     * ID
     * @type {string}
     * @memberof TimeLimitTitle
     */
    TimeLimitTitle_ID?: string;
    /**
     * Zone ID
     * @type {string}
     * @memberof TimeLimitTitle
     */
    Zone_ID?: string;
}
/**
 * TimeLimitTitle options    0 = Not in use    1 = S10 compatible    2 = S50 and 5 Series compatible    4 = Time limit title is deleted. Can be marked as deleted if all keys under time limit title are returned    8 = dynamic time limit. Changing dynamic time limit doesn\'t change key directly so keys are still following their own schedule (LNKeyTimeLimitData)    16 = S10 \"Time Limit 1\" profile    32 = S10 \"Time Limit 2\" profile    
 * @export
 * @enum {string}
 */
export enum TimeLimitTitleOptionMaskEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_4 = 4,
    NUMBER_8 = 8,
    NUMBER_16 = 16,
    NUMBER_32 = 32
}

/**
 * Update key\'s main zone.
 * @export
 * @interface UpdateKeyMainZoneParam
 */
export interface UpdateKeyMainZoneParam {
    /**
     * Main zone of the key.
     * @type {string}
     * @memberof UpdateKeyMainZoneParam
     */
    Zone_ID?: string;
}
/**
 * Parameter for updating key
 * @export
 * @interface UpdateKeyParam
 */
export interface UpdateKeyParam {
    /**
     * Key update information
     * @type {Key}
     * @memberof UpdateKeyParam
     */
    Key?: Key | null;
}
/**
 * Parameter for updating key
 * @export
 * @interface UpdateKeyParam1
 */
export interface UpdateKeyParam1 {
    /**
     * Key update information
     * @type {Key1}
     * @memberof UpdateKeyParam1
     */
    Key?: Key1 | null;
}
/**
 * Parameter for updating Key\'s phone information
 * @export
 * @interface UpdateKeyPhoneParam
 */
export interface UpdateKeyPhoneParam {
    /**
     * Email address which is used instead of SMS if OptionMask contains \'UseEmail\' bit
     * @type {string}
     * @memberof UpdateKeyPhoneParam
     */
    Email?: string | null;
    /**
     * Key Id
     * @type {string}
     * @memberof UpdateKeyPhoneParam
     */
    FNKey_ID?: string;
    /**
     * Option mask. At the moment only \'UseEmail\' can be changed. Others are readonly values.
     * @type {FNKeyPhoneOptionMask}
     * @memberof UpdateKeyPhoneParam
     */
    OptionMask?: FNKeyPhoneOptionMask;
    /**
     * Phone number. Must be unique within locking system.
     * @type {string}
     * @memberof UpdateKeyPhoneParam
     */
    PhoneNo?: string | null;
}
/**
 * Parameter for updating key\'s security accesses and time limits
 * @export
 * @interface UpdateKeySecurityAccessesParam
 */
export interface UpdateKeySecurityAccessesParam {
    /**
     * Security accesses which are set to the key
     * @type {Array<string>}
     * @memberof UpdateKeySecurityAccessesParam
     */
    SecurityAccessIds?: Array<string> | null;
    /**
     * Key renew information
     * @type {KeyScheduler}
     * @memberof UpdateKeySecurityAccessesParam
     */
    KeyScheduler?: KeyScheduler | null;
    /**
     * Time limit slots
     * @type {Array<KeyTimeLimitSlot>}
     * @memberof UpdateKeySecurityAccessesParam
     */
    TimeLimitSlots?: Array<KeyTimeLimitSlot> | null;
    /**
     * Slots which are filled by information not available for current user and aren\'t overridden.
     * @type {Array<number>}
     * @memberof UpdateKeySecurityAccessesParam
     */
    OutsideUserZoneTimeLimitTitleSlots?: Array<number> | null;
    /**
     * S50 Time key works offline in seconds. Zero = unlimited offline access.
     * @type {number}
     * @memberof UpdateKeySecurityAccessesParam
     */
    OfflineExpirationSeconds?: number;
}
/**
 * Parameter for updating key\'s security accesses and time limits
 * @export
 * @interface UpdateKeySecurityAccessesParam1
 */
export interface UpdateKeySecurityAccessesParam1 {
    /**
     * Security accesses which are set to the key
     * @type {Array<string>}
     * @memberof UpdateKeySecurityAccessesParam1
     */
    SecurityAccessIds?: Array<string> | null;
    /**
     * Time limit information for the key
     * @type {Array<KeyTimeLimit>}
     * @memberof UpdateKeySecurityAccessesParam1
     */
    TimeLimits?: Array<KeyTimeLimit> | null;
}
/**
 * Parameter for updating lock
 * @export
 * @interface UpdateLockParam
 */
export interface UpdateLockParam {
    /**
     * Lock information
     * @type {LockUpdate}
     * @memberof UpdateLockParam
     */
    Lock?: LockUpdate | null;
}
/**
 * Parameter for updating lock\'s security accesses
 * @export
 * @interface UpdateLockSecurityAccessesParam
 */
export interface UpdateLockSecurityAccessesParam {
    /**
     * If true, then lock respects all timelimits And TimeLimitTitleIds doesn\'t need to be given. If false, then lock respects given TimeLimitTitleIds. If no timelimittitle ids are given, then lock isn\'t timelimited. Default is false.
     * @type {boolean}
     * @memberof UpdateLockSecurityAccessesParam
     */
    LockRespectsAllTimeLimits?: boolean;
    /**
     * Security accesses which are set to the lock
     * @type {Array<string>}
     * @memberof UpdateLockSecurityAccessesParam
     */
    SecurityAccessIds?: Array<string> | null;
    /**
     * Time limit titles
     * @type {Array<string>}
     * @memberof UpdateLockSecurityAccessesParam
     */
    TimeLimitTitleIds?: Array<string> | null;
    /**
     * Lock relay information
     * @type {SecurityAccessRelay}
     * @memberof UpdateLockSecurityAccessesParam
     */
    LockRelay?: SecurityAccessRelay | null;
    /**
     * Lock\'s options
     * @type {LLockOptionMaskParam}
     * @memberof UpdateLockSecurityAccessesParam
     */
    LockOptions?: LLockOptionMaskParam | null;
}
/**
 * Parameter for updating lock\'s security accesses
 * @export
 * @interface UpdateLockSecurityAccessesParam1
 */
export interface UpdateLockSecurityAccessesParam1 {
    /**
     * Security accesses which are set to the lock
     * @type {Array<string>}
     * @memberof UpdateLockSecurityAccessesParam1
     */
    SecurityAccessIds?: Array<string> | null;
    /**
     * Time limit information
     * @type {LockTimeLimit}
     * @memberof UpdateLockSecurityAccessesParam1
     */
    TimeLimit?: LockTimeLimit | null;
    /**
     * Lock relay information
     * @type {SecurityAccessRelay}
     * @memberof UpdateLockSecurityAccessesParam1
     */
    LockRelay?: SecurityAccessRelay | null;
}
/**
 * 
 * @export
 * @interface UpdatePersonParam
 */
export interface UpdatePersonParam {
    /**
     * Updated person data
     * @type {PersonUpdate}
     * @memberof UpdatePersonParam
     */
    Person?: PersonUpdate | null;
}
/**
 * Parameter for updating security access
 * @export
 * @interface UpdateSecurityAccessParam
 */
export interface UpdateSecurityAccessParam {
    /**
     * Security access to update
     * @type {SecurityAccessUpdate}
     * @memberof UpdateSecurityAccessParam
     */
    SecurityAccess?: SecurityAccessUpdate | null;
}
/**
 * 
 * @export
 * @interface UpdateTimeLimitTitlesParam
 */
export interface UpdateTimeLimitTitlesParam {
    /**
     * Time limit title which is updated
     * @type {TimeLimitTitle}
     * @memberof UpdateTimeLimitTitlesParam
     */
    TimeLimitTitle?: TimeLimitTitle | null;
    /**
     * Time limit datas which are set for time limit title Maximum count is 10
     * @type {Array<TimeLimitData>}
     * @memberof UpdateTimeLimitTitlesParam
     */
    TimeLimitData?: Array<TimeLimitData> | null;
}
/**
 * 
 * @export
 * @interface Zone
 */
export interface Zone {
    /**
     * Description text
     * @type {string}
     * @memberof Zone
     */
    Description?: string | null;
    /**
     * Name
     * @type {string}
     * @memberof Zone
     */
    Name?: string | null;
    /**
     * Type    0 = Not set    1 = Zone the customer has added to their locking system    2 = Default zone for everything but keys and persons              This can be edited from locking system settings in iLOQ Manager    4 = Default zone for keys and persons.              This can be edited from locking system settings in iLOQ Manager    8 = General zone which is added to all customers as default zone.    
     * @type {number}
     * @memberof Zone
     */
    Type?: number;
    /**
     * ID
     * @type {string}
     * @memberof Zone
     */
    Zone_ID?: string;
}

/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates session. Returns session id which must then be passed in http headers. After session is created, call SetUserRights (and get locking systems before that if necessary to get a lockgroup_id)
         * @summary /api/v2/CreateSession
         * @param {CreateSessionParam} createSessionParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationCreateSession: async (createSessionParam: CreateSessionParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSessionParam' is not null or undefined
            if (createSessionParam === null || createSessionParam === undefined) {
                throw new RequiredError('createSessionParam','Required parameter createSessionParam was null or undefined when calling authenticationCreateSession.');
            }
            const localVarPath = `/api/v2/CreateSession`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof createSessionParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createSessionParam !== undefined ? createSessionParam : {}) : (createSessionParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ends session
         * @summary /api/v2/KillSession
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationKillSession: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/KillSession`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets user\'s session\'s locking system information. Call after CreateSession and GetLockGroups is called.
         * @summary /api/v2/SetLockgroup
         * @param {SetLockgroupParam} setLockgroupParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationSetLockgroup: async (setLockgroupParam: SetLockgroupParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'setLockgroupParam' is not null or undefined
            if (setLockgroupParam === null || setLockgroupParam === undefined) {
                throw new RequiredError('setLockgroupParam','Required parameter setLockgroupParam was null or undefined when calling authenticationSetLockgroup.');
            }
            const localVarPath = `/api/v2/SetLockgroup`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof setLockgroupParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(setLockgroupParam !== undefined ? setLockgroupParam : {}) : (setLockgroupParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Connection test. Returns \"Test OK\".
         * @summary /api/v2/Test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationTest: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Test`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Creates session. Returns session id which must then be passed in http headers. After session is created, call SetUserRights (and get locking systems before that if necessary to get a lockgroup_id)
         * @summary /api/v2/CreateSession
         * @param {CreateSessionParam} createSessionParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationCreateSession(createSessionParam: CreateSessionParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSessionResult>> {
            const localVarAxiosArgs = await AuthenticationApiAxiosParamCreator(configuration).authenticationCreateSession(createSessionParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Ends session
         * @summary /api/v2/KillSession
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationKillSession(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await AuthenticationApiAxiosParamCreator(configuration).authenticationKillSession(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Sets user\'s session\'s locking system information. Call after CreateSession and GetLockGroups is called.
         * @summary /api/v2/SetLockgroup
         * @param {SetLockgroupParam} setLockgroupParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationSetLockgroup(setLockgroupParam: SetLockgroupParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetLockgroupResult>> {
            const localVarAxiosArgs = await AuthenticationApiAxiosParamCreator(configuration).authenticationSetLockgroup(setLockgroupParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Connection test. Returns \"Test OK\".
         * @summary /api/v2/Test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationTest(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await AuthenticationApiAxiosParamCreator(configuration).authenticationTest(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Creates session. Returns session id which must then be passed in http headers. After session is created, call SetUserRights (and get locking systems before that if necessary to get a lockgroup_id)
         * @summary /api/v2/CreateSession
         * @param {CreateSessionParam} createSessionParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationCreateSession(createSessionParam: CreateSessionParam, options?: any): AxiosPromise<CreateSessionResult> {
            return AuthenticationApiFp(configuration).authenticationCreateSession(createSessionParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Ends session
         * @summary /api/v2/KillSession
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationKillSession(options?: any): AxiosPromise<any> {
            return AuthenticationApiFp(configuration).authenticationKillSession(options).then((request) => request(axios, basePath));
        },
        /**
         * Sets user\'s session\'s locking system information. Call after CreateSession and GetLockGroups is called.
         * @summary /api/v2/SetLockgroup
         * @param {SetLockgroupParam} setLockgroupParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationSetLockgroup(setLockgroupParam: SetLockgroupParam, options?: any): AxiosPromise<SetLockgroupResult> {
            return AuthenticationApiFp(configuration).authenticationSetLockgroup(setLockgroupParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Connection test. Returns \"Test OK\".
         * @summary /api/v2/Test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationTest(options?: any): AxiosPromise<string> {
            return AuthenticationApiFp(configuration).authenticationTest(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * Creates session. Returns session id which must then be passed in http headers. After session is created, call SetUserRights (and get locking systems before that if necessary to get a lockgroup_id)
     * @summary /api/v2/CreateSession
     * @param {CreateSessionParam} createSessionParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationCreateSession(createSessionParam: CreateSessionParam, options?: any) {
        return AuthenticationApiFp(this.configuration).authenticationCreateSession(createSessionParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ends session
     * @summary /api/v2/KillSession
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationKillSession(options?: any) {
        return AuthenticationApiFp(this.configuration).authenticationKillSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets user\'s session\'s locking system information. Call after CreateSession and GetLockGroups is called.
     * @summary /api/v2/SetLockgroup
     * @param {SetLockgroupParam} setLockgroupParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationSetLockgroup(setLockgroupParam: SetLockgroupParam, options?: any) {
        return AuthenticationApiFp(this.configuration).authenticationSetLockgroup(setLockgroupParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Connection test. Returns \"Test OK\".
     * @summary /api/v2/Test
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationTest(options?: any) {
        return AuthenticationApiFp(this.configuration).authenticationTest(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * BlacklistsApi - axios parameter creator
 * @export
 */
export const BlacklistsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds a key to the blocklist. Only S50 and 5 Series keys can be added.
         * @summary /api/v2/Blacklists/AddKey/{fnkeyId}
         * @param {string} fnkeyId Key which is added to blocklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistsAddKey: async (fnkeyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fnkeyId' is not null or undefined
            if (fnkeyId === null || fnkeyId === undefined) {
                throw new RequiredError('fnkeyId','Required parameter fnkeyId was null or undefined when calling blacklistsAddKey.');
            }
            const localVarPath = `/api/v2/Blacklists/AddKey/{fnkeyId}`
                .replace(`{${"fnkeyId"}}`, encodeURIComponent(String(fnkeyId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if given key can be added to the blocklist. Only S50 and 5 Series keys can be added
         * @summary /api/v2/Blacklists/CanAddKey/{fnkeyId}
         * @param {string} fnkeyId Key which would be added to blocklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistsCanAddKey: async (fnkeyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fnkeyId' is not null or undefined
            if (fnkeyId === null || fnkeyId === undefined) {
                throw new RequiredError('fnkeyId','Required parameter fnkeyId was null or undefined when calling blacklistsCanAddKey.');
            }
            const localVarPath = `/api/v2/Blacklists/CanAddKey/{fnkeyId}`
                .replace(`{${"fnkeyId"}}`, encodeURIComponent(String(fnkeyId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if blocklist can be ordered throught public web api or is iLOQ Manager and Programming device required
         * @summary /api/v2/Blacklists/CanOrderS40Blacklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistsCanOrderS40Blacklist: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Blacklists/CanOrderS40Blacklist`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if given key can be removed from the blocklist. Only S50 and 5 Series keys can be removed.
         * @summary /api/v2/Blacklists/CanRemoveKey/{fnkeyId}
         * @param {string} fnkeyId Key which would be removed from blocklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistsCanRemoveKey: async (fnkeyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fnkeyId' is not null or undefined
            if (fnkeyId === null || fnkeyId === undefined) {
                throw new RequiredError('fnkeyId','Required parameter fnkeyId was null or undefined when calling blacklistsCanRemoveKey.');
            }
            const localVarPath = `/api/v2/Blacklists/CanRemoveKey/{fnkeyId}`
                .replace(`{${"fnkeyId"}}`, encodeURIComponent(String(fnkeyId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all items in current blocklist
         * @summary /api/v2/Blacklists
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistsGetAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Blacklists`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Orders blocklist
         * @summary /api/v2/Blacklists/OrderS40Blacklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistsOrderS40Blacklist: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Blacklists/OrderS40Blacklist`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a key from the blocklist. Only S50 and 5 Series keys can be removed.
         * @summary /api/v2/Blacklists/RemoveKey/{fnkeyId}
         * @param {string} fnkeyId Key which is removed from blocklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistsRemoveKey: async (fnkeyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fnkeyId' is not null or undefined
            if (fnkeyId === null || fnkeyId === undefined) {
                throw new RequiredError('fnkeyId','Required parameter fnkeyId was null or undefined when calling blacklistsRemoveKey.');
            }
            const localVarPath = `/api/v2/Blacklists/RemoveKey/{fnkeyId}`
                .replace(`{${"fnkeyId"}}`, encodeURIComponent(String(fnkeyId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BlacklistsApi - functional programming interface
 * @export
 */
export const BlacklistsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Adds a key to the blocklist. Only S50 and 5 Series keys can be added.
         * @summary /api/v2/Blacklists/AddKey/{fnkeyId}
         * @param {string} fnkeyId Key which is added to blocklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blacklistsAddKey(fnkeyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await BlacklistsApiAxiosParamCreator(configuration).blacklistsAddKey(fnkeyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Checks if given key can be added to the blocklist. Only S50 and 5 Series keys can be added
         * @summary /api/v2/Blacklists/CanAddKey/{fnkeyId}
         * @param {string} fnkeyId Key which would be added to blocklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blacklistsCanAddKey(fnkeyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await BlacklistsApiAxiosParamCreator(configuration).blacklistsCanAddKey(fnkeyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Checks if blocklist can be ordered throught public web api or is iLOQ Manager and Programming device required
         * @summary /api/v2/Blacklists/CanOrderS40Blacklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blacklistsCanOrderS40Blacklist(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CanOrderS40BlacklistResult>> {
            const localVarAxiosArgs = await BlacklistsApiAxiosParamCreator(configuration).blacklistsCanOrderS40Blacklist(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Checks if given key can be removed from the blocklist. Only S50 and 5 Series keys can be removed.
         * @summary /api/v2/Blacklists/CanRemoveKey/{fnkeyId}
         * @param {string} fnkeyId Key which would be removed from blocklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blacklistsCanRemoveKey(fnkeyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await BlacklistsApiAxiosParamCreator(configuration).blacklistsCanRemoveKey(fnkeyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns all items in current blocklist
         * @summary /api/v2/Blacklists
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blacklistsGetAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetS40BlacklistResult>> {
            const localVarAxiosArgs = await BlacklistsApiAxiosParamCreator(configuration).blacklistsGetAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Orders blocklist
         * @summary /api/v2/Blacklists/OrderS40Blacklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blacklistsOrderS40Blacklist(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await BlacklistsApiAxiosParamCreator(configuration).blacklistsOrderS40Blacklist(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Removes a key from the blocklist. Only S50 and 5 Series keys can be removed.
         * @summary /api/v2/Blacklists/RemoveKey/{fnkeyId}
         * @param {string} fnkeyId Key which is removed from blocklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blacklistsRemoveKey(fnkeyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await BlacklistsApiAxiosParamCreator(configuration).blacklistsRemoveKey(fnkeyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BlacklistsApi - factory interface
 * @export
 */
export const BlacklistsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Adds a key to the blocklist. Only S50 and 5 Series keys can be added.
         * @summary /api/v2/Blacklists/AddKey/{fnkeyId}
         * @param {string} fnkeyId Key which is added to blocklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistsAddKey(fnkeyId: string, options?: any): AxiosPromise<any> {
            return BlacklistsApiFp(configuration).blacklistsAddKey(fnkeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if given key can be added to the blocklist. Only S50 and 5 Series keys can be added
         * @summary /api/v2/Blacklists/CanAddKey/{fnkeyId}
         * @param {string} fnkeyId Key which would be added to blocklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistsCanAddKey(fnkeyId: string, options?: any): AxiosPromise<boolean> {
            return BlacklistsApiFp(configuration).blacklistsCanAddKey(fnkeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if blocklist can be ordered throught public web api or is iLOQ Manager and Programming device required
         * @summary /api/v2/Blacklists/CanOrderS40Blacklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistsCanOrderS40Blacklist(options?: any): AxiosPromise<CanOrderS40BlacklistResult> {
            return BlacklistsApiFp(configuration).blacklistsCanOrderS40Blacklist(options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if given key can be removed from the blocklist. Only S50 and 5 Series keys can be removed.
         * @summary /api/v2/Blacklists/CanRemoveKey/{fnkeyId}
         * @param {string} fnkeyId Key which would be removed from blocklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistsCanRemoveKey(fnkeyId: string, options?: any): AxiosPromise<boolean> {
            return BlacklistsApiFp(configuration).blacklistsCanRemoveKey(fnkeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all items in current blocklist
         * @summary /api/v2/Blacklists
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistsGetAll(options?: any): AxiosPromise<GetS40BlacklistResult> {
            return BlacklistsApiFp(configuration).blacklistsGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * Orders blocklist
         * @summary /api/v2/Blacklists/OrderS40Blacklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistsOrderS40Blacklist(options?: any): AxiosPromise<any> {
            return BlacklistsApiFp(configuration).blacklistsOrderS40Blacklist(options).then((request) => request(axios, basePath));
        },
        /**
         * Removes a key from the blocklist. Only S50 and 5 Series keys can be removed.
         * @summary /api/v2/Blacklists/RemoveKey/{fnkeyId}
         * @param {string} fnkeyId Key which is removed from blocklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistsRemoveKey(fnkeyId: string, options?: any): AxiosPromise<any> {
            return BlacklistsApiFp(configuration).blacklistsRemoveKey(fnkeyId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BlacklistsApi - object-oriented interface
 * @export
 * @class BlacklistsApi
 * @extends {BaseAPI}
 */
export class BlacklistsApi extends BaseAPI {
    /**
     * Adds a key to the blocklist. Only S50 and 5 Series keys can be added.
     * @summary /api/v2/Blacklists/AddKey/{fnkeyId}
     * @param {string} fnkeyId Key which is added to blocklist
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlacklistsApi
     */
    public blacklistsAddKey(fnkeyId: string, options?: any) {
        return BlacklistsApiFp(this.configuration).blacklistsAddKey(fnkeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if given key can be added to the blocklist. Only S50 and 5 Series keys can be added
     * @summary /api/v2/Blacklists/CanAddKey/{fnkeyId}
     * @param {string} fnkeyId Key which would be added to blocklist
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlacklistsApi
     */
    public blacklistsCanAddKey(fnkeyId: string, options?: any) {
        return BlacklistsApiFp(this.configuration).blacklistsCanAddKey(fnkeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if blocklist can be ordered throught public web api or is iLOQ Manager and Programming device required
     * @summary /api/v2/Blacklists/CanOrderS40Blacklist
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlacklistsApi
     */
    public blacklistsCanOrderS40Blacklist(options?: any) {
        return BlacklistsApiFp(this.configuration).blacklistsCanOrderS40Blacklist(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if given key can be removed from the blocklist. Only S50 and 5 Series keys can be removed.
     * @summary /api/v2/Blacklists/CanRemoveKey/{fnkeyId}
     * @param {string} fnkeyId Key which would be removed from blocklist
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlacklistsApi
     */
    public blacklistsCanRemoveKey(fnkeyId: string, options?: any) {
        return BlacklistsApiFp(this.configuration).blacklistsCanRemoveKey(fnkeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all items in current blocklist
     * @summary /api/v2/Blacklists
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlacklistsApi
     */
    public blacklistsGetAll(options?: any) {
        return BlacklistsApiFp(this.configuration).blacklistsGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Orders blocklist
     * @summary /api/v2/Blacklists/OrderS40Blacklist
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlacklistsApi
     */
    public blacklistsOrderS40Blacklist(options?: any) {
        return BlacklistsApiFp(this.configuration).blacklistsOrderS40Blacklist(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes a key from the blocklist. Only S50 and 5 Series keys can be removed.
     * @summary /api/v2/Blacklists/RemoveKey/{fnkeyId}
     * @param {string} fnkeyId Key which is removed from blocklist
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlacklistsApi
     */
    public blacklistsRemoveKey(fnkeyId: string, options?: any) {
        return BlacklistsApiFp(this.configuration).blacklistsRemoveKey(fnkeyId, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CalendarDataSecurityRoleLinksApi - axios parameter creator
 * @export
 */
export const CalendarDataSecurityRoleLinksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes security role links from calendar data.
         * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks/Delete
         * @param {string} id Calendar data Id
         * @param {CalendarDataSecurityRoleLinksDeleteLinksParam} calendarDataSecurityRoleLinksDeleteLinksParam Parameter containing links which are deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataSecurityRoleLinksDeleteLinks: async (id: string, calendarDataSecurityRoleLinksDeleteLinksParam: CalendarDataSecurityRoleLinksDeleteLinksParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling calendarDataSecurityRoleLinksDeleteLinks.');
            }
            // verify required parameter 'calendarDataSecurityRoleLinksDeleteLinksParam' is not null or undefined
            if (calendarDataSecurityRoleLinksDeleteLinksParam === null || calendarDataSecurityRoleLinksDeleteLinksParam === undefined) {
                throw new RequiredError('calendarDataSecurityRoleLinksDeleteLinksParam','Required parameter calendarDataSecurityRoleLinksDeleteLinksParam was null or undefined when calling calendarDataSecurityRoleLinksDeleteLinks.');
            }
            const localVarPath = `/api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks/Delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof calendarDataSecurityRoleLinksDeleteLinksParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(calendarDataSecurityRoleLinksDeleteLinksParam !== undefined ? calendarDataSecurityRoleLinksDeleteLinksParam : {}) : (calendarDataSecurityRoleLinksDeleteLinksParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets links for given calendar data
         * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks
         * @param {string} id Calendar data id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataSecurityRoleLinksGetLinksByCalendarDataId: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling calendarDataSecurityRoleLinksGetLinksByCalendarDataId.');
            }
            const localVarPath = `/api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets links for given security role
         * @summary /api/v2/SecurityRoles/{id}/CalendarDataSecurityRoleLinks
         * @param {string} id Security role id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataSecurityRoleLinksGetLinksBySecurityRoleId: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling calendarDataSecurityRoleLinksGetLinksBySecurityRoleId.');
            }
            const localVarPath = `/api/v2/SecurityRoles/{id}/CalendarDataSecurityRoleLinks`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds security role links to calendar data.
         * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks
         * @param {string} id Calendar data Id
         * @param {CalendarDataSecurityRoleLinksInsertLinksParam} calendarDataSecurityRoleLinksInsertLinksParam Parameter containing links which are added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataSecurityRoleLinksInsertLinks: async (id: string, calendarDataSecurityRoleLinksInsertLinksParam: CalendarDataSecurityRoleLinksInsertLinksParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling calendarDataSecurityRoleLinksInsertLinks.');
            }
            // verify required parameter 'calendarDataSecurityRoleLinksInsertLinksParam' is not null or undefined
            if (calendarDataSecurityRoleLinksInsertLinksParam === null || calendarDataSecurityRoleLinksInsertLinksParam === undefined) {
                throw new RequiredError('calendarDataSecurityRoleLinksInsertLinksParam','Required parameter calendarDataSecurityRoleLinksInsertLinksParam was null or undefined when calling calendarDataSecurityRoleLinksInsertLinks.');
            }
            const localVarPath = `/api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof calendarDataSecurityRoleLinksInsertLinksParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(calendarDataSecurityRoleLinksInsertLinksParam !== undefined ? calendarDataSecurityRoleLinksInsertLinksParam : {}) : (calendarDataSecurityRoleLinksInsertLinksParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Links calendar datas to security roles. The whole result set must be given when setting links because this method handles both adding/removing of links. If no links are given, clears all calendar data\'s links.
         * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks
         * @param {string} id Calendar data Id
         * @param {CalendarDataSecurityRoleLinksSetLinksParam} calendarDataSecurityRoleLinksSetLinksParam Parameter containing links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataSecurityRoleLinksSetLinks: async (id: string, calendarDataSecurityRoleLinksSetLinksParam: CalendarDataSecurityRoleLinksSetLinksParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling calendarDataSecurityRoleLinksSetLinks.');
            }
            // verify required parameter 'calendarDataSecurityRoleLinksSetLinksParam' is not null or undefined
            if (calendarDataSecurityRoleLinksSetLinksParam === null || calendarDataSecurityRoleLinksSetLinksParam === undefined) {
                throw new RequiredError('calendarDataSecurityRoleLinksSetLinksParam','Required parameter calendarDataSecurityRoleLinksSetLinksParam was null or undefined when calling calendarDataSecurityRoleLinksSetLinks.');
            }
            const localVarPath = `/api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof calendarDataSecurityRoleLinksSetLinksParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(calendarDataSecurityRoleLinksSetLinksParam !== undefined ? calendarDataSecurityRoleLinksSetLinksParam : {}) : (calendarDataSecurityRoleLinksSetLinksParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendarDataSecurityRoleLinksApi - functional programming interface
 * @export
 */
export const CalendarDataSecurityRoleLinksApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Deletes security role links from calendar data.
         * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks/Delete
         * @param {string} id Calendar data Id
         * @param {CalendarDataSecurityRoleLinksDeleteLinksParam} calendarDataSecurityRoleLinksDeleteLinksParam Parameter containing links which are deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDataSecurityRoleLinksDeleteLinks(id: string, calendarDataSecurityRoleLinksDeleteLinksParam: CalendarDataSecurityRoleLinksDeleteLinksParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await CalendarDataSecurityRoleLinksApiAxiosParamCreator(configuration).calendarDataSecurityRoleLinksDeleteLinks(id, calendarDataSecurityRoleLinksDeleteLinksParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets links for given calendar data
         * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks
         * @param {string} id Calendar data id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDataSecurityRoleLinksGetLinksByCalendarDataId(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarDataSecurityRoleLink>>> {
            const localVarAxiosArgs = await CalendarDataSecurityRoleLinksApiAxiosParamCreator(configuration).calendarDataSecurityRoleLinksGetLinksByCalendarDataId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets links for given security role
         * @summary /api/v2/SecurityRoles/{id}/CalendarDataSecurityRoleLinks
         * @param {string} id Security role id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDataSecurityRoleLinksGetLinksBySecurityRoleId(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarDataSecurityRoleLink>>> {
            const localVarAxiosArgs = await CalendarDataSecurityRoleLinksApiAxiosParamCreator(configuration).calendarDataSecurityRoleLinksGetLinksBySecurityRoleId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Adds security role links to calendar data.
         * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks
         * @param {string} id Calendar data Id
         * @param {CalendarDataSecurityRoleLinksInsertLinksParam} calendarDataSecurityRoleLinksInsertLinksParam Parameter containing links which are added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDataSecurityRoleLinksInsertLinks(id: string, calendarDataSecurityRoleLinksInsertLinksParam: CalendarDataSecurityRoleLinksInsertLinksParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await CalendarDataSecurityRoleLinksApiAxiosParamCreator(configuration).calendarDataSecurityRoleLinksInsertLinks(id, calendarDataSecurityRoleLinksInsertLinksParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Links calendar datas to security roles. The whole result set must be given when setting links because this method handles both adding/removing of links. If no links are given, clears all calendar data\'s links.
         * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks
         * @param {string} id Calendar data Id
         * @param {CalendarDataSecurityRoleLinksSetLinksParam} calendarDataSecurityRoleLinksSetLinksParam Parameter containing links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDataSecurityRoleLinksSetLinks(id: string, calendarDataSecurityRoleLinksSetLinksParam: CalendarDataSecurityRoleLinksSetLinksParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await CalendarDataSecurityRoleLinksApiAxiosParamCreator(configuration).calendarDataSecurityRoleLinksSetLinks(id, calendarDataSecurityRoleLinksSetLinksParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CalendarDataSecurityRoleLinksApi - factory interface
 * @export
 */
export const CalendarDataSecurityRoleLinksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Deletes security role links from calendar data.
         * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks/Delete
         * @param {string} id Calendar data Id
         * @param {CalendarDataSecurityRoleLinksDeleteLinksParam} calendarDataSecurityRoleLinksDeleteLinksParam Parameter containing links which are deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataSecurityRoleLinksDeleteLinks(id: string, calendarDataSecurityRoleLinksDeleteLinksParam: CalendarDataSecurityRoleLinksDeleteLinksParam, options?: any): AxiosPromise<any> {
            return CalendarDataSecurityRoleLinksApiFp(configuration).calendarDataSecurityRoleLinksDeleteLinks(id, calendarDataSecurityRoleLinksDeleteLinksParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets links for given calendar data
         * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks
         * @param {string} id Calendar data id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataSecurityRoleLinksGetLinksByCalendarDataId(id: string, options?: any): AxiosPromise<Array<CalendarDataSecurityRoleLink>> {
            return CalendarDataSecurityRoleLinksApiFp(configuration).calendarDataSecurityRoleLinksGetLinksByCalendarDataId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets links for given security role
         * @summary /api/v2/SecurityRoles/{id}/CalendarDataSecurityRoleLinks
         * @param {string} id Security role id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataSecurityRoleLinksGetLinksBySecurityRoleId(id: string, options?: any): AxiosPromise<Array<CalendarDataSecurityRoleLink>> {
            return CalendarDataSecurityRoleLinksApiFp(configuration).calendarDataSecurityRoleLinksGetLinksBySecurityRoleId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds security role links to calendar data.
         * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks
         * @param {string} id Calendar data Id
         * @param {CalendarDataSecurityRoleLinksInsertLinksParam} calendarDataSecurityRoleLinksInsertLinksParam Parameter containing links which are added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataSecurityRoleLinksInsertLinks(id: string, calendarDataSecurityRoleLinksInsertLinksParam: CalendarDataSecurityRoleLinksInsertLinksParam, options?: any): AxiosPromise<any> {
            return CalendarDataSecurityRoleLinksApiFp(configuration).calendarDataSecurityRoleLinksInsertLinks(id, calendarDataSecurityRoleLinksInsertLinksParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Links calendar datas to security roles. The whole result set must be given when setting links because this method handles both adding/removing of links. If no links are given, clears all calendar data\'s links.
         * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks
         * @param {string} id Calendar data Id
         * @param {CalendarDataSecurityRoleLinksSetLinksParam} calendarDataSecurityRoleLinksSetLinksParam Parameter containing links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataSecurityRoleLinksSetLinks(id: string, calendarDataSecurityRoleLinksSetLinksParam: CalendarDataSecurityRoleLinksSetLinksParam, options?: any): AxiosPromise<any> {
            return CalendarDataSecurityRoleLinksApiFp(configuration).calendarDataSecurityRoleLinksSetLinks(id, calendarDataSecurityRoleLinksSetLinksParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendarDataSecurityRoleLinksApi - object-oriented interface
 * @export
 * @class CalendarDataSecurityRoleLinksApi
 * @extends {BaseAPI}
 */
export class CalendarDataSecurityRoleLinksApi extends BaseAPI {
    /**
     * Deletes security role links from calendar data.
     * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks/Delete
     * @param {string} id Calendar data Id
     * @param {CalendarDataSecurityRoleLinksDeleteLinksParam} calendarDataSecurityRoleLinksDeleteLinksParam Parameter containing links which are deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDataSecurityRoleLinksApi
     */
    public calendarDataSecurityRoleLinksDeleteLinks(id: string, calendarDataSecurityRoleLinksDeleteLinksParam: CalendarDataSecurityRoleLinksDeleteLinksParam, options?: any) {
        return CalendarDataSecurityRoleLinksApiFp(this.configuration).calendarDataSecurityRoleLinksDeleteLinks(id, calendarDataSecurityRoleLinksDeleteLinksParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets links for given calendar data
     * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks
     * @param {string} id Calendar data id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDataSecurityRoleLinksApi
     */
    public calendarDataSecurityRoleLinksGetLinksByCalendarDataId(id: string, options?: any) {
        return CalendarDataSecurityRoleLinksApiFp(this.configuration).calendarDataSecurityRoleLinksGetLinksByCalendarDataId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets links for given security role
     * @summary /api/v2/SecurityRoles/{id}/CalendarDataSecurityRoleLinks
     * @param {string} id Security role id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDataSecurityRoleLinksApi
     */
    public calendarDataSecurityRoleLinksGetLinksBySecurityRoleId(id: string, options?: any) {
        return CalendarDataSecurityRoleLinksApiFp(this.configuration).calendarDataSecurityRoleLinksGetLinksBySecurityRoleId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds security role links to calendar data.
     * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks
     * @param {string} id Calendar data Id
     * @param {CalendarDataSecurityRoleLinksInsertLinksParam} calendarDataSecurityRoleLinksInsertLinksParam Parameter containing links which are added
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDataSecurityRoleLinksApi
     */
    public calendarDataSecurityRoleLinksInsertLinks(id: string, calendarDataSecurityRoleLinksInsertLinksParam: CalendarDataSecurityRoleLinksInsertLinksParam, options?: any) {
        return CalendarDataSecurityRoleLinksApiFp(this.configuration).calendarDataSecurityRoleLinksInsertLinks(id, calendarDataSecurityRoleLinksInsertLinksParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Links calendar datas to security roles. The whole result set must be given when setting links because this method handles both adding/removing of links. If no links are given, clears all calendar data\'s links.
     * @summary /api/v2/CalendarDatas/{id}/CalendarDataSecurityRoleLinks
     * @param {string} id Calendar data Id
     * @param {CalendarDataSecurityRoleLinksSetLinksParam} calendarDataSecurityRoleLinksSetLinksParam Parameter containing links
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDataSecurityRoleLinksApi
     */
    public calendarDataSecurityRoleLinksSetLinks(id: string, calendarDataSecurityRoleLinksSetLinksParam: CalendarDataSecurityRoleLinksSetLinksParam, options?: any) {
        return CalendarDataSecurityRoleLinksApiFp(this.configuration).calendarDataSecurityRoleLinksSetLinks(id, calendarDataSecurityRoleLinksSetLinksParam, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CalendarDataTitlesApi - axios parameter creator
 * @export
 */
export const CalendarDataTitlesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes calendar by id
         * @summary /api/v2/CalendarDataTitles/{id}
         * @param {string} id Calendar id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataTitlesDelete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling calendarDataTitlesDelete.');
            }
            const localVarPath = `/api/v2/CalendarDataTitles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all calendars user has access to
         * @summary /api/v2/CalendarDataTitles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataTitlesGetAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/CalendarDataTitles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets given calendar\'s information
         * @summary /api/v2/CalendarDataTitles/{id}
         * @param {string} id Calendar data title id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataTitlesGetById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling calendarDataTitlesGetById.');
            }
            const localVarPath = `/api/v2/CalendarDataTitles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds new calendar
         * @summary /api/v2/CalendarDataTitles
         * @param {CalendarDataTitle} calendarDataTitle Calendar to insert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataTitlesInsert: async (calendarDataTitle: CalendarDataTitle, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarDataTitle' is not null or undefined
            if (calendarDataTitle === null || calendarDataTitle === undefined) {
                throw new RequiredError('calendarDataTitle','Required parameter calendarDataTitle was null or undefined when calling calendarDataTitlesInsert.');
            }
            const localVarPath = `/api/v2/CalendarDataTitles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof calendarDataTitle !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(calendarDataTitle !== undefined ? calendarDataTitle : {}) : (calendarDataTitle || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates existing calendar
         * @summary /api/v2/CalendarDataTitles
         * @param {CalendarDataTitle} calendarDataTitle Calendar to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataTitlesUpdate: async (calendarDataTitle: CalendarDataTitle, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarDataTitle' is not null or undefined
            if (calendarDataTitle === null || calendarDataTitle === undefined) {
                throw new RequiredError('calendarDataTitle','Required parameter calendarDataTitle was null or undefined when calling calendarDataTitlesUpdate.');
            }
            const localVarPath = `/api/v2/CalendarDataTitles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof calendarDataTitle !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(calendarDataTitle !== undefined ? calendarDataTitle : {}) : (calendarDataTitle || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendarDataTitlesApi - functional programming interface
 * @export
 */
export const CalendarDataTitlesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Deletes calendar by id
         * @summary /api/v2/CalendarDataTitles/{id}
         * @param {string} id Calendar id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDataTitlesDelete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await CalendarDataTitlesApiAxiosParamCreator(configuration).calendarDataTitlesDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns all calendars user has access to
         * @summary /api/v2/CalendarDataTitles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDataTitlesGetAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarDataTitle>>> {
            const localVarAxiosArgs = await CalendarDataTitlesApiAxiosParamCreator(configuration).calendarDataTitlesGetAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets given calendar\'s information
         * @summary /api/v2/CalendarDataTitles/{id}
         * @param {string} id Calendar data title id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDataTitlesGetById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarDataTitle>> {
            const localVarAxiosArgs = await CalendarDataTitlesApiAxiosParamCreator(configuration).calendarDataTitlesGetById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Adds new calendar
         * @summary /api/v2/CalendarDataTitles
         * @param {CalendarDataTitle} calendarDataTitle Calendar to insert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDataTitlesInsert(calendarDataTitle: CalendarDataTitle, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await CalendarDataTitlesApiAxiosParamCreator(configuration).calendarDataTitlesInsert(calendarDataTitle, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates existing calendar
         * @summary /api/v2/CalendarDataTitles
         * @param {CalendarDataTitle} calendarDataTitle Calendar to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDataTitlesUpdate(calendarDataTitle: CalendarDataTitle, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await CalendarDataTitlesApiAxiosParamCreator(configuration).calendarDataTitlesUpdate(calendarDataTitle, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CalendarDataTitlesApi - factory interface
 * @export
 */
export const CalendarDataTitlesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Deletes calendar by id
         * @summary /api/v2/CalendarDataTitles/{id}
         * @param {string} id Calendar id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataTitlesDelete(id: string, options?: any): AxiosPromise<any> {
            return CalendarDataTitlesApiFp(configuration).calendarDataTitlesDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all calendars user has access to
         * @summary /api/v2/CalendarDataTitles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataTitlesGetAll(options?: any): AxiosPromise<Array<CalendarDataTitle>> {
            return CalendarDataTitlesApiFp(configuration).calendarDataTitlesGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets given calendar\'s information
         * @summary /api/v2/CalendarDataTitles/{id}
         * @param {string} id Calendar data title id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataTitlesGetById(id: string, options?: any): AxiosPromise<CalendarDataTitle> {
            return CalendarDataTitlesApiFp(configuration).calendarDataTitlesGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds new calendar
         * @summary /api/v2/CalendarDataTitles
         * @param {CalendarDataTitle} calendarDataTitle Calendar to insert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataTitlesInsert(calendarDataTitle: CalendarDataTitle, options?: any): AxiosPromise<any> {
            return CalendarDataTitlesApiFp(configuration).calendarDataTitlesInsert(calendarDataTitle, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates existing calendar
         * @summary /api/v2/CalendarDataTitles
         * @param {CalendarDataTitle} calendarDataTitle Calendar to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDataTitlesUpdate(calendarDataTitle: CalendarDataTitle, options?: any): AxiosPromise<any> {
            return CalendarDataTitlesApiFp(configuration).calendarDataTitlesUpdate(calendarDataTitle, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendarDataTitlesApi - object-oriented interface
 * @export
 * @class CalendarDataTitlesApi
 * @extends {BaseAPI}
 */
export class CalendarDataTitlesApi extends BaseAPI {
    /**
     * Deletes calendar by id
     * @summary /api/v2/CalendarDataTitles/{id}
     * @param {string} id Calendar id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDataTitlesApi
     */
    public calendarDataTitlesDelete(id: string, options?: any) {
        return CalendarDataTitlesApiFp(this.configuration).calendarDataTitlesDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all calendars user has access to
     * @summary /api/v2/CalendarDataTitles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDataTitlesApi
     */
    public calendarDataTitlesGetAll(options?: any) {
        return CalendarDataTitlesApiFp(this.configuration).calendarDataTitlesGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets given calendar\'s information
     * @summary /api/v2/CalendarDataTitles/{id}
     * @param {string} id Calendar data title id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDataTitlesApi
     */
    public calendarDataTitlesGetById(id: string, options?: any) {
        return CalendarDataTitlesApiFp(this.configuration).calendarDataTitlesGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds new calendar
     * @summary /api/v2/CalendarDataTitles
     * @param {CalendarDataTitle} calendarDataTitle Calendar to insert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDataTitlesApi
     */
    public calendarDataTitlesInsert(calendarDataTitle: CalendarDataTitle, options?: any) {
        return CalendarDataTitlesApiFp(this.configuration).calendarDataTitlesInsert(calendarDataTitle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates existing calendar
     * @summary /api/v2/CalendarDataTitles
     * @param {CalendarDataTitle} calendarDataTitle Calendar to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDataTitlesApi
     */
    public calendarDataTitlesUpdate(calendarDataTitle: CalendarDataTitle, options?: any) {
        return CalendarDataTitlesApiFp(this.configuration).calendarDataTitlesUpdate(calendarDataTitle, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CalendarDatasApi - axios parameter creator
 * @export
 */
export const CalendarDatasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes calendar data
         * @summary /api/v2/CalendarDatas/{id}
         * @param {string} id Calendar data id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDatasDelete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling calendarDatasDelete.');
            }
            const localVarPath = `/api/v2/CalendarDatas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns calendar data information by calendar data id
         * @summary /api/v2/CalendarDatas/{id}
         * @param {string} id Calendar data id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDatasGetByCalendarDataId: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling calendarDatasGetByCalendarDataId.');
            }
            const localVarPath = `/api/v2/CalendarDatas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns calendar data for given calendar
         * @summary /api/v2/CalendarDataTitles/{id}/CalendarDatas
         * @param {string} id Calendar id
         * @param {string} [startDate] Start date to filter result set
         * @param {string} [endDate] End date to filter result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDatasGetByCalendarId: async (id: string, startDate?: string, endDate?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling calendarDatasGetByCalendarId.');
            }
            const localVarPath = `/api/v2/CalendarDataTitles/{id}/CalendarDatas`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds calendar data
         * @summary /api/v2/CalendarDatas
         * @param {CalendarDataInsertParam} calendarDataInsertParam Insert data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDatasInsert: async (calendarDataInsertParam: CalendarDataInsertParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarDataInsertParam' is not null or undefined
            if (calendarDataInsertParam === null || calendarDataInsertParam === undefined) {
                throw new RequiredError('calendarDataInsertParam','Required parameter calendarDataInsertParam was null or undefined when calling calendarDatasInsert.');
            }
            const localVarPath = `/api/v2/CalendarDatas`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof calendarDataInsertParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(calendarDataInsertParam !== undefined ? calendarDataInsertParam : {}) : (calendarDataInsertParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates calendar data
         * @summary /api/v2/CalendarDatas
         * @param {CalendarDataUpdateParam} calendarDataUpdateParam Update data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDatasUpdate: async (calendarDataUpdateParam: CalendarDataUpdateParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarDataUpdateParam' is not null or undefined
            if (calendarDataUpdateParam === null || calendarDataUpdateParam === undefined) {
                throw new RequiredError('calendarDataUpdateParam','Required parameter calendarDataUpdateParam was null or undefined when calling calendarDatasUpdate.');
            }
            const localVarPath = `/api/v2/CalendarDatas`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof calendarDataUpdateParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(calendarDataUpdateParam !== undefined ? calendarDataUpdateParam : {}) : (calendarDataUpdateParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendarDatasApi - functional programming interface
 * @export
 */
export const CalendarDatasApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Deletes calendar data
         * @summary /api/v2/CalendarDatas/{id}
         * @param {string} id Calendar data id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDatasDelete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await CalendarDatasApiAxiosParamCreator(configuration).calendarDatasDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns calendar data information by calendar data id
         * @summary /api/v2/CalendarDatas/{id}
         * @param {string} id Calendar data id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDatasGetByCalendarDataId(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarDataGetByCalendarDataIdResult>> {
            const localVarAxiosArgs = await CalendarDatasApiAxiosParamCreator(configuration).calendarDatasGetByCalendarDataId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns calendar data for given calendar
         * @summary /api/v2/CalendarDataTitles/{id}/CalendarDatas
         * @param {string} id Calendar id
         * @param {string} [startDate] Start date to filter result set
         * @param {string} [endDate] End date to filter result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDatasGetByCalendarId(id: string, startDate?: string, endDate?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarDataGetByCalendarIdResult>> {
            const localVarAxiosArgs = await CalendarDatasApiAxiosParamCreator(configuration).calendarDatasGetByCalendarId(id, startDate, endDate, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Adds calendar data
         * @summary /api/v2/CalendarDatas
         * @param {CalendarDataInsertParam} calendarDataInsertParam Insert data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDatasInsert(calendarDataInsertParam: CalendarDataInsertParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await CalendarDatasApiAxiosParamCreator(configuration).calendarDatasInsert(calendarDataInsertParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates calendar data
         * @summary /api/v2/CalendarDatas
         * @param {CalendarDataUpdateParam} calendarDataUpdateParam Update data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarDatasUpdate(calendarDataUpdateParam: CalendarDataUpdateParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await CalendarDatasApiAxiosParamCreator(configuration).calendarDatasUpdate(calendarDataUpdateParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CalendarDatasApi - factory interface
 * @export
 */
export const CalendarDatasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Deletes calendar data
         * @summary /api/v2/CalendarDatas/{id}
         * @param {string} id Calendar data id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDatasDelete(id: string, options?: any): AxiosPromise<any> {
            return CalendarDatasApiFp(configuration).calendarDatasDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns calendar data information by calendar data id
         * @summary /api/v2/CalendarDatas/{id}
         * @param {string} id Calendar data id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDatasGetByCalendarDataId(id: string, options?: any): AxiosPromise<CalendarDataGetByCalendarDataIdResult> {
            return CalendarDatasApiFp(configuration).calendarDatasGetByCalendarDataId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns calendar data for given calendar
         * @summary /api/v2/CalendarDataTitles/{id}/CalendarDatas
         * @param {string} id Calendar id
         * @param {string} [startDate] Start date to filter result set
         * @param {string} [endDate] End date to filter result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDatasGetByCalendarId(id: string, startDate?: string, endDate?: string, options?: any): AxiosPromise<CalendarDataGetByCalendarIdResult> {
            return CalendarDatasApiFp(configuration).calendarDatasGetByCalendarId(id, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds calendar data
         * @summary /api/v2/CalendarDatas
         * @param {CalendarDataInsertParam} calendarDataInsertParam Insert data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDatasInsert(calendarDataInsertParam: CalendarDataInsertParam, options?: any): AxiosPromise<any> {
            return CalendarDatasApiFp(configuration).calendarDatasInsert(calendarDataInsertParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates calendar data
         * @summary /api/v2/CalendarDatas
         * @param {CalendarDataUpdateParam} calendarDataUpdateParam Update data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarDatasUpdate(calendarDataUpdateParam: CalendarDataUpdateParam, options?: any): AxiosPromise<any> {
            return CalendarDatasApiFp(configuration).calendarDatasUpdate(calendarDataUpdateParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendarDatasApi - object-oriented interface
 * @export
 * @class CalendarDatasApi
 * @extends {BaseAPI}
 */
export class CalendarDatasApi extends BaseAPI {
    /**
     * Deletes calendar data
     * @summary /api/v2/CalendarDatas/{id}
     * @param {string} id Calendar data id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDatasApi
     */
    public calendarDatasDelete(id: string, options?: any) {
        return CalendarDatasApiFp(this.configuration).calendarDatasDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns calendar data information by calendar data id
     * @summary /api/v2/CalendarDatas/{id}
     * @param {string} id Calendar data id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDatasApi
     */
    public calendarDatasGetByCalendarDataId(id: string, options?: any) {
        return CalendarDatasApiFp(this.configuration).calendarDatasGetByCalendarDataId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns calendar data for given calendar
     * @summary /api/v2/CalendarDataTitles/{id}/CalendarDatas
     * @param {string} id Calendar id
     * @param {string} [startDate] Start date to filter result set
     * @param {string} [endDate] End date to filter result set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDatasApi
     */
    public calendarDatasGetByCalendarId(id: string, startDate?: string, endDate?: string, options?: any) {
        return CalendarDatasApiFp(this.configuration).calendarDatasGetByCalendarId(id, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds calendar data
     * @summary /api/v2/CalendarDatas
     * @param {CalendarDataInsertParam} calendarDataInsertParam Insert data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDatasApi
     */
    public calendarDatasInsert(calendarDataInsertParam: CalendarDataInsertParam, options?: any) {
        return CalendarDatasApiFp(this.configuration).calendarDatasInsert(calendarDataInsertParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates calendar data
     * @summary /api/v2/CalendarDatas
     * @param {CalendarDataUpdateParam} calendarDataUpdateParam Update data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarDatasApi
     */
    public calendarDatasUpdate(calendarDataUpdateParam: CalendarDataUpdateParam, options?: any) {
        return CalendarDatasApiFp(this.configuration).calendarDatasUpdate(calendarDataUpdateParam, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CalendarNetworkModuleRelayLinksApi - axios parameter creator
 * @export
 */
export const CalendarNetworkModuleRelayLinksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets links for given calendar
         * @summary /api/v2/CalendarDataTitles/{id}/CalendarNetworkModuleDeviceRelayLinks
         * @param {string} id Calendar id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarNetworkModuleRelayLinksGetLinksByCalendarId: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling calendarNetworkModuleRelayLinksGetLinksByCalendarId.');
            }
            const localVarPath = `/api/v2/CalendarDataTitles/{id}/CalendarNetworkModuleDeviceRelayLinks`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets links for given network module device relay
         * @summary /api/v2/NetworkModuleDeviceRelays/{id}/CalendarNetworkModuleDeviceRelayLinks
         * @param {string} id Network module device relay id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarNetworkModuleRelayLinksGetLinksByNetworkModuleRelayId: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling calendarNetworkModuleRelayLinksGetLinksByNetworkModuleRelayId.');
            }
            const localVarPath = `/api/v2/NetworkModuleDeviceRelays/{id}/CalendarNetworkModuleDeviceRelayLinks`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Links calendars to network module device relays. The whole result set must be given when setting links because this method handles both adding/removing of links. If no links are given, clears all calendar\'s links.
         * @summary /api/v2/CalendarDataTitles/{id}/CalendarNetworkModuleDeviceRelayLinks
         * @param {string} id 
         * @param {CalendarNetworkModuleDeviceRelayLinksSetLinksParam} calendarNetworkModuleDeviceRelayLinksSetLinksParam Parameter containing links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarNetworkModuleRelayLinksSetLinks: async (id: string, calendarNetworkModuleDeviceRelayLinksSetLinksParam: CalendarNetworkModuleDeviceRelayLinksSetLinksParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling calendarNetworkModuleRelayLinksSetLinks.');
            }
            // verify required parameter 'calendarNetworkModuleDeviceRelayLinksSetLinksParam' is not null or undefined
            if (calendarNetworkModuleDeviceRelayLinksSetLinksParam === null || calendarNetworkModuleDeviceRelayLinksSetLinksParam === undefined) {
                throw new RequiredError('calendarNetworkModuleDeviceRelayLinksSetLinksParam','Required parameter calendarNetworkModuleDeviceRelayLinksSetLinksParam was null or undefined when calling calendarNetworkModuleRelayLinksSetLinks.');
            }
            const localVarPath = `/api/v2/CalendarDataTitles/{id}/CalendarNetworkModuleDeviceRelayLinks`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof calendarNetworkModuleDeviceRelayLinksSetLinksParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(calendarNetworkModuleDeviceRelayLinksSetLinksParam !== undefined ? calendarNetworkModuleDeviceRelayLinksSetLinksParam : {}) : (calendarNetworkModuleDeviceRelayLinksSetLinksParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendarNetworkModuleRelayLinksApi - functional programming interface
 * @export
 */
export const CalendarNetworkModuleRelayLinksApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Gets links for given calendar
         * @summary /api/v2/CalendarDataTitles/{id}/CalendarNetworkModuleDeviceRelayLinks
         * @param {string} id Calendar id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarNetworkModuleRelayLinksGetLinksByCalendarId(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarNetworkModuleRelayLink>>> {
            const localVarAxiosArgs = await CalendarNetworkModuleRelayLinksApiAxiosParamCreator(configuration).calendarNetworkModuleRelayLinksGetLinksByCalendarId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets links for given network module device relay
         * @summary /api/v2/NetworkModuleDeviceRelays/{id}/CalendarNetworkModuleDeviceRelayLinks
         * @param {string} id Network module device relay id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarNetworkModuleRelayLinksGetLinksByNetworkModuleRelayId(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarNetworkModuleRelayLink>>> {
            const localVarAxiosArgs = await CalendarNetworkModuleRelayLinksApiAxiosParamCreator(configuration).calendarNetworkModuleRelayLinksGetLinksByNetworkModuleRelayId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Links calendars to network module device relays. The whole result set must be given when setting links because this method handles both adding/removing of links. If no links are given, clears all calendar\'s links.
         * @summary /api/v2/CalendarDataTitles/{id}/CalendarNetworkModuleDeviceRelayLinks
         * @param {string} id 
         * @param {CalendarNetworkModuleDeviceRelayLinksSetLinksParam} calendarNetworkModuleDeviceRelayLinksSetLinksParam Parameter containing links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarNetworkModuleRelayLinksSetLinks(id: string, calendarNetworkModuleDeviceRelayLinksSetLinksParam: CalendarNetworkModuleDeviceRelayLinksSetLinksParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await CalendarNetworkModuleRelayLinksApiAxiosParamCreator(configuration).calendarNetworkModuleRelayLinksSetLinks(id, calendarNetworkModuleDeviceRelayLinksSetLinksParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CalendarNetworkModuleRelayLinksApi - factory interface
 * @export
 */
export const CalendarNetworkModuleRelayLinksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Gets links for given calendar
         * @summary /api/v2/CalendarDataTitles/{id}/CalendarNetworkModuleDeviceRelayLinks
         * @param {string} id Calendar id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarNetworkModuleRelayLinksGetLinksByCalendarId(id: string, options?: any): AxiosPromise<Array<CalendarNetworkModuleRelayLink>> {
            return CalendarNetworkModuleRelayLinksApiFp(configuration).calendarNetworkModuleRelayLinksGetLinksByCalendarId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets links for given network module device relay
         * @summary /api/v2/NetworkModuleDeviceRelays/{id}/CalendarNetworkModuleDeviceRelayLinks
         * @param {string} id Network module device relay id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarNetworkModuleRelayLinksGetLinksByNetworkModuleRelayId(id: string, options?: any): AxiosPromise<Array<CalendarNetworkModuleRelayLink>> {
            return CalendarNetworkModuleRelayLinksApiFp(configuration).calendarNetworkModuleRelayLinksGetLinksByNetworkModuleRelayId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Links calendars to network module device relays. The whole result set must be given when setting links because this method handles both adding/removing of links. If no links are given, clears all calendar\'s links.
         * @summary /api/v2/CalendarDataTitles/{id}/CalendarNetworkModuleDeviceRelayLinks
         * @param {string} id 
         * @param {CalendarNetworkModuleDeviceRelayLinksSetLinksParam} calendarNetworkModuleDeviceRelayLinksSetLinksParam Parameter containing links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarNetworkModuleRelayLinksSetLinks(id: string, calendarNetworkModuleDeviceRelayLinksSetLinksParam: CalendarNetworkModuleDeviceRelayLinksSetLinksParam, options?: any): AxiosPromise<any> {
            return CalendarNetworkModuleRelayLinksApiFp(configuration).calendarNetworkModuleRelayLinksSetLinks(id, calendarNetworkModuleDeviceRelayLinksSetLinksParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendarNetworkModuleRelayLinksApi - object-oriented interface
 * @export
 * @class CalendarNetworkModuleRelayLinksApi
 * @extends {BaseAPI}
 */
export class CalendarNetworkModuleRelayLinksApi extends BaseAPI {
    /**
     * Gets links for given calendar
     * @summary /api/v2/CalendarDataTitles/{id}/CalendarNetworkModuleDeviceRelayLinks
     * @param {string} id Calendar id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarNetworkModuleRelayLinksApi
     */
    public calendarNetworkModuleRelayLinksGetLinksByCalendarId(id: string, options?: any) {
        return CalendarNetworkModuleRelayLinksApiFp(this.configuration).calendarNetworkModuleRelayLinksGetLinksByCalendarId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets links for given network module device relay
     * @summary /api/v2/NetworkModuleDeviceRelays/{id}/CalendarNetworkModuleDeviceRelayLinks
     * @param {string} id Network module device relay id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarNetworkModuleRelayLinksApi
     */
    public calendarNetworkModuleRelayLinksGetLinksByNetworkModuleRelayId(id: string, options?: any) {
        return CalendarNetworkModuleRelayLinksApiFp(this.configuration).calendarNetworkModuleRelayLinksGetLinksByNetworkModuleRelayId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Links calendars to network module device relays. The whole result set must be given when setting links because this method handles both adding/removing of links. If no links are given, clears all calendar\'s links.
     * @summary /api/v2/CalendarDataTitles/{id}/CalendarNetworkModuleDeviceRelayLinks
     * @param {string} id 
     * @param {CalendarNetworkModuleDeviceRelayLinksSetLinksParam} calendarNetworkModuleDeviceRelayLinksSetLinksParam Parameter containing links
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarNetworkModuleRelayLinksApi
     */
    public calendarNetworkModuleRelayLinksSetLinks(id: string, calendarNetworkModuleDeviceRelayLinksSetLinksParam: CalendarNetworkModuleDeviceRelayLinksSetLinksParam, options?: any) {
        return CalendarNetworkModuleRelayLinksApiFp(this.configuration).calendarNetworkModuleRelayLinksSetLinks(id, calendarNetworkModuleDeviceRelayLinksSetLinksParam, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * KeyPhonesApi - axios parameter creator
 * @export
 */
export const KeyPhonesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns KeyPhone information by Key id
         * @summary /api/v2/Keys/{id}/KeyPhone
         * @param {string} id Key Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyPhonesGetByKeyId: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling keyPhonesGetByKeyId.');
            }
            const localVarPath = `/api/v2/Keys/{id}/KeyPhone`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates Key\'s phone information.
         * @summary /api/v2/KeyPhones
         * @param {UpdateKeyPhoneParam} updateKeyPhoneParam Parameter containing phone information and key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyPhonesUpdate: async (updateKeyPhoneParam: UpdateKeyPhoneParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateKeyPhoneParam' is not null or undefined
            if (updateKeyPhoneParam === null || updateKeyPhoneParam === undefined) {
                throw new RequiredError('updateKeyPhoneParam','Required parameter updateKeyPhoneParam was null or undefined when calling keyPhonesUpdate.');
            }
            const localVarPath = `/api/v2/KeyPhones`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateKeyPhoneParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateKeyPhoneParam !== undefined ? updateKeyPhoneParam : {}) : (updateKeyPhoneParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KeyPhonesApi - functional programming interface
 * @export
 */
export const KeyPhonesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns KeyPhone information by Key id
         * @summary /api/v2/Keys/{id}/KeyPhone
         * @param {string} id Key Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keyPhonesGetByKeyId(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KeyPhone>> {
            const localVarAxiosArgs = await KeyPhonesApiAxiosParamCreator(configuration).keyPhonesGetByKeyId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates Key\'s phone information.
         * @summary /api/v2/KeyPhones
         * @param {UpdateKeyPhoneParam} updateKeyPhoneParam Parameter containing phone information and key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keyPhonesUpdate(updateKeyPhoneParam: UpdateKeyPhoneParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await KeyPhonesApiAxiosParamCreator(configuration).keyPhonesUpdate(updateKeyPhoneParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * KeyPhonesApi - factory interface
 * @export
 */
export const KeyPhonesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns KeyPhone information by Key id
         * @summary /api/v2/Keys/{id}/KeyPhone
         * @param {string} id Key Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyPhonesGetByKeyId(id: string, options?: any): AxiosPromise<KeyPhone> {
            return KeyPhonesApiFp(configuration).keyPhonesGetByKeyId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates Key\'s phone information.
         * @summary /api/v2/KeyPhones
         * @param {UpdateKeyPhoneParam} updateKeyPhoneParam Parameter containing phone information and key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyPhonesUpdate(updateKeyPhoneParam: UpdateKeyPhoneParam, options?: any): AxiosPromise<any> {
            return KeyPhonesApiFp(configuration).keyPhonesUpdate(updateKeyPhoneParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KeyPhonesApi - object-oriented interface
 * @export
 * @class KeyPhonesApi
 * @extends {BaseAPI}
 */
export class KeyPhonesApi extends BaseAPI {
    /**
     * Returns KeyPhone information by Key id
     * @summary /api/v2/Keys/{id}/KeyPhone
     * @param {string} id Key Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeyPhonesApi
     */
    public keyPhonesGetByKeyId(id: string, options?: any) {
        return KeyPhonesApiFp(this.configuration).keyPhonesGetByKeyId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates Key\'s phone information.
     * @summary /api/v2/KeyPhones
     * @param {UpdateKeyPhoneParam} updateKeyPhoneParam Parameter containing phone information and key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeyPhonesApi
     */
    public keyPhonesUpdate(updateKeyPhoneParam: UpdateKeyPhoneParam, options?: any) {
        return KeyPhonesApiFp(this.configuration).keyPhonesUpdate(updateKeyPhoneParam, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * KeysApi - axios parameter creator
 * @export
 */
export const KeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Checks if key can be ordered. Only S50 Phone keys and S5 Series keys can be ordered using this public API.
         * @summary /api/v2/Keys/{id}/CanOrder
         * @param {string} id Key Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysCanOrderKey: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling keysCanOrderKey.');
            }
            const localVarPath = `/api/v2/Keys/{id}/CanOrder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if key can be returned. Only S50 Phone keys can be returned using this public API and only if the keys don\'t have anything else but API access rights.
         * @summary /api/v2/Keys/{id}/CanReturn
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysCanReturnKey: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling keysCanReturnKey.');
            }
            const localVarPath = `/api/v2/Keys/{id}/CanReturn`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if key\'s main zone can be updated.
         * @summary /api/v2/Keys/{id}/CanUpdateMainZone
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysCanUpdateKeyMainZone: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling keysCanUpdateKeyMainZone.');
            }
            const localVarPath = `/api/v2/Keys/{id}/CanUpdateMainZone`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes given key
         * @summary /api/v2/Keys/{id}
         * @param {string} id Key id to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysDelete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling keysDelete.');
            }
            const localVarPath = `/api/v2/Keys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets all keys in locking system user has rights to
         * @summary /api/v2/Keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysGetAllKeys: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Keys`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets key information by key id
         * @summary /api/v2/Keys/{id}
         * @param {string} id Key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysGetKey: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling keysGetKey.');
            }
            const localVarPath = `/api/v2/Keys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets keys linked to the given person by person id
         * @summary /api/v2/Persons/{id}/Keys
         * @param {string} id Person id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysGetKeysByPerson: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling keysGetKeysByPerson.');
            }
            const localVarPath = `/api/v2/Persons/{id}/Keys`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets key informations by keys\' rom ids
         * @summary /api/v2/Keys/GetByRomIds
         * @param {Array<string>} [romIds] Rom ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysGetKeysByRomIds: async (romIds?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Keys/GetByRomIds`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (romIds) {
                localVarQueryParameter['romIds'] = romIds;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets key\'s security accesses
         * @summary /api/v2/Keys/{id}/SecurityAccesses
         * @param {string} id Key id
         * @param {GetSecurityAccessesView} mode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysGetSecurityAccesses: async (id: string, mode: GetSecurityAccessesView, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling keysGetSecurityAccesses.');
            }
            // verify required parameter 'mode' is not null or undefined
            if (mode === null || mode === undefined) {
                throw new RequiredError('mode','Required parameter mode was null or undefined when calling keysGetSecurityAccesses.');
            }
            const localVarPath = `/api/v2/Keys/{id}/SecurityAccesses`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns key\'s time limits
         * @summary /api/v2/Keys/{id}/TimeLimitTitles
         * @param {string} id Key Id
         * @param {GetTimeLimitsView} mode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysGetTimeLimits: async (id: string, mode: GetTimeLimitsView, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling keysGetTimeLimits.');
            }
            // verify required parameter 'mode' is not null or undefined
            if (mode === null || mode === undefined) {
                throw new RequiredError('mode','Required parameter mode was null or undefined when calling keysGetTimeLimits.');
            }
            const localVarPath = `/api/v2/Keys/{id}/TimeLimitTitles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds new key
         * @summary /api/v2/Keys
         * @param {InsertKeyParam} insertKeyParam Parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysInsert: async (insertKeyParam: InsertKeyParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'insertKeyParam' is not null or undefined
            if (insertKeyParam === null || insertKeyParam === undefined) {
                throw new RequiredError('insertKeyParam','Required parameter insertKeyParam was null or undefined when calling keysInsert.');
            }
            const localVarPath = `/api/v2/Keys`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof insertKeyParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(insertKeyParam !== undefined ? insertKeyParam : {}) : (insertKeyParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Orders key. Only S50 Phone keys and 5 Series keys can be ordered using this public API.
         * @summary /api/v2/Keys/{id}/Order
         * @param {string} id Key Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysOrderKey: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling keysOrderKey.');
            }
            const localVarPath = `/api/v2/Keys/{id}/Order`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces a key with another key. Sets replaced key into blocklist. Only available for S10 keys.
         * @summary /api/v2/Keys/{id}/ReplaceWith/{replaceWithKeyId}
         * @param {string} id Key which is replaced
         * @param {string} replaceWithKeyId Id of the key which replaces the first key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysReplaceKey: async (id: string, replaceWithKeyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling keysReplaceKey.');
            }
            // verify required parameter 'replaceWithKeyId' is not null or undefined
            if (replaceWithKeyId === null || replaceWithKeyId === undefined) {
                throw new RequiredError('replaceWithKeyId','Required parameter replaceWithKeyId was null or undefined when calling keysReplaceKey.');
            }
            const localVarPath = `/api/v2/Keys/{id}/ReplaceWith/{replaceWithKeyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"replaceWithKeyId"}}`, encodeURIComponent(String(replaceWithKeyId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Order return task for key. Only S50 Phone keys can be returned using this public API and only if the keys don\'t have anything else but API access rights.
         * @summary /api/v2/Keys/{id}/Return
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysReturnKey: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling keysReturnKey.');
            }
            const localVarPath = `/api/v2/Keys/{id}/Return`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates existing key
         * @summary /api/v2/Keys
         * @param {UpdateKeyParam} updateKeyParam Parameter
         * @param {boolean} [updateVersionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysUpdate: async (updateKeyParam: UpdateKeyParam, updateVersionCode?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateKeyParam' is not null or undefined
            if (updateKeyParam === null || updateKeyParam === undefined) {
                throw new RequiredError('updateKeyParam','Required parameter updateKeyParam was null or undefined when calling keysUpdate.');
            }
            const localVarPath = `/api/v2/Keys`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (updateVersionCode !== undefined) {
                localVarQueryParameter['updateVersionCode'] = updateVersionCode;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateKeyParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateKeyParam !== undefined ? updateKeyParam : {}) : (updateKeyParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates key\'s main zone. In use in 5 series systems.
         * @summary /api/v2/Keys/{id}/UpdateMainZone
         * @param {string} id 
         * @param {UpdateKeyMainZoneParam} updateKeyMainZoneParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysUpdateMainZone: async (id: string, updateKeyMainZoneParam: UpdateKeyMainZoneParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling keysUpdateMainZone.');
            }
            // verify required parameter 'updateKeyMainZoneParam' is not null or undefined
            if (updateKeyMainZoneParam === null || updateKeyMainZoneParam === undefined) {
                throw new RequiredError('updateKeyMainZoneParam','Required parameter updateKeyMainZoneParam was null or undefined when calling keysUpdateMainZone.');
            }
            const localVarPath = `/api/v2/Keys/{id}/UpdateMainZone`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateKeyMainZoneParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateKeyMainZoneParam !== undefined ? updateKeyMainZoneParam : {}) : (updateKeyMainZoneParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates key\'s security accesses and time limits
         * @summary /api/v2/Keys/{id}/SecurityAccesses
         * @param {string} id Key id
         * @param {UpdateKeySecurityAccessesParam} updateKeySecurityAccessesParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysUpdateSecurityAccesses: async (id: string, updateKeySecurityAccessesParam: UpdateKeySecurityAccessesParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling keysUpdateSecurityAccesses.');
            }
            // verify required parameter 'updateKeySecurityAccessesParam' is not null or undefined
            if (updateKeySecurityAccessesParam === null || updateKeySecurityAccessesParam === undefined) {
                throw new RequiredError('updateKeySecurityAccessesParam','Required parameter updateKeySecurityAccessesParam was null or undefined when calling keysUpdateSecurityAccesses.');
            }
            const localVarPath = `/api/v2/Keys/{id}/SecurityAccesses`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateKeySecurityAccessesParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateKeySecurityAccessesParam !== undefined ? updateKeySecurityAccessesParam : {}) : (updateKeySecurityAccessesParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KeysApi - functional programming interface
 * @export
 */
export const KeysApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Checks if key can be ordered. Only S50 Phone keys and S5 Series keys can be ordered using this public API.
         * @summary /api/v2/Keys/{id}/CanOrder
         * @param {string} id Key Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysCanOrderKey(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CanOrderKeyResultType>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysCanOrderKey(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Checks if key can be returned. Only S50 Phone keys can be returned using this public API and only if the keys don\'t have anything else but API access rights.
         * @summary /api/v2/Keys/{id}/CanReturn
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysCanReturnKey(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CanReturnKeyResultType>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysCanReturnKey(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Checks if key\'s main zone can be updated.
         * @summary /api/v2/Keys/{id}/CanUpdateMainZone
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysCanUpdateKeyMainZone(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CanUpdateKeyMainZoneResult>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysCanUpdateKeyMainZone(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deletes given key
         * @summary /api/v2/Keys/{id}
         * @param {string} id Key id to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysDelete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets all keys in locking system user has rights to
         * @summary /api/v2/Keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysGetAllKeys(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Key>>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysGetAllKeys(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets key information by key id
         * @summary /api/v2/Keys/{id}
         * @param {string} id Key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysGetKey(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Key>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysGetKey(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets keys linked to the given person by person id
         * @summary /api/v2/Persons/{id}/Keys
         * @param {string} id Person id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysGetKeysByPerson(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetKeysByPersonResult>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysGetKeysByPerson(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets key informations by keys\' rom ids
         * @summary /api/v2/Keys/GetByRomIds
         * @param {Array<string>} [romIds] Rom ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysGetKeysByRomIds(romIds?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Key>>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysGetKeysByRomIds(romIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets key\'s security accesses
         * @summary /api/v2/Keys/{id}/SecurityAccesses
         * @param {string} id Key id
         * @param {GetSecurityAccessesView} mode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysGetSecurityAccesses(id: string, mode: GetSecurityAccessesView, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetKeySecurityAccessesResult>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysGetSecurityAccesses(id, mode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns key\'s time limits
         * @summary /api/v2/Keys/{id}/TimeLimitTitles
         * @param {string} id Key Id
         * @param {GetTimeLimitsView} mode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysGetTimeLimits(id: string, mode: GetTimeLimitsView, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTimeLimitsResult>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysGetTimeLimits(id, mode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Adds new key
         * @summary /api/v2/Keys
         * @param {InsertKeyParam} insertKeyParam Parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysInsert(insertKeyParam: InsertKeyParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Key>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysInsert(insertKeyParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Orders key. Only S50 Phone keys and 5 Series keys can be ordered using this public API.
         * @summary /api/v2/Keys/{id}/Order
         * @param {string} id Key Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysOrderKey(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysOrderKey(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Replaces a key with another key. Sets replaced key into blocklist. Only available for S10 keys.
         * @summary /api/v2/Keys/{id}/ReplaceWith/{replaceWithKeyId}
         * @param {string} id Key which is replaced
         * @param {string} replaceWithKeyId Id of the key which replaces the first key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysReplaceKey(id: string, replaceWithKeyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysReplaceKey(id, replaceWithKeyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Order return task for key. Only S50 Phone keys can be returned using this public API and only if the keys don\'t have anything else but API access rights.
         * @summary /api/v2/Keys/{id}/Return
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysReturnKey(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysReturnKey(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates existing key
         * @summary /api/v2/Keys
         * @param {UpdateKeyParam} updateKeyParam Parameter
         * @param {boolean} [updateVersionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysUpdate(updateKeyParam: UpdateKeyParam, updateVersionCode?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysUpdate(updateKeyParam, updateVersionCode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates key\'s main zone. In use in 5 series systems.
         * @summary /api/v2/Keys/{id}/UpdateMainZone
         * @param {string} id 
         * @param {UpdateKeyMainZoneParam} updateKeyMainZoneParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysUpdateMainZone(id: string, updateKeyMainZoneParam: UpdateKeyMainZoneParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysUpdateMainZone(id, updateKeyMainZoneParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates key\'s security accesses and time limits
         * @summary /api/v2/Keys/{id}/SecurityAccesses
         * @param {string} id Key id
         * @param {UpdateKeySecurityAccessesParam} updateKeySecurityAccessesParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keysUpdateSecurityAccesses(id: string, updateKeySecurityAccessesParam: UpdateKeySecurityAccessesParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await KeysApiAxiosParamCreator(configuration).keysUpdateSecurityAccesses(id, updateKeySecurityAccessesParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * KeysApi - factory interface
 * @export
 */
export const KeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Checks if key can be ordered. Only S50 Phone keys and S5 Series keys can be ordered using this public API.
         * @summary /api/v2/Keys/{id}/CanOrder
         * @param {string} id Key Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysCanOrderKey(id: string, options?: any): AxiosPromise<CanOrderKeyResultType> {
            return KeysApiFp(configuration).keysCanOrderKey(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if key can be returned. Only S50 Phone keys can be returned using this public API and only if the keys don\'t have anything else but API access rights.
         * @summary /api/v2/Keys/{id}/CanReturn
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysCanReturnKey(id: string, options?: any): AxiosPromise<CanReturnKeyResultType> {
            return KeysApiFp(configuration).keysCanReturnKey(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if key\'s main zone can be updated.
         * @summary /api/v2/Keys/{id}/CanUpdateMainZone
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysCanUpdateKeyMainZone(id: string, options?: any): AxiosPromise<CanUpdateKeyMainZoneResult> {
            return KeysApiFp(configuration).keysCanUpdateKeyMainZone(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes given key
         * @summary /api/v2/Keys/{id}
         * @param {string} id Key id to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysDelete(id: string, options?: any): AxiosPromise<any> {
            return KeysApiFp(configuration).keysDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all keys in locking system user has rights to
         * @summary /api/v2/Keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysGetAllKeys(options?: any): AxiosPromise<Array<Key>> {
            return KeysApiFp(configuration).keysGetAllKeys(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets key information by key id
         * @summary /api/v2/Keys/{id}
         * @param {string} id Key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysGetKey(id: string, options?: any): AxiosPromise<Key> {
            return KeysApiFp(configuration).keysGetKey(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets keys linked to the given person by person id
         * @summary /api/v2/Persons/{id}/Keys
         * @param {string} id Person id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysGetKeysByPerson(id: string, options?: any): AxiosPromise<GetKeysByPersonResult> {
            return KeysApiFp(configuration).keysGetKeysByPerson(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets key informations by keys\' rom ids
         * @summary /api/v2/Keys/GetByRomIds
         * @param {Array<string>} [romIds] Rom ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysGetKeysByRomIds(romIds?: Array<string>, options?: any): AxiosPromise<Array<Key>> {
            return KeysApiFp(configuration).keysGetKeysByRomIds(romIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets key\'s security accesses
         * @summary /api/v2/Keys/{id}/SecurityAccesses
         * @param {string} id Key id
         * @param {GetSecurityAccessesView} mode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysGetSecurityAccesses(id: string, mode: GetSecurityAccessesView, options?: any): AxiosPromise<GetKeySecurityAccessesResult> {
            return KeysApiFp(configuration).keysGetSecurityAccesses(id, mode, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns key\'s time limits
         * @summary /api/v2/Keys/{id}/TimeLimitTitles
         * @param {string} id Key Id
         * @param {GetTimeLimitsView} mode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysGetTimeLimits(id: string, mode: GetTimeLimitsView, options?: any): AxiosPromise<GetTimeLimitsResult> {
            return KeysApiFp(configuration).keysGetTimeLimits(id, mode, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds new key
         * @summary /api/v2/Keys
         * @param {InsertKeyParam} insertKeyParam Parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysInsert(insertKeyParam: InsertKeyParam, options?: any): AxiosPromise<Key> {
            return KeysApiFp(configuration).keysInsert(insertKeyParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Orders key. Only S50 Phone keys and 5 Series keys can be ordered using this public API.
         * @summary /api/v2/Keys/{id}/Order
         * @param {string} id Key Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysOrderKey(id: string, options?: any): AxiosPromise<any> {
            return KeysApiFp(configuration).keysOrderKey(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces a key with another key. Sets replaced key into blocklist. Only available for S10 keys.
         * @summary /api/v2/Keys/{id}/ReplaceWith/{replaceWithKeyId}
         * @param {string} id Key which is replaced
         * @param {string} replaceWithKeyId Id of the key which replaces the first key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysReplaceKey(id: string, replaceWithKeyId: string, options?: any): AxiosPromise<any> {
            return KeysApiFp(configuration).keysReplaceKey(id, replaceWithKeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Order return task for key. Only S50 Phone keys can be returned using this public API and only if the keys don\'t have anything else but API access rights.
         * @summary /api/v2/Keys/{id}/Return
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysReturnKey(id: string, options?: any): AxiosPromise<any> {
            return KeysApiFp(configuration).keysReturnKey(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates existing key
         * @summary /api/v2/Keys
         * @param {UpdateKeyParam} updateKeyParam Parameter
         * @param {boolean} [updateVersionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysUpdate(updateKeyParam: UpdateKeyParam, updateVersionCode?: boolean, options?: any): AxiosPromise<any> {
            return KeysApiFp(configuration).keysUpdate(updateKeyParam, updateVersionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates key\'s main zone. In use in 5 series systems.
         * @summary /api/v2/Keys/{id}/UpdateMainZone
         * @param {string} id 
         * @param {UpdateKeyMainZoneParam} updateKeyMainZoneParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysUpdateMainZone(id: string, updateKeyMainZoneParam: UpdateKeyMainZoneParam, options?: any): AxiosPromise<any> {
            return KeysApiFp(configuration).keysUpdateMainZone(id, updateKeyMainZoneParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates key\'s security accesses and time limits
         * @summary /api/v2/Keys/{id}/SecurityAccesses
         * @param {string} id Key id
         * @param {UpdateKeySecurityAccessesParam} updateKeySecurityAccessesParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keysUpdateSecurityAccesses(id: string, updateKeySecurityAccessesParam: UpdateKeySecurityAccessesParam, options?: any): AxiosPromise<any> {
            return KeysApiFp(configuration).keysUpdateSecurityAccesses(id, updateKeySecurityAccessesParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KeysApi - object-oriented interface
 * @export
 * @class KeysApi
 * @extends {BaseAPI}
 */
export class KeysApi extends BaseAPI {
    /**
     * Checks if key can be ordered. Only S50 Phone keys and S5 Series keys can be ordered using this public API.
     * @summary /api/v2/Keys/{id}/CanOrder
     * @param {string} id Key Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysCanOrderKey(id: string, options?: any) {
        return KeysApiFp(this.configuration).keysCanOrderKey(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if key can be returned. Only S50 Phone keys can be returned using this public API and only if the keys don\'t have anything else but API access rights.
     * @summary /api/v2/Keys/{id}/CanReturn
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysCanReturnKey(id: string, options?: any) {
        return KeysApiFp(this.configuration).keysCanReturnKey(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if key\'s main zone can be updated.
     * @summary /api/v2/Keys/{id}/CanUpdateMainZone
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysCanUpdateKeyMainZone(id: string, options?: any) {
        return KeysApiFp(this.configuration).keysCanUpdateKeyMainZone(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes given key
     * @summary /api/v2/Keys/{id}
     * @param {string} id Key id to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysDelete(id: string, options?: any) {
        return KeysApiFp(this.configuration).keysDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets all keys in locking system user has rights to
     * @summary /api/v2/Keys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysGetAllKeys(options?: any) {
        return KeysApiFp(this.configuration).keysGetAllKeys(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets key information by key id
     * @summary /api/v2/Keys/{id}
     * @param {string} id Key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysGetKey(id: string, options?: any) {
        return KeysApiFp(this.configuration).keysGetKey(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets keys linked to the given person by person id
     * @summary /api/v2/Persons/{id}/Keys
     * @param {string} id Person id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysGetKeysByPerson(id: string, options?: any) {
        return KeysApiFp(this.configuration).keysGetKeysByPerson(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets key informations by keys\' rom ids
     * @summary /api/v2/Keys/GetByRomIds
     * @param {Array<string>} [romIds] Rom ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysGetKeysByRomIds(romIds?: Array<string>, options?: any) {
        return KeysApiFp(this.configuration).keysGetKeysByRomIds(romIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets key\'s security accesses
     * @summary /api/v2/Keys/{id}/SecurityAccesses
     * @param {string} id Key id
     * @param {GetSecurityAccessesView} mode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysGetSecurityAccesses(id: string, mode: GetSecurityAccessesView, options?: any) {
        return KeysApiFp(this.configuration).keysGetSecurityAccesses(id, mode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns key\'s time limits
     * @summary /api/v2/Keys/{id}/TimeLimitTitles
     * @param {string} id Key Id
     * @param {GetTimeLimitsView} mode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysGetTimeLimits(id: string, mode: GetTimeLimitsView, options?: any) {
        return KeysApiFp(this.configuration).keysGetTimeLimits(id, mode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds new key
     * @summary /api/v2/Keys
     * @param {InsertKeyParam} insertKeyParam Parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysInsert(insertKeyParam: InsertKeyParam, options?: any) {
        return KeysApiFp(this.configuration).keysInsert(insertKeyParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Orders key. Only S50 Phone keys and 5 Series keys can be ordered using this public API.
     * @summary /api/v2/Keys/{id}/Order
     * @param {string} id Key Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysOrderKey(id: string, options?: any) {
        return KeysApiFp(this.configuration).keysOrderKey(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces a key with another key. Sets replaced key into blocklist. Only available for S10 keys.
     * @summary /api/v2/Keys/{id}/ReplaceWith/{replaceWithKeyId}
     * @param {string} id Key which is replaced
     * @param {string} replaceWithKeyId Id of the key which replaces the first key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysReplaceKey(id: string, replaceWithKeyId: string, options?: any) {
        return KeysApiFp(this.configuration).keysReplaceKey(id, replaceWithKeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Order return task for key. Only S50 Phone keys can be returned using this public API and only if the keys don\'t have anything else but API access rights.
     * @summary /api/v2/Keys/{id}/Return
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysReturnKey(id: string, options?: any) {
        return KeysApiFp(this.configuration).keysReturnKey(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates existing key
     * @summary /api/v2/Keys
     * @param {UpdateKeyParam} updateKeyParam Parameter
     * @param {boolean} [updateVersionCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysUpdate(updateKeyParam: UpdateKeyParam, updateVersionCode?: boolean, options?: any) {
        return KeysApiFp(this.configuration).keysUpdate(updateKeyParam, updateVersionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates key\'s main zone. In use in 5 series systems.
     * @summary /api/v2/Keys/{id}/UpdateMainZone
     * @param {string} id 
     * @param {UpdateKeyMainZoneParam} updateKeyMainZoneParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysUpdateMainZone(id: string, updateKeyMainZoneParam: UpdateKeyMainZoneParam, options?: any) {
        return KeysApiFp(this.configuration).keysUpdateMainZone(id, updateKeyMainZoneParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates key\'s security accesses and time limits
     * @summary /api/v2/Keys/{id}/SecurityAccesses
     * @param {string} id Key id
     * @param {UpdateKeySecurityAccessesParam} updateKeySecurityAccessesParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public keysUpdateSecurityAccesses(id: string, updateKeySecurityAccessesParam: UpdateKeySecurityAccessesParam, options?: any) {
        return KeysApiFp(this.configuration).keysUpdateSecurityAccesses(id, updateKeySecurityAccessesParam, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * LockGroupsApi - axios parameter creator
 * @export
 */
export const LockGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generates new access token. Access tokens are used to access certain external services.
         * @summary /api/v2/LockGroups/GenerateAccessToken
         * @param {GenerateAccessTokenParam} generateAccessTokenParam Access token generation parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockGroupsGenerateAccessToken: async (generateAccessTokenParam: GenerateAccessTokenParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateAccessTokenParam' is not null or undefined
            if (generateAccessTokenParam === null || generateAccessTokenParam === undefined) {
                throw new RequiredError('generateAccessTokenParam','Required parameter generateAccessTokenParam was null or undefined when calling lockGroupsGenerateAccessToken.');
            }
            const localVarPath = `/api/v2/LockGroups/GenerateAccessToken`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof generateAccessTokenParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(generateAccessTokenParam !== undefined ? generateAccessTokenParam : {}) : (generateAccessTokenParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets all locking systems available for user
         * @summary /api/v2/LockGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockGroupsGetAllLockGroups: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/LockGroups`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns locking system\'s connection settings
         * @summary /api/v2/LockGroups/ConnectionSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockGroupsGetConnectionSettings: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/LockGroups/ConnectionSettings`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LockGroupsApi - functional programming interface
 * @export
 */
export const LockGroupsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Generates new access token. Access tokens are used to access certain external services.
         * @summary /api/v2/LockGroups/GenerateAccessToken
         * @param {GenerateAccessTokenParam} generateAccessTokenParam Access token generation parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockGroupsGenerateAccessToken(generateAccessTokenParam: GenerateAccessTokenParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateAccessTokenResult>> {
            const localVarAxiosArgs = await LockGroupsApiAxiosParamCreator(configuration).lockGroupsGenerateAccessToken(generateAccessTokenParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets all locking systems available for user
         * @summary /api/v2/LockGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockGroupsGetAllLockGroups(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LockGroup>>> {
            const localVarAxiosArgs = await LockGroupsApiAxiosParamCreator(configuration).lockGroupsGetAllLockGroups(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns locking system\'s connection settings
         * @summary /api/v2/LockGroups/ConnectionSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockGroupsGetConnectionSettings(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetConnectionSettingsResult>> {
            const localVarAxiosArgs = await LockGroupsApiAxiosParamCreator(configuration).lockGroupsGetConnectionSettings(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LockGroupsApi - factory interface
 * @export
 */
export const LockGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Generates new access token. Access tokens are used to access certain external services.
         * @summary /api/v2/LockGroups/GenerateAccessToken
         * @param {GenerateAccessTokenParam} generateAccessTokenParam Access token generation parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockGroupsGenerateAccessToken(generateAccessTokenParam: GenerateAccessTokenParam, options?: any): AxiosPromise<GenerateAccessTokenResult> {
            return LockGroupsApiFp(configuration).lockGroupsGenerateAccessToken(generateAccessTokenParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all locking systems available for user
         * @summary /api/v2/LockGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockGroupsGetAllLockGroups(options?: any): AxiosPromise<Array<LockGroup>> {
            return LockGroupsApiFp(configuration).lockGroupsGetAllLockGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns locking system\'s connection settings
         * @summary /api/v2/LockGroups/ConnectionSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockGroupsGetConnectionSettings(options?: any): AxiosPromise<GetConnectionSettingsResult> {
            return LockGroupsApiFp(configuration).lockGroupsGetConnectionSettings(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LockGroupsApi - object-oriented interface
 * @export
 * @class LockGroupsApi
 * @extends {BaseAPI}
 */
export class LockGroupsApi extends BaseAPI {
    /**
     * Generates new access token. Access tokens are used to access certain external services.
     * @summary /api/v2/LockGroups/GenerateAccessToken
     * @param {GenerateAccessTokenParam} generateAccessTokenParam Access token generation parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LockGroupsApi
     */
    public lockGroupsGenerateAccessToken(generateAccessTokenParam: GenerateAccessTokenParam, options?: any) {
        return LockGroupsApiFp(this.configuration).lockGroupsGenerateAccessToken(generateAccessTokenParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets all locking systems available for user
     * @summary /api/v2/LockGroups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LockGroupsApi
     */
    public lockGroupsGetAllLockGroups(options?: any) {
        return LockGroupsApiFp(this.configuration).lockGroupsGetAllLockGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns locking system\'s connection settings
     * @summary /api/v2/LockGroups/ConnectionSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LockGroupsApi
     */
    public lockGroupsGetConnectionSettings(options?: any) {
        return LockGroupsApiFp(this.configuration).lockGroupsGetConnectionSettings(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * LockLogsApi - axios parameter creator
 * @export
 */
export const LockLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns lock logs by going dates
         * @summary /api/v2/LockLogs/GetLockLogDataByGoingDates
         * @param {GetLockLogDataParam} getLockLogDataParam Parameter containing start and end dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockLogsGetLockLogDataByGoingDates: async (getLockLogDataParam: GetLockLogDataParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getLockLogDataParam' is not null or undefined
            if (getLockLogDataParam === null || getLockLogDataParam === undefined) {
                throw new RequiredError('getLockLogDataParam','Required parameter getLockLogDataParam was null or undefined when calling lockLogsGetLockLogDataByGoingDates.');
            }
            const localVarPath = `/api/v2/LockLogs/GetLockLogDataByGoingDates`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof getLockLogDataParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(getLockLogDataParam !== undefined ? getLockLogDataParam : {}) : (getLockLogDataParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns lock logs by the time they were added to the database
         * @summary /api/v2/LockLogs/GetLockLogDataByTimestamp
         * @param {GetLockLogDataParam} getLockLogDataParam Parameter containing start and end dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockLogsGetLockLogDataByTimestamp: async (getLockLogDataParam: GetLockLogDataParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getLockLogDataParam' is not null or undefined
            if (getLockLogDataParam === null || getLockLogDataParam === undefined) {
                throw new RequiredError('getLockLogDataParam','Required parameter getLockLogDataParam was null or undefined when calling lockLogsGetLockLogDataByTimestamp.');
            }
            const localVarPath = `/api/v2/LockLogs/GetLockLogDataByTimestamp`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof getLockLogDataParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(getLockLogDataParam !== undefined ? getLockLogDataParam : {}) : (getLockLogDataParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns logs for keys/locks.
         * @summary /api/v2/LockLogs
         * @param {GetLockLogsParam} getLockLogsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockLogsGetLockLogs: async (getLockLogsParam: GetLockLogsParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getLockLogsParam' is not null or undefined
            if (getLockLogsParam === null || getLockLogsParam === undefined) {
                throw new RequiredError('getLockLogsParam','Required parameter getLockLogsParam was null or undefined when calling lockLogsGetLockLogs.');
            }
            const localVarPath = `/api/v2/LockLogs`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof getLockLogsParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(getLockLogsParam !== undefined ? getLockLogsParam : {}) : (getLockLogsParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LockLogsApi - functional programming interface
 * @export
 */
export const LockLogsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns lock logs by going dates
         * @summary /api/v2/LockLogs/GetLockLogDataByGoingDates
         * @param {GetLockLogDataParam} getLockLogDataParam Parameter containing start and end dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockLogsGetLockLogDataByGoingDates(getLockLogDataParam: GetLockLogDataParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLockLogDataResult>> {
            const localVarAxiosArgs = await LockLogsApiAxiosParamCreator(configuration).lockLogsGetLockLogDataByGoingDates(getLockLogDataParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns lock logs by the time they were added to the database
         * @summary /api/v2/LockLogs/GetLockLogDataByTimestamp
         * @param {GetLockLogDataParam} getLockLogDataParam Parameter containing start and end dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockLogsGetLockLogDataByTimestamp(getLockLogDataParam: GetLockLogDataParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLockLogDataResult>> {
            const localVarAxiosArgs = await LockLogsApiAxiosParamCreator(configuration).lockLogsGetLockLogDataByTimestamp(getLockLogDataParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns logs for keys/locks.
         * @summary /api/v2/LockLogs
         * @param {GetLockLogsParam} getLockLogsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockLogsGetLockLogs(getLockLogsParam: GetLockLogsParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLockLogsResult>> {
            const localVarAxiosArgs = await LockLogsApiAxiosParamCreator(configuration).lockLogsGetLockLogs(getLockLogsParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LockLogsApi - factory interface
 * @export
 */
export const LockLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns lock logs by going dates
         * @summary /api/v2/LockLogs/GetLockLogDataByGoingDates
         * @param {GetLockLogDataParam} getLockLogDataParam Parameter containing start and end dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockLogsGetLockLogDataByGoingDates(getLockLogDataParam: GetLockLogDataParam, options?: any): AxiosPromise<GetLockLogDataResult> {
            return LockLogsApiFp(configuration).lockLogsGetLockLogDataByGoingDates(getLockLogDataParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns lock logs by the time they were added to the database
         * @summary /api/v2/LockLogs/GetLockLogDataByTimestamp
         * @param {GetLockLogDataParam} getLockLogDataParam Parameter containing start and end dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockLogsGetLockLogDataByTimestamp(getLockLogDataParam: GetLockLogDataParam, options?: any): AxiosPromise<GetLockLogDataResult> {
            return LockLogsApiFp(configuration).lockLogsGetLockLogDataByTimestamp(getLockLogDataParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns logs for keys/locks.
         * @summary /api/v2/LockLogs
         * @param {GetLockLogsParam} getLockLogsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockLogsGetLockLogs(getLockLogsParam: GetLockLogsParam, options?: any): AxiosPromise<GetLockLogsResult> {
            return LockLogsApiFp(configuration).lockLogsGetLockLogs(getLockLogsParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LockLogsApi - object-oriented interface
 * @export
 * @class LockLogsApi
 * @extends {BaseAPI}
 */
export class LockLogsApi extends BaseAPI {
    /**
     * Returns lock logs by going dates
     * @summary /api/v2/LockLogs/GetLockLogDataByGoingDates
     * @param {GetLockLogDataParam} getLockLogDataParam Parameter containing start and end dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LockLogsApi
     */
    public lockLogsGetLockLogDataByGoingDates(getLockLogDataParam: GetLockLogDataParam, options?: any) {
        return LockLogsApiFp(this.configuration).lockLogsGetLockLogDataByGoingDates(getLockLogDataParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns lock logs by the time they were added to the database
     * @summary /api/v2/LockLogs/GetLockLogDataByTimestamp
     * @param {GetLockLogDataParam} getLockLogDataParam Parameter containing start and end dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LockLogsApi
     */
    public lockLogsGetLockLogDataByTimestamp(getLockLogDataParam: GetLockLogDataParam, options?: any) {
        return LockLogsApiFp(this.configuration).lockLogsGetLockLogDataByTimestamp(getLockLogDataParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns logs for keys/locks.
     * @summary /api/v2/LockLogs
     * @param {GetLockLogsParam} getLockLogsParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LockLogsApi
     */
    public lockLogsGetLockLogs(getLockLogsParam: GetLockLogsParam, options?: any) {
        return LockLogsApiFp(this.configuration).lockLogsGetLockLogs(getLockLogsParam, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * LocksApi - axios parameter creator
 * @export
 */
export const LocksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Checks if given lock can be ordered. Only Locks compatible with S50 Keys can be ordered using this public API.
         * @summary /api/v2/Locks/{id}/CanOrder
         * @param {string} id Lock Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksCanOrderLock: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling locksCanOrderLock.');
            }
            const localVarPath = `/api/v2/Locks/{id}/CanOrder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes given lock or removes it from use if it\'s programmed to keep history and logs.
         * @summary /api/v2/Locks/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksDelete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling locksDelete.');
            }
            const localVarPath = `/api/v2/Locks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns lock list
         * @summary /api/v2/Locks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksGetAllLocks: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Locks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns single lock
         * @summary /api/v2/Locks/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksGetLockById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling locksGetLockById.');
            }
            const localVarPath = `/api/v2/Locks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets locks option mask values
         * @summary /api/v2/Locks/{id}/Options
         * @param {string} id Lock Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksGetLockOptions: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling locksGetLockOptions.');
            }
            const localVarPath = `/api/v2/Locks/{id}/Options`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets lock\'s security accesses
         * @summary /api/v2/Locks/{id}/SecurityAccesses
         * @param {string} id Lock id
         * @param {GetSecurityAccessesView} mode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksGetSecurityAccesses: async (id: string, mode: GetSecurityAccessesView, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling locksGetSecurityAccesses.');
            }
            // verify required parameter 'mode' is not null or undefined
            if (mode === null || mode === undefined) {
                throw new RequiredError('mode','Required parameter mode was null or undefined when calling locksGetSecurityAccesses.');
            }
            const localVarPath = `/api/v2/Locks/{id}/SecurityAccesses`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns Lock\'s time limits
         * @summary /api/v2/Locks/{id}/TimeLimitTitles
         * @param {string} id Lock Id
         * @param {GetTimeLimitsView} mode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksGetTimeLimits: async (id: string, mode: GetTimeLimitsView, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling locksGetTimeLimits.');
            }
            // verify required parameter 'mode' is not null or undefined
            if (mode === null || mode === undefined) {
                throw new RequiredError('mode','Required parameter mode was null or undefined when calling locksGetTimeLimits.');
            }
            const localVarPath = `/api/v2/Locks/{id}/TimeLimitTitles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds new lock If lock hasn\'t been initialized yet, it can\'t have soft security accesses
         * @summary /api/v2/Locks
         * @param {InsertLockParam} insertLockParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksInsert: async (insertLockParam: InsertLockParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'insertLockParam' is not null or undefined
            if (insertLockParam === null || insertLockParam === undefined) {
                throw new RequiredError('insertLockParam','Required parameter insertLockParam was null or undefined when calling locksInsert.');
            }
            const localVarPath = `/api/v2/Locks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof insertLockParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(insertLockParam !== undefined ? insertLockParam : {}) : (insertLockParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Orders Lock. Only Locks compatible with S50 Keys can be ordered using this public API.
         * @summary /api/v2/Locks/{id}/Order
         * @param {string} id Lock Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksOrderLock: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling locksOrderLock.');
            }
            const localVarPath = `/api/v2/Locks/{id}/Order`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates existing lock
         * @summary /api/v2/Locks
         * @param {UpdateLockParam} updateLockParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksUpdate: async (updateLockParam: UpdateLockParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateLockParam' is not null or undefined
            if (updateLockParam === null || updateLockParam === undefined) {
                throw new RequiredError('updateLockParam','Required parameter updateLockParam was null or undefined when calling locksUpdate.');
            }
            const localVarPath = `/api/v2/Locks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateLockParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateLockParam !== undefined ? updateLockParam : {}) : (updateLockParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates locks\' access rights.
         * @summary /api/v2/Locks/{id}/SecurityAccesses
         * @param {string} id Lock id
         * @param {UpdateLockSecurityAccessesParam} updateLockSecurityAccessesParam Parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksUpdateSecurityAccesses: async (id: string, updateLockSecurityAccessesParam: UpdateLockSecurityAccessesParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling locksUpdateSecurityAccesses.');
            }
            // verify required parameter 'updateLockSecurityAccessesParam' is not null or undefined
            if (updateLockSecurityAccessesParam === null || updateLockSecurityAccessesParam === undefined) {
                throw new RequiredError('updateLockSecurityAccessesParam','Required parameter updateLockSecurityAccessesParam was null or undefined when calling locksUpdateSecurityAccesses.');
            }
            const localVarPath = `/api/v2/Locks/{id}/SecurityAccesses`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateLockSecurityAccessesParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateLockSecurityAccessesParam !== undefined ? updateLockSecurityAccessesParam : {}) : (updateLockSecurityAccessesParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocksApi - functional programming interface
 * @export
 */
export const LocksApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Checks if given lock can be ordered. Only Locks compatible with S50 Keys can be ordered using this public API.
         * @summary /api/v2/Locks/{id}/CanOrder
         * @param {string} id Lock Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locksCanOrderLock(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CanOrderLockResultType>> {
            const localVarAxiosArgs = await LocksApiAxiosParamCreator(configuration).locksCanOrderLock(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deletes given lock or removes it from use if it\'s programmed to keep history and logs.
         * @summary /api/v2/Locks/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locksDelete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await LocksApiAxiosParamCreator(configuration).locksDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns lock list
         * @summary /api/v2/Locks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locksGetAllLocks(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Lock>>> {
            const localVarAxiosArgs = await LocksApiAxiosParamCreator(configuration).locksGetAllLocks(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns single lock
         * @summary /api/v2/Locks/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locksGetLockById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Lock>> {
            const localVarAxiosArgs = await LocksApiAxiosParamCreator(configuration).locksGetLockById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets locks option mask values
         * @summary /api/v2/Locks/{id}/Options
         * @param {string} id Lock Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locksGetLockOptions(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LLockOptionMaskParam>> {
            const localVarAxiosArgs = await LocksApiAxiosParamCreator(configuration).locksGetLockOptions(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets lock\'s security accesses
         * @summary /api/v2/Locks/{id}/SecurityAccesses
         * @param {string} id Lock id
         * @param {GetSecurityAccessesView} mode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locksGetSecurityAccesses(id: string, mode: GetSecurityAccessesView, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLockSecurityAccessesResult>> {
            const localVarAxiosArgs = await LocksApiAxiosParamCreator(configuration).locksGetSecurityAccesses(id, mode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns Lock\'s time limits
         * @summary /api/v2/Locks/{id}/TimeLimitTitles
         * @param {string} id Lock Id
         * @param {GetTimeLimitsView} mode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locksGetTimeLimits(id: string, mode: GetTimeLimitsView, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLockTimeLimitsResult>> {
            const localVarAxiosArgs = await LocksApiAxiosParamCreator(configuration).locksGetTimeLimits(id, mode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Adds new lock If lock hasn\'t been initialized yet, it can\'t have soft security accesses
         * @summary /api/v2/Locks
         * @param {InsertLockParam} insertLockParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locksInsert(insertLockParam: InsertLockParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await LocksApiAxiosParamCreator(configuration).locksInsert(insertLockParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Orders Lock. Only Locks compatible with S50 Keys can be ordered using this public API.
         * @summary /api/v2/Locks/{id}/Order
         * @param {string} id Lock Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locksOrderLock(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await LocksApiAxiosParamCreator(configuration).locksOrderLock(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates existing lock
         * @summary /api/v2/Locks
         * @param {UpdateLockParam} updateLockParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locksUpdate(updateLockParam: UpdateLockParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await LocksApiAxiosParamCreator(configuration).locksUpdate(updateLockParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates locks\' access rights.
         * @summary /api/v2/Locks/{id}/SecurityAccesses
         * @param {string} id Lock id
         * @param {UpdateLockSecurityAccessesParam} updateLockSecurityAccessesParam Parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locksUpdateSecurityAccesses(id: string, updateLockSecurityAccessesParam: UpdateLockSecurityAccessesParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await LocksApiAxiosParamCreator(configuration).locksUpdateSecurityAccesses(id, updateLockSecurityAccessesParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LocksApi - factory interface
 * @export
 */
export const LocksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Checks if given lock can be ordered. Only Locks compatible with S50 Keys can be ordered using this public API.
         * @summary /api/v2/Locks/{id}/CanOrder
         * @param {string} id Lock Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksCanOrderLock(id: string, options?: any): AxiosPromise<CanOrderLockResultType> {
            return LocksApiFp(configuration).locksCanOrderLock(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes given lock or removes it from use if it\'s programmed to keep history and logs.
         * @summary /api/v2/Locks/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksDelete(id: string, options?: any): AxiosPromise<any> {
            return LocksApiFp(configuration).locksDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns lock list
         * @summary /api/v2/Locks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksGetAllLocks(options?: any): AxiosPromise<Array<Lock>> {
            return LocksApiFp(configuration).locksGetAllLocks(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns single lock
         * @summary /api/v2/Locks/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksGetLockById(id: string, options?: any): AxiosPromise<Lock> {
            return LocksApiFp(configuration).locksGetLockById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets locks option mask values
         * @summary /api/v2/Locks/{id}/Options
         * @param {string} id Lock Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksGetLockOptions(id: string, options?: any): AxiosPromise<LLockOptionMaskParam> {
            return LocksApiFp(configuration).locksGetLockOptions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets lock\'s security accesses
         * @summary /api/v2/Locks/{id}/SecurityAccesses
         * @param {string} id Lock id
         * @param {GetSecurityAccessesView} mode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksGetSecurityAccesses(id: string, mode: GetSecurityAccessesView, options?: any): AxiosPromise<GetLockSecurityAccessesResult> {
            return LocksApiFp(configuration).locksGetSecurityAccesses(id, mode, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns Lock\'s time limits
         * @summary /api/v2/Locks/{id}/TimeLimitTitles
         * @param {string} id Lock Id
         * @param {GetTimeLimitsView} mode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksGetTimeLimits(id: string, mode: GetTimeLimitsView, options?: any): AxiosPromise<GetLockTimeLimitsResult> {
            return LocksApiFp(configuration).locksGetTimeLimits(id, mode, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds new lock If lock hasn\'t been initialized yet, it can\'t have soft security accesses
         * @summary /api/v2/Locks
         * @param {InsertLockParam} insertLockParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksInsert(insertLockParam: InsertLockParam, options?: any): AxiosPromise<any> {
            return LocksApiFp(configuration).locksInsert(insertLockParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Orders Lock. Only Locks compatible with S50 Keys can be ordered using this public API.
         * @summary /api/v2/Locks/{id}/Order
         * @param {string} id Lock Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksOrderLock(id: string, options?: any): AxiosPromise<any> {
            return LocksApiFp(configuration).locksOrderLock(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates existing lock
         * @summary /api/v2/Locks
         * @param {UpdateLockParam} updateLockParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksUpdate(updateLockParam: UpdateLockParam, options?: any): AxiosPromise<any> {
            return LocksApiFp(configuration).locksUpdate(updateLockParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates locks\' access rights.
         * @summary /api/v2/Locks/{id}/SecurityAccesses
         * @param {string} id Lock id
         * @param {UpdateLockSecurityAccessesParam} updateLockSecurityAccessesParam Parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locksUpdateSecurityAccesses(id: string, updateLockSecurityAccessesParam: UpdateLockSecurityAccessesParam, options?: any): AxiosPromise<any> {
            return LocksApiFp(configuration).locksUpdateSecurityAccesses(id, updateLockSecurityAccessesParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocksApi - object-oriented interface
 * @export
 * @class LocksApi
 * @extends {BaseAPI}
 */
export class LocksApi extends BaseAPI {
    /**
     * Checks if given lock can be ordered. Only Locks compatible with S50 Keys can be ordered using this public API.
     * @summary /api/v2/Locks/{id}/CanOrder
     * @param {string} id Lock Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocksApi
     */
    public locksCanOrderLock(id: string, options?: any) {
        return LocksApiFp(this.configuration).locksCanOrderLock(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes given lock or removes it from use if it\'s programmed to keep history and logs.
     * @summary /api/v2/Locks/{id}
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocksApi
     */
    public locksDelete(id: string, options?: any) {
        return LocksApiFp(this.configuration).locksDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns lock list
     * @summary /api/v2/Locks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocksApi
     */
    public locksGetAllLocks(options?: any) {
        return LocksApiFp(this.configuration).locksGetAllLocks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns single lock
     * @summary /api/v2/Locks/{id}
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocksApi
     */
    public locksGetLockById(id: string, options?: any) {
        return LocksApiFp(this.configuration).locksGetLockById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets locks option mask values
     * @summary /api/v2/Locks/{id}/Options
     * @param {string} id Lock Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocksApi
     */
    public locksGetLockOptions(id: string, options?: any) {
        return LocksApiFp(this.configuration).locksGetLockOptions(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets lock\'s security accesses
     * @summary /api/v2/Locks/{id}/SecurityAccesses
     * @param {string} id Lock id
     * @param {GetSecurityAccessesView} mode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocksApi
     */
    public locksGetSecurityAccesses(id: string, mode: GetSecurityAccessesView, options?: any) {
        return LocksApiFp(this.configuration).locksGetSecurityAccesses(id, mode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns Lock\'s time limits
     * @summary /api/v2/Locks/{id}/TimeLimitTitles
     * @param {string} id Lock Id
     * @param {GetTimeLimitsView} mode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocksApi
     */
    public locksGetTimeLimits(id: string, mode: GetTimeLimitsView, options?: any) {
        return LocksApiFp(this.configuration).locksGetTimeLimits(id, mode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds new lock If lock hasn\'t been initialized yet, it can\'t have soft security accesses
     * @summary /api/v2/Locks
     * @param {InsertLockParam} insertLockParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocksApi
     */
    public locksInsert(insertLockParam: InsertLockParam, options?: any) {
        return LocksApiFp(this.configuration).locksInsert(insertLockParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Orders Lock. Only Locks compatible with S50 Keys can be ordered using this public API.
     * @summary /api/v2/Locks/{id}/Order
     * @param {string} id Lock Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocksApi
     */
    public locksOrderLock(id: string, options?: any) {
        return LocksApiFp(this.configuration).locksOrderLock(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates existing lock
     * @summary /api/v2/Locks
     * @param {UpdateLockParam} updateLockParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocksApi
     */
    public locksUpdate(updateLockParam: UpdateLockParam, options?: any) {
        return LocksApiFp(this.configuration).locksUpdate(updateLockParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates locks\' access rights.
     * @summary /api/v2/Locks/{id}/SecurityAccesses
     * @param {string} id Lock id
     * @param {UpdateLockSecurityAccessesParam} updateLockSecurityAccessesParam Parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocksApi
     */
    public locksUpdateSecurityAccesses(id: string, updateLockSecurityAccessesParam: UpdateLockSecurityAccessesParam, options?: any) {
        return LocksApiFp(this.configuration).locksUpdateSecurityAccesses(id, updateLockSecurityAccessesParam, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * NetworkModuleDeviceRelaysApi - axios parameter creator
 * @export
 */
export const NetworkModuleDeviceRelaysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns information about specific network module device relay
         * @summary /api/v2/NetworkModuleDeviceRelays/{id}
         * @param {string} id network module device relay id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModuleDeviceRelaysGetById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling networkModuleDeviceRelaysGetById.');
            }
            const localVarPath = `/api/v2/NetworkModuleDeviceRelays/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns relays which belong to given network module device
         * @summary /api/v2/NetworkModuleDevices/{id}/NetworkModuleDeviceRelays
         * @param {string} id Network module device id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModuleDeviceRelaysGetByNetworkModuleDeviceId: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling networkModuleDeviceRelaysGetByNetworkModuleDeviceId.');
            }
            const localVarPath = `/api/v2/NetworkModuleDevices/{id}/NetworkModuleDeviceRelays`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns relays which belong to given network module
         * @summary /api/v2/NetworkModules/{id}/NetworkModuleDeviceRelays
         * @param {string} id Network module id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModuleDeviceRelaysGetByNetworkModuleId: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling networkModuleDeviceRelaysGetByNetworkModuleId.');
            }
            const localVarPath = `/api/v2/NetworkModules/{id}/NetworkModuleDeviceRelays`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NetworkModuleDeviceRelaysApi - functional programming interface
 * @export
 */
export const NetworkModuleDeviceRelaysApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns information about specific network module device relay
         * @summary /api/v2/NetworkModuleDeviceRelays/{id}
         * @param {string} id network module device relay id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async networkModuleDeviceRelaysGetById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NetworkModuleDeviceRelay>> {
            const localVarAxiosArgs = await NetworkModuleDeviceRelaysApiAxiosParamCreator(configuration).networkModuleDeviceRelaysGetById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns relays which belong to given network module device
         * @summary /api/v2/NetworkModuleDevices/{id}/NetworkModuleDeviceRelays
         * @param {string} id Network module device id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async networkModuleDeviceRelaysGetByNetworkModuleDeviceId(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NetworkModuleDeviceRelay>>> {
            const localVarAxiosArgs = await NetworkModuleDeviceRelaysApiAxiosParamCreator(configuration).networkModuleDeviceRelaysGetByNetworkModuleDeviceId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns relays which belong to given network module
         * @summary /api/v2/NetworkModules/{id}/NetworkModuleDeviceRelays
         * @param {string} id Network module id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async networkModuleDeviceRelaysGetByNetworkModuleId(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NetworkModuleDeviceRelay>>> {
            const localVarAxiosArgs = await NetworkModuleDeviceRelaysApiAxiosParamCreator(configuration).networkModuleDeviceRelaysGetByNetworkModuleId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NetworkModuleDeviceRelaysApi - factory interface
 * @export
 */
export const NetworkModuleDeviceRelaysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns information about specific network module device relay
         * @summary /api/v2/NetworkModuleDeviceRelays/{id}
         * @param {string} id network module device relay id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModuleDeviceRelaysGetById(id: string, options?: any): AxiosPromise<NetworkModuleDeviceRelay> {
            return NetworkModuleDeviceRelaysApiFp(configuration).networkModuleDeviceRelaysGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns relays which belong to given network module device
         * @summary /api/v2/NetworkModuleDevices/{id}/NetworkModuleDeviceRelays
         * @param {string} id Network module device id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModuleDeviceRelaysGetByNetworkModuleDeviceId(id: string, options?: any): AxiosPromise<Array<NetworkModuleDeviceRelay>> {
            return NetworkModuleDeviceRelaysApiFp(configuration).networkModuleDeviceRelaysGetByNetworkModuleDeviceId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns relays which belong to given network module
         * @summary /api/v2/NetworkModules/{id}/NetworkModuleDeviceRelays
         * @param {string} id Network module id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModuleDeviceRelaysGetByNetworkModuleId(id: string, options?: any): AxiosPromise<Array<NetworkModuleDeviceRelay>> {
            return NetworkModuleDeviceRelaysApiFp(configuration).networkModuleDeviceRelaysGetByNetworkModuleId(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NetworkModuleDeviceRelaysApi - object-oriented interface
 * @export
 * @class NetworkModuleDeviceRelaysApi
 * @extends {BaseAPI}
 */
export class NetworkModuleDeviceRelaysApi extends BaseAPI {
    /**
     * Returns information about specific network module device relay
     * @summary /api/v2/NetworkModuleDeviceRelays/{id}
     * @param {string} id network module device relay id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkModuleDeviceRelaysApi
     */
    public networkModuleDeviceRelaysGetById(id: string, options?: any) {
        return NetworkModuleDeviceRelaysApiFp(this.configuration).networkModuleDeviceRelaysGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns relays which belong to given network module device
     * @summary /api/v2/NetworkModuleDevices/{id}/NetworkModuleDeviceRelays
     * @param {string} id Network module device id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkModuleDeviceRelaysApi
     */
    public networkModuleDeviceRelaysGetByNetworkModuleDeviceId(id: string, options?: any) {
        return NetworkModuleDeviceRelaysApiFp(this.configuration).networkModuleDeviceRelaysGetByNetworkModuleDeviceId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns relays which belong to given network module
     * @summary /api/v2/NetworkModules/{id}/NetworkModuleDeviceRelays
     * @param {string} id Network module id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkModuleDeviceRelaysApi
     */
    public networkModuleDeviceRelaysGetByNetworkModuleId(id: string, options?: any) {
        return NetworkModuleDeviceRelaysApiFp(this.configuration).networkModuleDeviceRelaysGetByNetworkModuleId(id, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * NetworkModuleDevicesApi - axios parameter creator
 * @export
 */
export const NetworkModuleDevicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all network module devices
         * @summary /api/v2/NetworkModuleDevices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModuleDevicesGetAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/NetworkModuleDevices`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns network module device by ID
         * @summary /api/v2/NetworkModuleDevices/{id}
         * @param {string} id Network module device ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModuleDevicesGetById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling networkModuleDevicesGetById.');
            }
            const localVarPath = `/api/v2/NetworkModuleDevices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns network module devices which belong to given Network Module
         * @summary /api/v2/NetworkModules/{id}/NetworkModuleDevices
         * @param {string} id Network module ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModuleDevicesGetByNetworkModuleId: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling networkModuleDevicesGetByNetworkModuleId.');
            }
            const localVarPath = `/api/v2/NetworkModules/{id}/NetworkModuleDevices`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NetworkModuleDevicesApi - functional programming interface
 * @export
 */
export const NetworkModuleDevicesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns all network module devices
         * @summary /api/v2/NetworkModuleDevices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async networkModuleDevicesGetAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NetworkModuleDevice>>> {
            const localVarAxiosArgs = await NetworkModuleDevicesApiAxiosParamCreator(configuration).networkModuleDevicesGetAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns network module device by ID
         * @summary /api/v2/NetworkModuleDevices/{id}
         * @param {string} id Network module device ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async networkModuleDevicesGetById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NetworkModuleDevice>> {
            const localVarAxiosArgs = await NetworkModuleDevicesApiAxiosParamCreator(configuration).networkModuleDevicesGetById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns network module devices which belong to given Network Module
         * @summary /api/v2/NetworkModules/{id}/NetworkModuleDevices
         * @param {string} id Network module ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async networkModuleDevicesGetByNetworkModuleId(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NetworkModuleDevice>>> {
            const localVarAxiosArgs = await NetworkModuleDevicesApiAxiosParamCreator(configuration).networkModuleDevicesGetByNetworkModuleId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NetworkModuleDevicesApi - factory interface
 * @export
 */
export const NetworkModuleDevicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns all network module devices
         * @summary /api/v2/NetworkModuleDevices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModuleDevicesGetAll(options?: any): AxiosPromise<Array<NetworkModuleDevice>> {
            return NetworkModuleDevicesApiFp(configuration).networkModuleDevicesGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns network module device by ID
         * @summary /api/v2/NetworkModuleDevices/{id}
         * @param {string} id Network module device ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModuleDevicesGetById(id: string, options?: any): AxiosPromise<NetworkModuleDevice> {
            return NetworkModuleDevicesApiFp(configuration).networkModuleDevicesGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns network module devices which belong to given Network Module
         * @summary /api/v2/NetworkModules/{id}/NetworkModuleDevices
         * @param {string} id Network module ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModuleDevicesGetByNetworkModuleId(id: string, options?: any): AxiosPromise<Array<NetworkModuleDevice>> {
            return NetworkModuleDevicesApiFp(configuration).networkModuleDevicesGetByNetworkModuleId(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NetworkModuleDevicesApi - object-oriented interface
 * @export
 * @class NetworkModuleDevicesApi
 * @extends {BaseAPI}
 */
export class NetworkModuleDevicesApi extends BaseAPI {
    /**
     * Returns all network module devices
     * @summary /api/v2/NetworkModuleDevices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkModuleDevicesApi
     */
    public networkModuleDevicesGetAll(options?: any) {
        return NetworkModuleDevicesApiFp(this.configuration).networkModuleDevicesGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns network module device by ID
     * @summary /api/v2/NetworkModuleDevices/{id}
     * @param {string} id Network module device ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkModuleDevicesApi
     */
    public networkModuleDevicesGetById(id: string, options?: any) {
        return NetworkModuleDevicesApiFp(this.configuration).networkModuleDevicesGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns network module devices which belong to given Network Module
     * @summary /api/v2/NetworkModules/{id}/NetworkModuleDevices
     * @param {string} id Network module ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkModuleDevicesApi
     */
    public networkModuleDevicesGetByNetworkModuleId(id: string, options?: any) {
        return NetworkModuleDevicesApiFp(this.configuration).networkModuleDevicesGetByNetworkModuleId(id, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * NetworkModulesApi - axios parameter creator
 * @export
 */
export const NetworkModulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns list of network modules
         * @summary /api/v2/NetworkModules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModulesGetAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/NetworkModules`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns information for given network module
         * @summary /api/v2/NetworkModules/{id}
         * @param {string} id Network module id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModulesGetById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling networkModulesGetById.');
            }
            const localVarPath = `/api/v2/NetworkModules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NetworkModulesApi - functional programming interface
 * @export
 */
export const NetworkModulesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns list of network modules
         * @summary /api/v2/NetworkModules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async networkModulesGetAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NetworkModule>>> {
            const localVarAxiosArgs = await NetworkModulesApiAxiosParamCreator(configuration).networkModulesGetAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns information for given network module
         * @summary /api/v2/NetworkModules/{id}
         * @param {string} id Network module id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async networkModulesGetById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NetworkModule>> {
            const localVarAxiosArgs = await NetworkModulesApiAxiosParamCreator(configuration).networkModulesGetById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NetworkModulesApi - factory interface
 * @export
 */
export const NetworkModulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns list of network modules
         * @summary /api/v2/NetworkModules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModulesGetAll(options?: any): AxiosPromise<Array<NetworkModule>> {
            return NetworkModulesApiFp(configuration).networkModulesGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns information for given network module
         * @summary /api/v2/NetworkModules/{id}
         * @param {string} id Network module id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        networkModulesGetById(id: string, options?: any): AxiosPromise<NetworkModule> {
            return NetworkModulesApiFp(configuration).networkModulesGetById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NetworkModulesApi - object-oriented interface
 * @export
 * @class NetworkModulesApi
 * @extends {BaseAPI}
 */
export class NetworkModulesApi extends BaseAPI {
    /**
     * Returns list of network modules
     * @summary /api/v2/NetworkModules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkModulesApi
     */
    public networkModulesGetAll(options?: any) {
        return NetworkModulesApiFp(this.configuration).networkModulesGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns information for given network module
     * @summary /api/v2/NetworkModules/{id}
     * @param {string} id Network module id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkModulesApi
     */
    public networkModulesGetById(id: string, options?: any) {
        return NetworkModulesApiFp(this.configuration).networkModulesGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * PersonRolesApi - axios parameter creator
 * @export
 */
export const PersonRolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets all person roles in locking system user has rights to
         * @summary /api/v2/PersonRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personRolesGetAllPersonRoles: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/PersonRoles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets all person roles linked to given Person ID
         * @summary /api/v2/Persons/{id}/PersonRoles
         * @param {string} id Person ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personRolesGetPersonRolesByPersonResult: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling personRolesGetPersonRolesByPersonResult.');
            }
            const localVarPath = `/api/v2/Persons/{id}/PersonRoles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets single role by its ID
         * @summary /api/v2/PersonRoles/{id}
         * @param {string} id Person role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personRolesGetRoleById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling personRolesGetRoleById.');
            }
            const localVarPath = `/api/v2/PersonRoles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersonRolesApi - functional programming interface
 * @export
 */
export const PersonRolesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Gets all person roles in locking system user has rights to
         * @summary /api/v2/PersonRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personRolesGetAllPersonRoles(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PersonRole>>> {
            const localVarAxiosArgs = await PersonRolesApiAxiosParamCreator(configuration).personRolesGetAllPersonRoles(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets all person roles linked to given Person ID
         * @summary /api/v2/Persons/{id}/PersonRoles
         * @param {string} id Person ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personRolesGetPersonRolesByPersonResult(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PersonRole>>> {
            const localVarAxiosArgs = await PersonRolesApiAxiosParamCreator(configuration).personRolesGetPersonRolesByPersonResult(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets single role by its ID
         * @summary /api/v2/PersonRoles/{id}
         * @param {string} id Person role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personRolesGetRoleById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonRole>> {
            const localVarAxiosArgs = await PersonRolesApiAxiosParamCreator(configuration).personRolesGetRoleById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PersonRolesApi - factory interface
 * @export
 */
export const PersonRolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Gets all person roles in locking system user has rights to
         * @summary /api/v2/PersonRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personRolesGetAllPersonRoles(options?: any): AxiosPromise<Array<PersonRole>> {
            return PersonRolesApiFp(configuration).personRolesGetAllPersonRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all person roles linked to given Person ID
         * @summary /api/v2/Persons/{id}/PersonRoles
         * @param {string} id Person ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personRolesGetPersonRolesByPersonResult(id: string, options?: any): AxiosPromise<Array<PersonRole>> {
            return PersonRolesApiFp(configuration).personRolesGetPersonRolesByPersonResult(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets single role by its ID
         * @summary /api/v2/PersonRoles/{id}
         * @param {string} id Person role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personRolesGetRoleById(id: string, options?: any): AxiosPromise<PersonRole> {
            return PersonRolesApiFp(configuration).personRolesGetRoleById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PersonRolesApi - object-oriented interface
 * @export
 * @class PersonRolesApi
 * @extends {BaseAPI}
 */
export class PersonRolesApi extends BaseAPI {
    /**
     * Gets all person roles in locking system user has rights to
     * @summary /api/v2/PersonRoles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRolesApi
     */
    public personRolesGetAllPersonRoles(options?: any) {
        return PersonRolesApiFp(this.configuration).personRolesGetAllPersonRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets all person roles linked to given Person ID
     * @summary /api/v2/Persons/{id}/PersonRoles
     * @param {string} id Person ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRolesApi
     */
    public personRolesGetPersonRolesByPersonResult(id: string, options?: any) {
        return PersonRolesApiFp(this.configuration).personRolesGetPersonRolesByPersonResult(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets single role by its ID
     * @summary /api/v2/PersonRoles/{id}
     * @param {string} id Person role ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRolesApi
     */
    public personRolesGetRoleById(id: string, options?: any) {
        return PersonRolesApiFp(this.configuration).personRolesGetRoleById(id, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * PersonsApi - axios parameter creator
 * @export
 */
export const PersonsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Checks if person can be deleted.
         * @summary /api/v2/Persons/{id}/CanDelete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsCanDelete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling personsCanDelete.');
            }
            const localVarPath = `/api/v2/Persons/{id}/CanDelete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a person
         * @summary /api/v2/Persons/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsDelete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling personsDelete.');
            }
            const localVarPath = `/api/v2/Persons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets all persons user has rights to. Requires CanBrowsePersonList right.
         * @summary /api/v2/Persons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsGetAllPersons: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Persons`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a single person by its ID. Requires CanBrowsePersonList right
         * @summary /api/v2/Persons/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsGetPerson: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling personsGetPerson.');
            }
            const localVarPath = `/api/v2/Persons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets persons by their external person ids
         * @summary /api/v2/Persons/GetByExternalPersonIds
         * @param {Array<string>} [externalPersonIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsGetPersonsByExternalPersonIds: async (externalPersonIds?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Persons/GetByExternalPersonIds`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (externalPersonIds) {
                localVarQueryParameter['externalPersonIds'] = externalPersonIds;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inserts new persons
         * @summary /api/v2/Persons
         * @param {InsertPersonParam} insertPersonParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsInsert: async (insertPersonParam: InsertPersonParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'insertPersonParam' is not null or undefined
            if (insertPersonParam === null || insertPersonParam === undefined) {
                throw new RequiredError('insertPersonParam','Required parameter insertPersonParam was null or undefined when calling personsInsert.');
            }
            const localVarPath = `/api/v2/Persons`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof insertPersonParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(insertPersonParam !== undefined ? insertPersonParam : {}) : (insertPersonParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates existing persons
         * @summary /api/v2/Persons
         * @param {UpdatePersonParam} updatePersonParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsUpdate: async (updatePersonParam: UpdatePersonParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePersonParam' is not null or undefined
            if (updatePersonParam === null || updatePersonParam === undefined) {
                throw new RequiredError('updatePersonParam','Required parameter updatePersonParam was null or undefined when calling personsUpdate.');
            }
            const localVarPath = `/api/v2/Persons`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updatePersonParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updatePersonParam !== undefined ? updatePersonParam : {}) : (updatePersonParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersonsApi - functional programming interface
 * @export
 */
export const PersonsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Checks if person can be deleted.
         * @summary /api/v2/Persons/{id}/CanDelete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personsCanDelete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PniPersonCanDeleteErrorType>> {
            const localVarAxiosArgs = await PersonsApiAxiosParamCreator(configuration).personsCanDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deletes a person
         * @summary /api/v2/Persons/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personsDelete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await PersonsApiAxiosParamCreator(configuration).personsDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets all persons user has rights to. Requires CanBrowsePersonList right.
         * @summary /api/v2/Persons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personsGetAllPersons(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await PersonsApiAxiosParamCreator(configuration).personsGetAllPersons(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets a single person by its ID. Requires CanBrowsePersonList right
         * @summary /api/v2/Persons/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personsGetPerson(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await PersonsApiAxiosParamCreator(configuration).personsGetPerson(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets persons by their external person ids
         * @summary /api/v2/Persons/GetByExternalPersonIds
         * @param {Array<string>} [externalPersonIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personsGetPersonsByExternalPersonIds(externalPersonIds?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await PersonsApiAxiosParamCreator(configuration).personsGetPersonsByExternalPersonIds(externalPersonIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Inserts new persons
         * @summary /api/v2/Persons
         * @param {InsertPersonParam} insertPersonParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personsInsert(insertPersonParam: InsertPersonParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsertResult>> {
            const localVarAxiosArgs = await PersonsApiAxiosParamCreator(configuration).personsInsert(insertPersonParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates existing persons
         * @summary /api/v2/Persons
         * @param {UpdatePersonParam} updatePersonParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personsUpdate(updatePersonParam: UpdatePersonParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await PersonsApiAxiosParamCreator(configuration).personsUpdate(updatePersonParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PersonsApi - factory interface
 * @export
 */
export const PersonsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Checks if person can be deleted.
         * @summary /api/v2/Persons/{id}/CanDelete
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsCanDelete(id: string, options?: any): AxiosPromise<PniPersonCanDeleteErrorType> {
            return PersonsApiFp(configuration).personsCanDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a person
         * @summary /api/v2/Persons/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsDelete(id: string, options?: any): AxiosPromise<any> {
            return PersonsApiFp(configuration).personsDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all persons user has rights to. Requires CanBrowsePersonList right.
         * @summary /api/v2/Persons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsGetAllPersons(options?: any): AxiosPromise<Array<Person>> {
            return PersonsApiFp(configuration).personsGetAllPersons(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a single person by its ID. Requires CanBrowsePersonList right
         * @summary /api/v2/Persons/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsGetPerson(id: string, options?: any): AxiosPromise<Person> {
            return PersonsApiFp(configuration).personsGetPerson(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets persons by their external person ids
         * @summary /api/v2/Persons/GetByExternalPersonIds
         * @param {Array<string>} [externalPersonIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsGetPersonsByExternalPersonIds(externalPersonIds?: Array<string>, options?: any): AxiosPromise<Array<Person>> {
            return PersonsApiFp(configuration).personsGetPersonsByExternalPersonIds(externalPersonIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Inserts new persons
         * @summary /api/v2/Persons
         * @param {InsertPersonParam} insertPersonParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsInsert(insertPersonParam: InsertPersonParam, options?: any): AxiosPromise<InsertResult> {
            return PersonsApiFp(configuration).personsInsert(insertPersonParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates existing persons
         * @summary /api/v2/Persons
         * @param {UpdatePersonParam} updatePersonParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsUpdate(updatePersonParam: UpdatePersonParam, options?: any): AxiosPromise<any> {
            return PersonsApiFp(configuration).personsUpdate(updatePersonParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PersonsApi - object-oriented interface
 * @export
 * @class PersonsApi
 * @extends {BaseAPI}
 */
export class PersonsApi extends BaseAPI {
    /**
     * Checks if person can be deleted.
     * @summary /api/v2/Persons/{id}/CanDelete
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApi
     */
    public personsCanDelete(id: string, options?: any) {
        return PersonsApiFp(this.configuration).personsCanDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a person
     * @summary /api/v2/Persons/{id}
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApi
     */
    public personsDelete(id: string, options?: any) {
        return PersonsApiFp(this.configuration).personsDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets all persons user has rights to. Requires CanBrowsePersonList right.
     * @summary /api/v2/Persons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApi
     */
    public personsGetAllPersons(options?: any) {
        return PersonsApiFp(this.configuration).personsGetAllPersons(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a single person by its ID. Requires CanBrowsePersonList right
     * @summary /api/v2/Persons/{id}
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApi
     */
    public personsGetPerson(id: string, options?: any) {
        return PersonsApiFp(this.configuration).personsGetPerson(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets persons by their external person ids
     * @summary /api/v2/Persons/GetByExternalPersonIds
     * @param {Array<string>} [externalPersonIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApi
     */
    public personsGetPersonsByExternalPersonIds(externalPersonIds?: Array<string>, options?: any) {
        return PersonsApiFp(this.configuration).personsGetPersonsByExternalPersonIds(externalPersonIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inserts new persons
     * @summary /api/v2/Persons
     * @param {InsertPersonParam} insertPersonParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApi
     */
    public personsInsert(insertPersonParam: InsertPersonParam, options?: any) {
        return PersonsApiFp(this.configuration).personsInsert(insertPersonParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates existing persons
     * @summary /api/v2/Persons
     * @param {UpdatePersonParam} updatePersonParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApi
     */
    public personsUpdate(updatePersonParam: UpdatePersonParam, options?: any) {
        return PersonsApiFp(this.configuration).personsUpdate(updatePersonParam, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * RealEstatesApi - axios parameter creator
 * @export
 */
export const RealEstatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns list of locking system\'s real estates
         * @summary /api/v2/RealEstates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        realEstatesGetValues: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/RealEstates`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RealEstatesApi - functional programming interface
 * @export
 */
export const RealEstatesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns list of locking system\'s real estates
         * @summary /api/v2/RealEstates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async realEstatesGetValues(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RealEstate>>> {
            const localVarAxiosArgs = await RealEstatesApiAxiosParamCreator(configuration).realEstatesGetValues(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RealEstatesApi - factory interface
 * @export
 */
export const RealEstatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns list of locking system\'s real estates
         * @summary /api/v2/RealEstates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        realEstatesGetValues(options?: any): AxiosPromise<Array<RealEstate>> {
            return RealEstatesApiFp(configuration).realEstatesGetValues(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RealEstatesApi - object-oriented interface
 * @export
 * @class RealEstatesApi
 * @extends {BaseAPI}
 */
export class RealEstatesApi extends BaseAPI {
    /**
     * Returns list of locking system\'s real estates
     * @summary /api/v2/RealEstates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RealEstatesApi
     */
    public realEstatesGetValues(options?: any) {
        return RealEstatesApiFp(this.configuration).realEstatesGetValues(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SecurityAccessApi - axios parameter creator
 * @export
 */
export const SecurityAccessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes given security access
         * @summary /api/v2/SecurityAccesses/{id}
         * @param {string} id Security access ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityAccessDelete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling securityAccessDelete.');
            }
            const localVarPath = `/api/v2/SecurityAccesses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns list of locking system\'s security accesses
         * @summary /api/v2/SecurityAccesses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityAccessGetAllSecurityAccesses: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/SecurityAccesses`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds new security access
         * @summary /api/v2/SecurityAccesses
         * @param {InsertSecurityAccessParam} insertSecurityAccessParam Parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityAccessInsert: async (insertSecurityAccessParam: InsertSecurityAccessParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'insertSecurityAccessParam' is not null or undefined
            if (insertSecurityAccessParam === null || insertSecurityAccessParam === undefined) {
                throw new RequiredError('insertSecurityAccessParam','Required parameter insertSecurityAccessParam was null or undefined when calling securityAccessInsert.');
            }
            const localVarPath = `/api/v2/SecurityAccesses`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof insertSecurityAccessParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(insertSecurityAccessParam !== undefined ? insertSecurityAccessParam : {}) : (insertSecurityAccessParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates existing security access
         * @summary /api/v2/SecurityAccesses
         * @param {UpdateSecurityAccessParam} updateSecurityAccessParam Parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityAccessUpdate: async (updateSecurityAccessParam: UpdateSecurityAccessParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateSecurityAccessParam' is not null or undefined
            if (updateSecurityAccessParam === null || updateSecurityAccessParam === undefined) {
                throw new RequiredError('updateSecurityAccessParam','Required parameter updateSecurityAccessParam was null or undefined when calling securityAccessUpdate.');
            }
            const localVarPath = `/api/v2/SecurityAccesses`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateSecurityAccessParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateSecurityAccessParam !== undefined ? updateSecurityAccessParam : {}) : (updateSecurityAccessParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecurityAccessApi - functional programming interface
 * @export
 */
export const SecurityAccessApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Deletes given security access
         * @summary /api/v2/SecurityAccesses/{id}
         * @param {string} id Security access ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async securityAccessDelete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await SecurityAccessApiAxiosParamCreator(configuration).securityAccessDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns list of locking system\'s security accesses
         * @summary /api/v2/SecurityAccesses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async securityAccessGetAllSecurityAccesses(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SecurityAccess>>> {
            const localVarAxiosArgs = await SecurityAccessApiAxiosParamCreator(configuration).securityAccessGetAllSecurityAccesses(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Adds new security access
         * @summary /api/v2/SecurityAccesses
         * @param {InsertSecurityAccessParam} insertSecurityAccessParam Parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async securityAccessInsert(insertSecurityAccessParam: InsertSecurityAccessParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsertSecurityAccessResult>> {
            const localVarAxiosArgs = await SecurityAccessApiAxiosParamCreator(configuration).securityAccessInsert(insertSecurityAccessParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates existing security access
         * @summary /api/v2/SecurityAccesses
         * @param {UpdateSecurityAccessParam} updateSecurityAccessParam Parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async securityAccessUpdate(updateSecurityAccessParam: UpdateSecurityAccessParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await SecurityAccessApiAxiosParamCreator(configuration).securityAccessUpdate(updateSecurityAccessParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SecurityAccessApi - factory interface
 * @export
 */
export const SecurityAccessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Deletes given security access
         * @summary /api/v2/SecurityAccesses/{id}
         * @param {string} id Security access ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityAccessDelete(id: string, options?: any): AxiosPromise<any> {
            return SecurityAccessApiFp(configuration).securityAccessDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns list of locking system\'s security accesses
         * @summary /api/v2/SecurityAccesses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityAccessGetAllSecurityAccesses(options?: any): AxiosPromise<Array<SecurityAccess>> {
            return SecurityAccessApiFp(configuration).securityAccessGetAllSecurityAccesses(options).then((request) => request(axios, basePath));
        },
        /**
         * Adds new security access
         * @summary /api/v2/SecurityAccesses
         * @param {InsertSecurityAccessParam} insertSecurityAccessParam Parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityAccessInsert(insertSecurityAccessParam: InsertSecurityAccessParam, options?: any): AxiosPromise<InsertSecurityAccessResult> {
            return SecurityAccessApiFp(configuration).securityAccessInsert(insertSecurityAccessParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates existing security access
         * @summary /api/v2/SecurityAccesses
         * @param {UpdateSecurityAccessParam} updateSecurityAccessParam Parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityAccessUpdate(updateSecurityAccessParam: UpdateSecurityAccessParam, options?: any): AxiosPromise<any> {
            return SecurityAccessApiFp(configuration).securityAccessUpdate(updateSecurityAccessParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SecurityAccessApi - object-oriented interface
 * @export
 * @class SecurityAccessApi
 * @extends {BaseAPI}
 */
export class SecurityAccessApi extends BaseAPI {
    /**
     * Deletes given security access
     * @summary /api/v2/SecurityAccesses/{id}
     * @param {string} id Security access ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityAccessApi
     */
    public securityAccessDelete(id: string, options?: any) {
        return SecurityAccessApiFp(this.configuration).securityAccessDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns list of locking system\'s security accesses
     * @summary /api/v2/SecurityAccesses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityAccessApi
     */
    public securityAccessGetAllSecurityAccesses(options?: any) {
        return SecurityAccessApiFp(this.configuration).securityAccessGetAllSecurityAccesses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds new security access
     * @summary /api/v2/SecurityAccesses
     * @param {InsertSecurityAccessParam} insertSecurityAccessParam Parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityAccessApi
     */
    public securityAccessInsert(insertSecurityAccessParam: InsertSecurityAccessParam, options?: any) {
        return SecurityAccessApiFp(this.configuration).securityAccessInsert(insertSecurityAccessParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates existing security access
     * @summary /api/v2/SecurityAccesses
     * @param {UpdateSecurityAccessParam} updateSecurityAccessParam Parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityAccessApi
     */
    public securityAccessUpdate(updateSecurityAccessParam: UpdateSecurityAccessParam, options?: any) {
        return SecurityAccessApiFp(this.configuration).securityAccessUpdate(updateSecurityAccessParam, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SecurityRolesApi - axios parameter creator
 * @export
 */
export const SecurityRolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes security role
         * @summary /api/v2/SecurityRoles/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityRolesDelete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling securityRolesDelete.');
            }
            const localVarPath = `/api/v2/SecurityRoles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all Security Roles
         * @summary /api/v2/SecurityRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityRolesGetAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/SecurityRoles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns security role data by its ID
         * @summary /api/v2/SecurityRoles/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityRolesGetById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling securityRolesGetById.');
            }
            const localVarPath = `/api/v2/SecurityRoles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds new security role
         * @summary /api/v2/SecurityRoles
         * @param {SecurityRole} securityRole 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityRolesInsert: async (securityRole: SecurityRole, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'securityRole' is not null or undefined
            if (securityRole === null || securityRole === undefined) {
                throw new RequiredError('securityRole','Required parameter securityRole was null or undefined when calling securityRolesInsert.');
            }
            const localVarPath = `/api/v2/SecurityRoles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof securityRole !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(securityRole !== undefined ? securityRole : {}) : (securityRole || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates existing security role
         * @summary /api/v2/SecurityRoles
         * @param {SecurityRole} securityRole 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityRolesUpdate: async (securityRole: SecurityRole, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'securityRole' is not null or undefined
            if (securityRole === null || securityRole === undefined) {
                throw new RequiredError('securityRole','Required parameter securityRole was null or undefined when calling securityRolesUpdate.');
            }
            const localVarPath = `/api/v2/SecurityRoles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof securityRole !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(securityRole !== undefined ? securityRole : {}) : (securityRole || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecurityRolesApi - functional programming interface
 * @export
 */
export const SecurityRolesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Deletes security role
         * @summary /api/v2/SecurityRoles/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async securityRolesDelete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await SecurityRolesApiAxiosParamCreator(configuration).securityRolesDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns all Security Roles
         * @summary /api/v2/SecurityRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async securityRolesGetAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SecurityRole>>> {
            const localVarAxiosArgs = await SecurityRolesApiAxiosParamCreator(configuration).securityRolesGetAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns security role data by its ID
         * @summary /api/v2/SecurityRoles/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async securityRolesGetById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityRole>> {
            const localVarAxiosArgs = await SecurityRolesApiAxiosParamCreator(configuration).securityRolesGetById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Adds new security role
         * @summary /api/v2/SecurityRoles
         * @param {SecurityRole} securityRole 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async securityRolesInsert(securityRole: SecurityRole, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityRole>> {
            const localVarAxiosArgs = await SecurityRolesApiAxiosParamCreator(configuration).securityRolesInsert(securityRole, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates existing security role
         * @summary /api/v2/SecurityRoles
         * @param {SecurityRole} securityRole 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async securityRolesUpdate(securityRole: SecurityRole, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await SecurityRolesApiAxiosParamCreator(configuration).securityRolesUpdate(securityRole, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SecurityRolesApi - factory interface
 * @export
 */
export const SecurityRolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Deletes security role
         * @summary /api/v2/SecurityRoles/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityRolesDelete(id: string, options?: any): AxiosPromise<any> {
            return SecurityRolesApiFp(configuration).securityRolesDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all Security Roles
         * @summary /api/v2/SecurityRoles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityRolesGetAll(options?: any): AxiosPromise<Array<SecurityRole>> {
            return SecurityRolesApiFp(configuration).securityRolesGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns security role data by its ID
         * @summary /api/v2/SecurityRoles/{id}
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityRolesGetById(id: string, options?: any): AxiosPromise<SecurityRole> {
            return SecurityRolesApiFp(configuration).securityRolesGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds new security role
         * @summary /api/v2/SecurityRoles
         * @param {SecurityRole} securityRole 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityRolesInsert(securityRole: SecurityRole, options?: any): AxiosPromise<SecurityRole> {
            return SecurityRolesApiFp(configuration).securityRolesInsert(securityRole, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates existing security role
         * @summary /api/v2/SecurityRoles
         * @param {SecurityRole} securityRole 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityRolesUpdate(securityRole: SecurityRole, options?: any): AxiosPromise<any> {
            return SecurityRolesApiFp(configuration).securityRolesUpdate(securityRole, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SecurityRolesApi - object-oriented interface
 * @export
 * @class SecurityRolesApi
 * @extends {BaseAPI}
 */
export class SecurityRolesApi extends BaseAPI {
    /**
     * Deletes security role
     * @summary /api/v2/SecurityRoles/{id}
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityRolesApi
     */
    public securityRolesDelete(id: string, options?: any) {
        return SecurityRolesApiFp(this.configuration).securityRolesDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all Security Roles
     * @summary /api/v2/SecurityRoles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityRolesApi
     */
    public securityRolesGetAll(options?: any) {
        return SecurityRolesApiFp(this.configuration).securityRolesGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns security role data by its ID
     * @summary /api/v2/SecurityRoles/{id}
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityRolesApi
     */
    public securityRolesGetById(id: string, options?: any) {
        return SecurityRolesApiFp(this.configuration).securityRolesGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds new security role
     * @summary /api/v2/SecurityRoles
     * @param {SecurityRole} securityRole 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityRolesApi
     */
    public securityRolesInsert(securityRole: SecurityRole, options?: any) {
        return SecurityRolesApiFp(this.configuration).securityRolesInsert(securityRole, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates existing security role
     * @summary /api/v2/SecurityRoles
     * @param {SecurityRole} securityRole 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityRolesApi
     */
    public securityRolesUpdate(securityRole: SecurityRole, options?: any) {
        return SecurityRolesApiFp(this.configuration).securityRolesUpdate(securityRole, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * TimeLimitDataApi - axios parameter creator
 * @export
 */
export const TimeLimitDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns TimeLimitData for given TimeLimitTitle
         * @summary /api/v2/TimeLimitTitles/{id}/TimeLimitData
         * @param {string} id TimeLimitTitle Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeLimitDataGetByTimeLimitTitleId: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling timeLimitDataGetByTimeLimitTitleId.');
            }
            const localVarPath = `/api/v2/TimeLimitTitles/{id}/TimeLimitData`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeLimitDataApi - functional programming interface
 * @export
 */
export const TimeLimitDataApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns TimeLimitData for given TimeLimitTitle
         * @summary /api/v2/TimeLimitTitles/{id}/TimeLimitData
         * @param {string} id TimeLimitTitle Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timeLimitDataGetByTimeLimitTitleId(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimeLimitData>>> {
            const localVarAxiosArgs = await TimeLimitDataApiAxiosParamCreator(configuration).timeLimitDataGetByTimeLimitTitleId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TimeLimitDataApi - factory interface
 * @export
 */
export const TimeLimitDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns TimeLimitData for given TimeLimitTitle
         * @summary /api/v2/TimeLimitTitles/{id}/TimeLimitData
         * @param {string} id TimeLimitTitle Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeLimitDataGetByTimeLimitTitleId(id: string, options?: any): AxiosPromise<Array<TimeLimitData>> {
            return TimeLimitDataApiFp(configuration).timeLimitDataGetByTimeLimitTitleId(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimeLimitDataApi - object-oriented interface
 * @export
 * @class TimeLimitDataApi
 * @extends {BaseAPI}
 */
export class TimeLimitDataApi extends BaseAPI {
    /**
     * Returns TimeLimitData for given TimeLimitTitle
     * @summary /api/v2/TimeLimitTitles/{id}/TimeLimitData
     * @param {string} id TimeLimitTitle Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeLimitDataApi
     */
    public timeLimitDataGetByTimeLimitTitleId(id: string, options?: any) {
        return TimeLimitDataApiFp(this.configuration).timeLimitDataGetByTimeLimitTitleId(id, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * TimeLimitTitlesApi - axios parameter creator
 * @export
 */
export const TimeLimitTitlesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Checks if given TimeLimitTitle can be deleted
         * @summary /api/v2/TimeLimitTitles/{id}/CanDelete
         * @param {string} id TimeLimitTitle Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeLimitTitlesCanDelete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling timeLimitTitlesCanDelete.');
            }
            const localVarPath = `/api/v2/TimeLimitTitles/{id}/CanDelete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes Time limit title by id
         * @summary /api/v2/TimeLimitTitles/{id}
         * @param {string} id Time limit title id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeLimitTitlesDelete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling timeLimitTitlesDelete.');
            }
            const localVarPath = `/api/v2/TimeLimitTitles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all time limit titles user has access to
         * @summary /api/v2/TimeLimitTitles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeLimitTitlesGetAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeLimitTitles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets given time limit title\'s information
         * @summary /api/v2/TimeLimitTitles/{id}
         * @param {string} id Time limit title id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeLimitTitlesGetById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling timeLimitTitlesGetById.');
            }
            const localVarPath = `/api/v2/TimeLimitTitles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds new Time limit title and data
         * @summary /api/v2/TimeLimitTitles
         * @param {InsertTimeLimitTitlesParam} insertTimeLimitTitlesParam Time limit title and data to insert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeLimitTitlesInsert: async (insertTimeLimitTitlesParam: InsertTimeLimitTitlesParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'insertTimeLimitTitlesParam' is not null or undefined
            if (insertTimeLimitTitlesParam === null || insertTimeLimitTitlesParam === undefined) {
                throw new RequiredError('insertTimeLimitTitlesParam','Required parameter insertTimeLimitTitlesParam was null or undefined when calling timeLimitTitlesInsert.');
            }
            const localVarPath = `/api/v2/TimeLimitTitles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof insertTimeLimitTitlesParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(insertTimeLimitTitlesParam !== undefined ? insertTimeLimitTitlesParam : {}) : (insertTimeLimitTitlesParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates existing Time limit title and its data.
         * @summary /api/v2/TimeLimitTitles
         * @param {UpdateTimeLimitTitlesParam} updateTimeLimitTitlesParam Time limit title to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeLimitTitlesUpdate: async (updateTimeLimitTitlesParam: UpdateTimeLimitTitlesParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateTimeLimitTitlesParam' is not null or undefined
            if (updateTimeLimitTitlesParam === null || updateTimeLimitTitlesParam === undefined) {
                throw new RequiredError('updateTimeLimitTitlesParam','Required parameter updateTimeLimitTitlesParam was null or undefined when calling timeLimitTitlesUpdate.');
            }
            const localVarPath = `/api/v2/TimeLimitTitles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateTimeLimitTitlesParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateTimeLimitTitlesParam !== undefined ? updateTimeLimitTitlesParam : {}) : (updateTimeLimitTitlesParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeLimitTitlesApi - functional programming interface
 * @export
 */
export const TimeLimitTitlesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Checks if given TimeLimitTitle can be deleted
         * @summary /api/v2/TimeLimitTitles/{id}/CanDelete
         * @param {string} id TimeLimitTitle Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timeLimitTitlesCanDelete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CanDeleteTimeLimitTitleResult>> {
            const localVarAxiosArgs = await TimeLimitTitlesApiAxiosParamCreator(configuration).timeLimitTitlesCanDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deletes Time limit title by id
         * @summary /api/v2/TimeLimitTitles/{id}
         * @param {string} id Time limit title id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timeLimitTitlesDelete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await TimeLimitTitlesApiAxiosParamCreator(configuration).timeLimitTitlesDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns all time limit titles user has access to
         * @summary /api/v2/TimeLimitTitles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timeLimitTitlesGetAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimeLimitTitle>>> {
            const localVarAxiosArgs = await TimeLimitTitlesApiAxiosParamCreator(configuration).timeLimitTitlesGetAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets given time limit title\'s information
         * @summary /api/v2/TimeLimitTitles/{id}
         * @param {string} id Time limit title id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timeLimitTitlesGetById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeLimitTitle>> {
            const localVarAxiosArgs = await TimeLimitTitlesApiAxiosParamCreator(configuration).timeLimitTitlesGetById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Adds new Time limit title and data
         * @summary /api/v2/TimeLimitTitles
         * @param {InsertTimeLimitTitlesParam} insertTimeLimitTitlesParam Time limit title and data to insert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timeLimitTitlesInsert(insertTimeLimitTitlesParam: InsertTimeLimitTitlesParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await TimeLimitTitlesApiAxiosParamCreator(configuration).timeLimitTitlesInsert(insertTimeLimitTitlesParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates existing Time limit title and its data.
         * @summary /api/v2/TimeLimitTitles
         * @param {UpdateTimeLimitTitlesParam} updateTimeLimitTitlesParam Time limit title to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timeLimitTitlesUpdate(updateTimeLimitTitlesParam: UpdateTimeLimitTitlesParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await TimeLimitTitlesApiAxiosParamCreator(configuration).timeLimitTitlesUpdate(updateTimeLimitTitlesParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TimeLimitTitlesApi - factory interface
 * @export
 */
export const TimeLimitTitlesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Checks if given TimeLimitTitle can be deleted
         * @summary /api/v2/TimeLimitTitles/{id}/CanDelete
         * @param {string} id TimeLimitTitle Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeLimitTitlesCanDelete(id: string, options?: any): AxiosPromise<CanDeleteTimeLimitTitleResult> {
            return TimeLimitTitlesApiFp(configuration).timeLimitTitlesCanDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes Time limit title by id
         * @summary /api/v2/TimeLimitTitles/{id}
         * @param {string} id Time limit title id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeLimitTitlesDelete(id: string, options?: any): AxiosPromise<any> {
            return TimeLimitTitlesApiFp(configuration).timeLimitTitlesDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all time limit titles user has access to
         * @summary /api/v2/TimeLimitTitles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeLimitTitlesGetAll(options?: any): AxiosPromise<Array<TimeLimitTitle>> {
            return TimeLimitTitlesApiFp(configuration).timeLimitTitlesGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets given time limit title\'s information
         * @summary /api/v2/TimeLimitTitles/{id}
         * @param {string} id Time limit title id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeLimitTitlesGetById(id: string, options?: any): AxiosPromise<TimeLimitTitle> {
            return TimeLimitTitlesApiFp(configuration).timeLimitTitlesGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds new Time limit title and data
         * @summary /api/v2/TimeLimitTitles
         * @param {InsertTimeLimitTitlesParam} insertTimeLimitTitlesParam Time limit title and data to insert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeLimitTitlesInsert(insertTimeLimitTitlesParam: InsertTimeLimitTitlesParam, options?: any): AxiosPromise<any> {
            return TimeLimitTitlesApiFp(configuration).timeLimitTitlesInsert(insertTimeLimitTitlesParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates existing Time limit title and its data.
         * @summary /api/v2/TimeLimitTitles
         * @param {UpdateTimeLimitTitlesParam} updateTimeLimitTitlesParam Time limit title to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeLimitTitlesUpdate(updateTimeLimitTitlesParam: UpdateTimeLimitTitlesParam, options?: any): AxiosPromise<any> {
            return TimeLimitTitlesApiFp(configuration).timeLimitTitlesUpdate(updateTimeLimitTitlesParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimeLimitTitlesApi - object-oriented interface
 * @export
 * @class TimeLimitTitlesApi
 * @extends {BaseAPI}
 */
export class TimeLimitTitlesApi extends BaseAPI {
    /**
     * Checks if given TimeLimitTitle can be deleted
     * @summary /api/v2/TimeLimitTitles/{id}/CanDelete
     * @param {string} id TimeLimitTitle Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeLimitTitlesApi
     */
    public timeLimitTitlesCanDelete(id: string, options?: any) {
        return TimeLimitTitlesApiFp(this.configuration).timeLimitTitlesCanDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes Time limit title by id
     * @summary /api/v2/TimeLimitTitles/{id}
     * @param {string} id Time limit title id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeLimitTitlesApi
     */
    public timeLimitTitlesDelete(id: string, options?: any) {
        return TimeLimitTitlesApiFp(this.configuration).timeLimitTitlesDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all time limit titles user has access to
     * @summary /api/v2/TimeLimitTitles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeLimitTitlesApi
     */
    public timeLimitTitlesGetAll(options?: any) {
        return TimeLimitTitlesApiFp(this.configuration).timeLimitTitlesGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets given time limit title\'s information
     * @summary /api/v2/TimeLimitTitles/{id}
     * @param {string} id Time limit title id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeLimitTitlesApi
     */
    public timeLimitTitlesGetById(id: string, options?: any) {
        return TimeLimitTitlesApiFp(this.configuration).timeLimitTitlesGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds new Time limit title and data
     * @summary /api/v2/TimeLimitTitles
     * @param {InsertTimeLimitTitlesParam} insertTimeLimitTitlesParam Time limit title and data to insert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeLimitTitlesApi
     */
    public timeLimitTitlesInsert(insertTimeLimitTitlesParam: InsertTimeLimitTitlesParam, options?: any) {
        return TimeLimitTitlesApiFp(this.configuration).timeLimitTitlesInsert(insertTimeLimitTitlesParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates existing Time limit title and its data.
     * @summary /api/v2/TimeLimitTitles
     * @param {UpdateTimeLimitTitlesParam} updateTimeLimitTitlesParam Time limit title to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeLimitTitlesApi
     */
    public timeLimitTitlesUpdate(updateTimeLimitTitlesParam: UpdateTimeLimitTitlesParam, options?: any) {
        return TimeLimitTitlesApiFp(this.configuration).timeLimitTitlesUpdate(updateTimeLimitTitlesParam, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * UrlApi - axios parameter creator
 * @export
 */
export const UrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns url for public API endpoint
         * @summary /api/v2/Url/GetUrl
         * @param {PublicApiGetUrlParam} publicApiGetUrlParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlGetUrl: async (publicApiGetUrlParam: PublicApiGetUrlParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicApiGetUrlParam' is not null or undefined
            if (publicApiGetUrlParam === null || publicApiGetUrlParam === undefined) {
                throw new RequiredError('publicApiGetUrlParam','Required parameter publicApiGetUrlParam was null or undefined when calling urlGetUrl.');
            }
            const localVarPath = `/api/v2/Url/GetUrl`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof publicApiGetUrlParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(publicApiGetUrlParam !== undefined ? publicApiGetUrlParam : {}) : (publicApiGetUrlParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UrlApi - functional programming interface
 * @export
 */
export const UrlApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns url for public API endpoint
         * @summary /api/v2/Url/GetUrl
         * @param {PublicApiGetUrlParam} publicApiGetUrlParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async urlGetUrl(publicApiGetUrlParam: PublicApiGetUrlParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await UrlApiAxiosParamCreator(configuration).urlGetUrl(publicApiGetUrlParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UrlApi - factory interface
 * @export
 */
export const UrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns url for public API endpoint
         * @summary /api/v2/Url/GetUrl
         * @param {PublicApiGetUrlParam} publicApiGetUrlParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        urlGetUrl(publicApiGetUrlParam: PublicApiGetUrlParam, options?: any): AxiosPromise<string> {
            return UrlApiFp(configuration).urlGetUrl(publicApiGetUrlParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UrlApi - object-oriented interface
 * @export
 * @class UrlApi
 * @extends {BaseAPI}
 */
export class UrlApi extends BaseAPI {
    /**
     * Returns url for public API endpoint
     * @summary /api/v2/Url/GetUrl
     * @param {PublicApiGetUrlParam} publicApiGetUrlParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrlApi
     */
    public urlGetUrl(publicApiGetUrlParam: PublicApiGetUrlParam, options?: any) {
        return UrlApiFp(this.configuration).urlGetUrl(publicApiGetUrlParam, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ZonesApi - axios parameter creator
 * @export
 */
export const ZonesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets all zones in locking system.
         * @summary /api/v2/Zones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesGetAllZones: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Zones`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZonesApi - functional programming interface
 * @export
 */
export const ZonesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Gets all zones in locking system.
         * @summary /api/v2/Zones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zonesGetAllZones(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Zone>>> {
            const localVarAxiosArgs = await ZonesApiAxiosParamCreator(configuration).zonesGetAllZones(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ZonesApi - factory interface
 * @export
 */
export const ZonesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Gets all zones in locking system.
         * @summary /api/v2/Zones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesGetAllZones(options?: any): AxiosPromise<Array<Zone>> {
            return ZonesApiFp(configuration).zonesGetAllZones(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZonesApi - object-oriented interface
 * @export
 * @class ZonesApi
 * @extends {BaseAPI}
 */
export class ZonesApi extends BaseAPI {
    /**
     * Gets all zones in locking system.
     * @summary /api/v2/Zones
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    public zonesGetAllZones(options?: any) {
        return ZonesApiFp(this.configuration).zonesGetAllZones(options).then((request) => request(this.axios, this.basePath));
    }

}


